export const arPtBr = {
  collectionSettings: {
    title: 'Configurações de Cobrança',
    subtitle: 'Comportamento de recebimento aprendido por cliente',
    cardTitle: 'Comportamento de recebimento',
    lookbackInvoices: 'Faturas liquidadas consideradas',
    lookbackInvoicesHint:
      'Quantas faturas liquidadas mais recentes alimentam a estimativa de comportamento de recebimento (por cliente, grupo de faturamento ou tenant). Entre 1 e 24.',
    lookbackInvoicesInvalid: 'Informe um número inteiro entre 1 e 24.',
    save: 'Salvar',
    saving: 'Salvando...',
    discard: 'Descartar',
    lastUpdated: 'Última atualização em {{date}} por {{user}}',
    noChangesRecorded: 'Nenhuma alteração registrada',
    loadError: 'Erro ao carregar configurações',
    saveSuccess: 'Configurações salvas',
    saveError: 'Erro ao salvar configurações',
  },
  invoiceApprovalSettings: {
    cardTitle: 'Aprovação de faturas',
    cardDescription: 'Regras para aprovar faturas sem uma pessoa clicar em aprovar.',
    autoApproveTitle: 'Auto aprovar faturas emitidas fora da Alchemy',
    autoApproveDescription:
      'Quando uma fatura é criada e todos os serviços dela têm a nota fiscal emitida fora da Alchemy, o sistema aprova a fatura e lança a receita na contabilidade. Se a aprovação falhar, a fatura fica em rascunho e o motivo aparece no histórico dela.',
    noPermission: 'Só quem pode aprovar faturas pode mudar esta opção.',
    save: 'Salvar',
    saving: 'Salvando...',
    discard: 'Descartar',
    lastUpdated: 'Última alteração em {{date}}',
    noChangesRecorded: 'Nenhuma alteração registrada',
    loadErrorTitle: 'Não foi possível carregar a configuração',
    loadErrorDescription: 'Tente de novo em alguns instantes.',
    saveSuccess: 'Configuração salva',
    saveError: 'Não foi possível salvar a configuração. Tente de novo.',
    confirmLeave: {
      title: 'Descartar alterações?',
      description: 'Há alterações não salvas. Se sair agora, elas serão perdidas.',
      confirm: 'Sair sem salvar',
      stay: 'Continuar editando',
    },
  },
  arForecastSettings: {
    title: 'Previsão AR — uso variável',
    subtitle: 'Janela de histórico para projetar quantidades de itens variáveis',
    cardTitle: 'Projeção de uso',
    lookbackPeriods: 'Períodos de uso considerados',
    lookbackPeriodsHint:
      'Quantos períodos de serviço FINALIZADOS mais recentes alimentam a média aritmética da quantidade projetada (itens variáveis). Entre 1 e 24; padrão 3.',
    lookbackPeriodsInvalid: 'Informe um número inteiro entre 1 e 24.',
    save: 'Salvar',
    saving: 'Salvando...',
    discard: 'Descartar',
    lastUpdated: 'Última atualização em {{date}} por {{user}}',
    noChangesRecorded: 'Nenhuma alteração registrada',
    loadError: 'Erro ao carregar configurações',
    saveSuccess: 'Configurações salvas',
    saveError: 'Erro ao salvar configurações',
    systemUser: 'Sistema',
  },
  expectedCash: {
    label: 'Previsão de caixa',
    expectedOn: 'Previsto para {{date}}',
    lowConfidence: 'Confiança baixa',
    highConfidence: 'Confiança alta',
    sourceCustomer: 'Histórico do cliente',
    sourceBillingGroup: 'Histórico do grupo de faturamento',
    sourceTenant: 'Histórico do tenant (mesma entidade)',
    sourceNone: 'Sem histórico — data de vencimento',
    sampleSize: '{{count}} faturas liquidadas na amostra',
    installments: 'Parcelas',
    installment: 'Parcela',
    dueDate: 'Vencimento',
    amount: 'Valor',
    paid: 'Pago',
    estimatedHint: 'Data estimada a partir do comportamento de recebimento',
  },
  receipts: {
    title: 'Recebimentos',
    subtitle: 'Gerencie os recebimentos de clientes',
    table: {
      receipt: 'Recibo',
      customer: 'Cliente',
      method: 'Método',
      amount: 'Valor',
      allocation: 'Alocação',
      status: 'Status',
      noResults: 'Nenhum recibo encontrado.',
      loading: 'Carregando recebimentos...',
    },
    filters: {
      title: 'Filtros',
      search: 'Busca',
      searchPlaceholder: 'Cliente, número, referência...',
      status: 'Status',
      paymentMethod: 'Método de Pagamento',
      clearAll: 'Limpar todos',
      activeFilters: 'Filtros ativos:',
      all: 'Todos',
    },
    types: {
      standard: 'Padrão',
      transaction: 'Transação',
      gtvTransaction: 'Transação GTV',
      aggregate: 'Agregadora',
    },
    statuses: {
      draft: 'Rascunho',
      posted: 'Lançado',
      partiallyAllocated: 'Parcial',
      fullyAllocated: 'Alocado',
      void: 'Anulado',
    },
    paymentMethods: {
      pix: 'PIX',
      ted: 'TED',
      boleto: 'Boleto',
      card: 'Cartão',
    },
    stats: {
      totalReceived: 'Total Recebido',
      allocated: 'Alocado',
      pending: 'Pendente',
      reconciled: 'Conciliados',
      receipts: 'recibos',
    },
    empty: {
      title: 'Nenhum recebimento encontrado',
      description: 'Não há recebimentos que correspondam aos filtros selecionados.',
    },
    selection: {
      selected: '{{count}} recibo selecionado',
      selectedPlural: '{{count}} recibos selecionados',
      export: 'Exportar',
      allocateToInvoices: 'Alocar a faturas',
    },
    details: {
      reviewReconciliation: 'Revisar conciliação',
      reviewReconciliationHint:
        'Desfaz a conciliação bancária, suas alocações e lançamentos vinculados. Não registra uma devolução bancária.',
    },
    pagination: {
      showing: 'Mostrando {{start}}–{{end}} de {{total}}',
      noResults: 'Nenhum resultado',
      pageSize: 'Tamanho da página:',
      page: 'Página {{current}} de {{total}}',
      previous: 'Anterior',
      next: 'Próxima',
    },
  },
  debitNotes: {
    title: 'Notas de débito',
    subtitle: 'Gere cobranças de despesas reembolsáveis por cliente',
    loading: 'Carregando...',
    featureDisabled:
      'Despesas reembolsáveis pelo cliente não estão habilitadas para este tenant. Ative em Configurações globais de aprovação.',
    tabs: {
      notes: 'Notas',
      customers: 'Por cliente',
    },
    eligible: {
      title: 'Despesas elegíveis',
      create: 'Gerar nota de débito',
      empty: 'Nenhuma despesa reembolsável em aberto.',
    },
    customers: {
      title: 'Clientes com despesas reembolsáveis',
      empty: 'Nenhum cliente possui despesas reembolsáveis em aberto.',
      openCustomer: 'Abrir detalhes do cliente',
    },
    customerDetail: {
      title: 'Detalhe do cliente',
      selectCustomer: 'Selecione um cliente para ver as despesas reembolsáveis.',
      empty: 'Nenhuma despesa encontrada para este cliente.',
      emptyFiltered: 'Nenhuma despesa neste status.',
      summary:
        '{{count}} contas · futuro {{future}} · pendente {{pending}} · reembolsado {{reimbursed}}',
      summaryExtended:
        '{{count}} contas · futuro {{future}} · pronto {{ready}} · pendente {{pending}} · reembolsado {{reimbursed}}',
      modalTitle: 'Despesas reembolsáveis do cliente',
      modalTitleWithCustomer: 'Despesas Reembolsáveis · {{customerName}}',
      modalDescription: 'Selecione as despesas prontas para gerar uma Nota de Débito.',
      tabs: {
        all: 'Todas',
        ready: 'Prontas',
        future: 'Futuras',
        pending: 'Em nota',
        reimbursed: 'Reembolsadas',
      },
      stats: {
        ready: 'Pronto p/ nota',
        future: 'Futuro',
        pending: 'Em nota / pendente',
        reimbursed: 'Reembolsado',
        expenseCountOne: '{{count}} despesa',
        expenseCountOther: '{{count}} despesas',
        noteCountOne: '{{count}} nota',
        noteCountOther: '{{count}} notas',
      },
      selection: {
        none: 'Nenhuma despesa selecionada',
        selectedOne: '{{count}} despesa selecionada · {{amount}}',
        selectedOther: '{{count}} despesas selecionadas · {{amount}}',
        selectedShort: 'selecionadas',
        selectAllReady: 'Selecionar todas prontas',
        toggleVisibleReady: 'Selecionar despesas prontas visíveis',
        toggleBill: 'Selecionar despesa',
      },
      metadata: {
        billRef: 'Conta {{id}}',
        debitNoteRef: 'Nota {{number}}',
        downloadDebitNote: 'Baixar nota {{number}}',
        category: 'Categoria',
        booleanTrue: 'Sim',
        booleanFalse: 'Não',
      },
      issueReview: {
        title: 'Revisar nota de débito',
        description: 'Confira as despesas selecionadas e informe o vencimento antes de emitir.',
        stepSelect: 'Selecionar despesas',
        stepReview: 'Revisar & emitir',
        dueDateLabel: 'Vencimento',
        dueDateHintOne: 'Vence em 1 dia',
        dueDateHintOther: 'Vence em {{count}} dias',
        totalLabel: 'Total a ser reembolsado via nota de débito',
        entityLabel: 'Entidade emitente',
        bankAccountLabel: 'Conta bancária de recebimento',
        bankAccountPlaceholder: 'Selecione a conta bancária',
        bankAccountEmpty: 'Nenhuma conta bancária ativa para esta entidade.',
        expensesTitle: 'Despesas incluídas',
        proofColumn: 'Comprovante',
        hasProof: 'Com comprovante',
        noProof: 'Sem comprovante',
        attachOriginalDocuments: 'Anexar documentos originais',
        attachOriginalDocumentsDescriptionOne:
          'Inclui 1 comprovante das despesas no pacote de download da nota.',
        attachOriginalDocumentsDescriptionOther:
          'Inclui {{count}} comprovantes das despesas no pacote de download da nota.',
        attachOriginalDocumentsCountOne: '1 anexo',
        attachOriginalDocumentsCountOther: '{{count}} anexos',
        back: 'Voltar',
        confirm: 'Emitir nota',
      },
    },
    buckets: {
      ready: 'Prontas para reembolso (conciliação realizada)',
      awaiting: 'Aguardando confirmação de pagamento',
      billed: 'Notas de débito geradas / pendentes',
      reimbursed: 'Reembolsadas',
      empty: 'Nenhuma conta nesta etapa.',
    },
    billStatus: {
      AWAITING_PAYMENT: 'Aguardando pagamento',
      READY_FOR_REIMBURSEMENT: 'Pronto para reembolso',
      BILLED: 'Pendente de reembolso',
      REIMBURSED: 'Reembolsado',
    },
    list: {
      title: 'Notas emitidas',
      empty: 'Nenhuma nota de débito encontrada.',
    },
    dueDateDialog: {
      title: 'Data de vencimento da nota',
    },
    detail: {
      title: 'Nota de débito',
      description: 'Dados da nota emitida para reembolso do cliente.',
      back: 'Voltar',
      summary: 'Resumo',
      totalLabel: 'Total da nota de débito',
      allocated: 'Alocado',
      lines: 'Despesas vinculadas',
      noLines: 'Nenhuma despesa vinculada.',
      allocations: 'Recebimentos',
      noAllocations: 'Nenhum recebimento alocado.',
      receipt: 'Recebimento',
      date: 'Data',
      payment: 'Pagamento',
      paymentDate: 'Data de pagamento',
      openBill: 'Abrir conta',
      expenseCountOne: '{{count}} despesa',
      expenseCountOther: '{{count}} despesas',
      footerSummary: '{{countLabel}} · {{amount}}',
    },
    filters: {
      competencyRange: 'Competência',
      competencyRangePlaceholder: 'Selecione a competência',
      competencyFrom: 'Competência de',
      competencyTo: 'Competência até',
      numberPlaceholder: 'Número da nota',
      amount: 'Valor',
      amountPlaceholder: 'Valor',
      amountMin: 'Valor mínimo',
      amountMax: 'Valor máximo',
      amountOperators: {
        eqSymbol: '=',
        gteSymbol: '≥',
        lteSymbol: '≤',
      },
      status: 'Status da nota',
      billStatus: 'Status da conta',
      createdRangePlaceholder: 'Selecione a criação',
      dueRange: 'Vencimento',
      dueRangePlaceholder: 'Selecione o vencimento',
      dueFrom: 'Vencimento de',
      dueTo: 'Vencimento até',
      customerPlaceholder: 'Cliente ou CNPJ',
      billsPlaceholder: 'Contas',
      all: 'Todos',
      clear: 'Limpar filtros',
      apply: 'Aplicar',
      filterColumn: 'Filtrar coluna',
      filterAmount: 'Filtrar valor',
      active: 'Filtros ativos:',
      clearAll: 'Limpar todos',
      datePlaceholder: 'Qualquer data',
    },
    table: {
      description: 'Descrição',
      vendor: 'Fornecedor',
      customer: 'Cliente',
      bills: 'Contas',
      bill: 'Conta',
      future: 'Futuro',
      ready: 'Pronto para reembolso',
      pending: 'Pendente de reembolso',
      reimbursed: 'Reembolsado',
      amount: 'Valor',
      number: 'Número',
      status: 'Status',
      date: 'Data',
      createdAt: 'Criada em',
      dueDate: 'Vencimento',
      actions: 'Ações',
    },
    tableTooltips: {
      amount: 'Valor total da nota de débito emitida para o cliente.',
      future:
        'Despesas reembolsáveis que ainda não estão prontas para cobrança, normalmente porque aguardam pagamento ou confirmação.',
      ready:
        'Despesas já aptas para gerar nota de débito, com pagamento/condição de reembolso confirmados.',
      pending: 'Despesas já incluídas em uma nota de débito e ainda pendentes de reembolso.',
      reimbursed: 'Despesas que já foram reembolsadas pelo cliente.',
    },
    actions: {
      issue: 'Emitir',
      void: 'Anular',
      cancel: 'Cancelar nota',
      close: 'Fechar',
      download: 'Baixar PDF',
      downloadWithDocuments: 'Baixar PDF + docs',
      openCustomer: 'Ver cliente',
      removeLine: 'Remover despesa da nota',
      delete: 'Excluir',
      deleting: 'Excluindo...',
      clearingUploadedFiscalNote: 'Limpando NF...',
    },
    dialogs: {
      cancel: 'Cancelar',
      deleteTitle: 'Excluir nota de débito?',
      deleteDescription:
        'A nota {{number}} será anulada e as contas vinculadas voltarão a ficar elegíveis para reembolso. Esta ação não pode ser desfeita.',
      deleteConfirm: 'Excluir nota',
      deleteUnavailable: 'Notas recebidas, anuladas ou com alocação não podem ser excluídas.',
    },
    voidDialog: {
      title: 'Cancelar nota de débito?',
      description:
        'A nota será anulada e as despesas vinculadas voltarão para a fila de reembolso. Esta ação não pode ser desfeita.',
      writeOffLabel: 'Baixar as despesas como perda (não serão reembolsadas)',
      writeOffHint:
        'Um lançamento de perda será registrado na contabilidade e as despesas não ficarão elegíveis para uma nova nota de débito.',
      confirm: 'Cancelar nota',
    },
    status: {
      DRAFT: 'Rascunho',
      ISSUED: 'Emitida',
      PARTIALLY_RECEIVED: 'Parcial',
      RECEIVED: 'Recebida',
      VOID: 'Anulada',
    },
    toast: {
      created: 'Nota de débito criada com sucesso.',
      createError: 'Erro ao criar nota de débito.',
      issued: 'Nota de débito emitida.',
      issueError: 'Erro ao emitir nota de débito.',
      voided: 'Nota de débito anulada.',
      voidError: 'Erro ao anular nota de débito.',
      deleted: 'Nota de débito excluída.',
      deleteError: 'Erro ao excluir nota de débito.',
      lineRemoved: 'Conta removida da nota de débito.',
      lineRemoveError: 'Erro ao remover conta da nota.',
      downloadError: 'Erro ao baixar PDF da nota.',
      downloadDocumentsError: 'Erro ao baixar PDF da nota com documentos.',
    },
  },
  customers: {
    title: 'Clientes',
    subtitle: 'Gerencie seus clientes',
    table: {
      name: 'Nome',
      code: 'Código',
      email: 'E-mail',
      taxId: 'CNPJ/CPF',
      status: 'Status',
      noResults: 'Nenhum cliente encontrado.',
      loading: 'Carregando clientes...',
    },
    statuses: {
      active: 'Ativo',
      inactive: 'Inativo',
      blocked: 'Bloqueado',
    },
    stats: {
      total: 'Total',
      active: 'Ativos',
      blocked: 'Bloqueados',
      withTaxId: 'Com CNPJ/CPF',
    },
    filters: {
      title: 'Filtros',
      search: 'Busca',
      searchPlaceholder: 'Nome, código, e-mail...',
      status: 'Status',
      clearAll: 'Limpar todos',
      activeFilters: 'Filtros ativos:',
      all: 'Todos',
    },
    empty: {
      title: 'Nenhum cliente encontrado',
      description: 'Não há clientes que correspondam aos filtros selecionados.',
    },
    listing: {
      columns: {
        name: 'Cliente',
        code: 'Código',
        email: 'E-mail',
        // Country-neutral: the customer's tax id may be a CNPJ, a CPF or a Mexican RFC.
        taxId: 'Documento fiscal',
        status: 'Status',
      },
      statusBadge: {
        ACTIVE: 'Ativo',
        BLOCKED: 'Inativo',
      },
      noEntity: 'Sem entidade',
      create: 'Novo Cliente',
      exportSelected: 'Exportar selecionados',
      nounOne: 'cliente',
      nounOther: 'clientes',
    },
    actions: {
      cancel: 'Cancelar',
      create: 'Criar cliente',
      saveChanges: 'Salvar alterações',
      edit: 'Editar',
      backToList: 'Voltar para clientes',
    },
    form: {
      titleNew: 'Novo cliente',
      titleEdit: 'Editar cliente',
      subtitle: 'Cadastro e configurações do cliente',
      tabs: {
        identity: 'Identificação',
        contact: 'Contato',
        emails: 'E-mails',
        contracts: 'Contratos',
        group: 'Grupo',
        balance: 'Saldo',
        customerBalance: 'Créditos e débitos',
        address: 'Endereço',
        reimbursableExpenses: 'Despesas reembolsáveis',
      },
      emailRoles: {
        FINANCIAL: 'Financeiro',
        GENERAL: 'Geral',
        ACCOUNTING: 'Contábil',
        NFE_RECIPIENT: 'Destinatário NF-e',
      },
      emails: {
        add: 'Adicionar',
        addPlaceholder: 'E-mail',
        remove: 'Remover',
        tableEmail: 'E-mail',
        tableRole: 'Função',
        empty: 'Nenhum e-mail cadastrado.',
      },
      validation: {
        entityRequired: 'Selecione a entidade',
        customerTypeRequired: 'Selecione o tipo de documento',
        taxIdRequired: 'Informe o documento fiscal',
        taxIdInvalid: 'Documento inválido',
        countryCodeRequired: 'Informe o país de residência ou constituição',
        cepLookupError: 'Não foi possível consultar o CEP. Verifique o número e tente novamente.',
        codeRequired: 'Informe o código',
        legalNameRequired: 'Informe a razão social ou nome',
        tradeNameRequired: 'Informe o nome fantasia',
        phoneRequired: 'Informe o telefone',
      },
      saveBeforeEditingHint: 'Salve o cliente antes de editar outras informações',
      sections: {
        identity: {
          title: 'Identificação',
          description: 'Informações legais e fiscais',
        },
        contact: {
          title: 'Contato',
          description: 'Canais de comunicação',
        },
        emails: {
          title: 'E-mails',
          description: 'E-mails cadastrados e funções',
        },
        address: {
          title: 'Endereço',
          description: 'Endereço principal do cliente',
        },
        billing: {
          title: 'Configurações de cobrança',
          description: 'Parâmetros financeiros e preferências',
        },
        status: {
          title: 'Status do cliente',
          description: 'Bloqueio e motivos',
        },
        crm: {
          title: 'Integrações CRM',
          description: 'IDs de sistemas externos',
        },
        fiscal: {
          title: 'Informações fiscais (RF)',
          description: 'Dados públicos da Receita Federal',
          emptyHint:
            'Informe um CNPJ e clique em Buscar na RF para preencher os dados fiscais automaticamente',
        },
      },
      fields: {
        entity: {
          label: 'Entidade',
          placeholder: 'Selecione a entidade',
        },
        country: {
          label: 'País',
          placeholder: 'Selecione o país',
        },
        taxRegimeCode: {
          label: 'Regime fiscal (SAT)',
          placeholder: '601',
          hint: 'c_RegimenFiscal do cliente como receptor de CFDI. Ex.: 601 pessoa moral, 612 pessoa física, 616 sem obrigações.',
        },
        paymentFormCode: {
          label: 'Tipo de pagamento (SAT)',
          hint: 'c_FormaPago que o CFDI do cliente declara. Sem valor, o CFDI declara 03. Um CFDI PPD sempre declara 99; 99 é recusado em CFDI PUE.',
          placeholder: 'Selecione a forma de pagamento',
          none: 'Não informado (03)',
          options: {
            '01': 'Dinheiro',
            '02': 'Cheque nominativo',
            '03': 'Transferência eletrônica de fundos',
            '04': 'Cartão de crédito',
            '05': 'Carteira eletrônica',
            '06': 'Dinheiro eletrônico',
            '08': 'Vales-alimentação',
            '12': 'Dação em pagamento',
            '13': 'Pagamento por sub-rogação',
            '14': 'Pagamento por consignação',
            '15': 'Remissão (condonação)',
            '17': 'Compensação',
            '23': 'Novação',
            '24': 'Confusão',
            '25': 'Remissão de dívida',
            '26': 'Prescrição ou caducidade',
            '27': 'A satisfação do credor',
            '28': 'Cartão de débito',
            '29': 'Cartão de serviços',
            '30': 'Aplicação de adiantamentos',
            '31': 'Intermediário de pagamentos',
            '99': 'A definir',
          },
        },
        code: {
          label: 'Código',
          placeholder: 'CLI-001',
          hint: 'Deixe vazio para gerar automaticamente',
        },
        partyType: {
          label: 'Tipo de pessoa',
          placeholder: 'Selecione o tipo',
          options: {
            organization: 'Pessoa jurídica',
            individual: 'Pessoa física',
          },
        },
        legalName: {
          label: 'Razão social / Nome',
          placeholder: 'Informe o nome legal',
        },
        tradeName: {
          label: 'Nome fantasia',
          placeholder: 'Opcional',
        },
        taxIdType: {
          label: 'Tipo de documento',
          placeholder: 'Selecione o tipo',
          options: {
            cnpj: 'CNPJ',
            cpf: 'CPF',
            other: 'Outro',
          },
        },
        customerType: {
          label: 'Tipo de documento',
          placeholder: 'Selecione o tipo',
          options: {
            cnpj: 'CNPJ',
            cpf: 'CPF',
            rfc: 'RFC (México)',
            ein: 'EIN (Estados Unidos)',
            international: 'Estrangeiro',
          },
        },
        taxIdValue: {
          label: 'Documento',
          hint: 'Digite o documento conforme o tipo selecionado',
          placeholder: '00.000.000/0000-00',
          einPlaceholder: '12-3456789',
          internationalPlaceholder: 'EIN, RFC ou outro identificador fiscal',
        },
        email: {
          label: 'E-mail principal',
          placeholder: 'financeiro@cliente.com',
        },
        phoneNumber: {
          label: 'Telefone',
          placeholder: 'Ex.: +1 212 555 0100',
        },
        addressLine1: {
          label: 'Logradouro',
          placeholder: 'Rua, avenida, número',
        },
        addressNumber: {
          label: 'Número',
          placeholder: 'Ex.: 123 ou S/N',
        },
        addressLine2: {
          label: 'Complemento',
          placeholder: 'Sala, bloco, bairro',
        },
        addressCity: {
          label: 'Cidade',
          placeholder: 'São Paulo',
        },
        addressState: {
          label: 'Estado',
          placeholder: 'SP',
        },
        addressPostalCode: {
          label: 'CEP',
          placeholder: '00000-000',
        },
        addressCountryCode: {
          label: 'País',
          placeholder: 'BR',
        },
        billingGroupId: {
          label: 'Grupo de cobrança',
          placeholder: 'Selecione o grupo',
          none: 'Sem grupo',
        },
        creditLimit: {
          label: 'Limite de crédito',
          placeholder: '1000.00',
        },
        paymentTerms: {
          label: 'Condições de pagamento',
          placeholder: 'Ex: 30 dias',
        },
        boletoInstructions: {
          label: 'Instruções de boleto',
          placeholder: 'Instruções adicionais',
        },
        communicationChannels: {
          label: 'Canais de comunicação',
          placeholder: 'email, whatsapp',
        },
        autoCollectionEnabled: {
          label: 'Cobrança automática',
        },
        negativacaoEnabled: {
          label: 'Negativação',
        },
        negativacaoDays: {
          label: 'Dias para negativação',
          placeholder: '30',
        },
        glOffsetAccountId: {
          label: 'Conta contábil (GL)',
          placeholder: 'Selecione a conta',
        },
        billingNotes: {
          label: 'Notas de cobrança',
          hint: 'Observações internas',
          placeholder: 'Informações adicionais...',
        },
        isBlocked: {
          label: 'Cliente bloqueado',
        },
        blockReason: {
          label: 'Motivo do bloqueio',
          placeholder: 'Descreva o motivo',
        },
        hubspotContactId: {
          label: 'ID HubSpot',
          placeholder: 'Opcional',
        },
        intercomContactId: {
          label: 'ID Intercom',
          placeholder: 'Opcional',
        },
        fiscal: {
          regimeTributario: 'Regime tributário',
          porte: 'Porte',
          situacaoCadastral: 'Situação cadastral',
          naturezaJuridica: 'Natureza jurídica',
          cnaePrincipal: 'CNAE principal',
          dataAbertura: 'Data de abertura',
        },
      },
      taxIdChange: {
        title: 'Alterar o documento',
        description:
          'O documento mudou de {{from}} para {{to}}. Isso é uma correção do mesmo cadastro ou se trata de outra empresa ou pessoa?',
        correct: {
          label: 'Corrigir o documento',
          description:
            'É a mesma empresa ou pessoa e o documento estava errado. O cadastro e todo o histórico continuam, agora com o documento novo.',
        },
        otherParty: {
          label: 'É outra empresa/pessoa',
          description:
            'O cliente passa a ser outro cadastro. O cadastro atual mantém o documento antigo e o histórico dele.',
        },
        sharedNote:
          'Este cadastro também é usado em outros registros (fornecedor, funcionário ou cliente de outra entidade). Corrigir o documento altera o documento deles também.',
        // Primeiro documento de um cliente que ainda não tem nenhum, num cadastro compartilhado.
        added: {
          title: 'Adicionar o documento',
          description:
            'Este cliente ainda não tem documento. Adicionar {{to}} ao cadastro atual ou dar a este cliente um cadastro próprio?',
          correct: {
            label: 'Adicionar ao cadastro atual',
            description:
              'O documento é gravado no cadastro que o cliente já usa, com todo o histórico dele.',
          },
          otherParty: {
            label: 'Criar cadastro próprio',
            description:
              'O cliente passa a ter um cadastro novo, com este documento. O cadastro atual não muda.',
          },
          sharedNote:
            'Este cadastro também é usado em outros registros (fornecedor, funcionário ou cliente de outra entidade). Adicionar o documento aqui o grava neles também.',
        },
      },
      serpro: {
        button: 'Validar dados na RF',
        searchAtRf: 'Buscar na RF',
        disabledTooltip:
          'Informe um CNPJ válido completo (14 dígitos) para buscar os dados na Receita Federal',
        disabledTooltipEdit: 'Não disponível ao editar cliente',
        disabledTooltipValidated: 'Dados já validados na RF',
        disabledTooltipLoading: 'Buscando dados na RF...',
        loading: 'Validando...',
        validated: 'Verificado',
        validatedAt: 'Verificado em {{date}}',
        invalidCnpj: 'Informe um CNPJ válido para validar',
        genericError: 'Falha ao validar dados na RF',
        notFound: 'CNPJ não encontrado na Receita Federal',
      },
    },
    detail: {
      titleFallback: 'Detalhes do cliente',
      code: 'Código: {{code}}',
      title: 'Cliente: {{name}}',
      subtitle: 'Visão completa do cliente',
      invalidIdTitle: 'Cliente não encontrado',
      invalidIdDescription: 'O identificador do cliente é inválido.',
      loadErrorTitle: 'Erro ao carregar cliente',
      loadErrorDescription: 'Não foi possível carregar os dados do cliente.',
      tabs: {
        overview: 'Visão geral',
        balance: 'Saldo',
        emails: 'E-mails',
        notes: 'Notas',
      },
      sections: {
        summary: {
          title: 'Resumo',
          description: 'Informações principais',
        },
        registrationData: {
          title: 'Dados cadastrais',
          description: 'Informações principais',
        },
        identity: {
          title: 'Identificação',
          description: 'Dados legais e contato',
        },
        fiscal: {
          title: 'Informações fiscais',
          source: 'Receita Federal',
          suspendedVerify: 'Verifique antes de emitir documentos fiscais.',
        },
        billing: {
          title: 'Cobrança',
          description: 'Parâmetros financeiros',
        },
        address: {
          title: 'Endereço',
          description: 'Localização principal',
        },
        audit: {
          title: 'Auditoria',
          description: 'Datas de criação e atualização',
        },
        balance: {
          title: 'Reembolsos a receber',
          description: 'Despesas reembolsáveis registradas no saldo por contraparte',
        },
        emails: {
          title: 'E-mails',
          description: 'Canais cadastrados',
        },
        notes: {
          title: 'Notas de cobrança',
          description: 'Observações internas',
        },
      },
      fields: {
        code: 'Código',
        taxId: 'Documento',
        status: 'Status',
        legalName: 'Razão social',
        tradeName: 'Nome fantasia',
        partyType: 'Tipo de pessoa',
        email: 'E-mail',
        phone: 'Telefone',
        billingGroup: 'Grupo de cobrança',
        creditLimit: 'Limite de crédito',
        paymentTerms: 'Condições de pagamento',
        taxRegimeCode: 'Regime fiscal (SAT)',
        paymentFormCode: 'Tipo de pagamento (SAT)',
        autoCollection: 'Cobrança automática',
        negativacao: 'Negativação',
        address: 'Logradouro',
        addressCity: 'Cidade',
        addressState: 'Estado',
        addressPostalCode: 'CEP',
        createdAt: 'Criado em',
        updatedAt: 'Atualizado em',
      },
      status: {
        active: 'Ativo',
        inactive: 'Inativo',
        blocked: 'Bloqueado',
      },
      boolean: {
        yes: 'Sim',
        no: 'Não',
      },
      balance: {
        recoverable: 'A recuperar',
        entryCount: 'Movimentações',
        currency: 'Moeda',
        entryTypes: {
          CREDIT: 'Entrada',
          DEBIT: 'Baixa',
        },
        emptyTitle: 'Sem movimentações',
        emptyDescription: 'Não há despesas reembolsáveis em aberto para este cliente.',
        showInvoices: 'ver faturas',
        hideInvoices: 'ocultar faturas',
        invoicesLoading: 'Carregando faturas…',
        invoicesEmpty: 'Nenhuma fatura ligada a esta movimentação.',
        invoicesTotal: '{{count}} faturas',
        colReservation: 'Reserva',
        colCompetency: 'Competência',
        colGtv: 'GTV',
        colFee: 'Fee + IVA',
        openInvoice: 'Abrir',
      },
      creditsDebits: {
        loading: 'Carregando lançamentos...',
        loadError: 'Erro ao carregar os lançamentos de saldo.',
        summary: {
          credits: 'Créditos',
          debits: 'Débitos',
          net: 'Saldo líquido',
        },
        table: {
          type: 'Tipo',
          reason: 'Motivo',
          description: 'Descrição',
          amount: 'Valor',
          remaining: 'Restante',
          status: 'Status',
          createdAt: 'Criado em',
          actions: 'Ações',
        },
        type: {
          CREDIT: 'Crédito',
          DEBIT: 'Débito',
        },
        reason: {
          COMMERCIAL_DISCOUNT: 'Desconto comercial',
          OVERPAYMENT: 'Pagamento a maior',
          CREDIT_NOTE: 'Nota de crédito',
          GOODWILL: 'Cortesia',
          PENALTY: 'Penalidade',
          UNBILLED_CHARGE: 'Cobrança não faturada',
          CARRY_FORWARD: 'Saldo transportado',
          OTHER: 'Outro',
        },
        status: {
          AVAILABLE: 'Disponível',
          PARTIALLY_CONSUMED: 'Parcialmente consumido',
          CONSUMED: 'Consumido',
          EXPIRED: 'Expirado',
          CANCELLED: 'Cancelado',
        },
        cancelledInfo: 'Cancelado por {{user}} em {{date}}',
        empty: {
          title: 'Nenhum lançamento',
          description: 'Não há créditos ou débitos manuais registrados para este cliente.',
        },
        create: {
          trigger: 'Novo lançamento',
          title: 'Novo lançamento de saldo',
          description:
            'Registra um crédito ou débito manual que passa a compor o saldo do cliente, consumido pelas próximas faturas.',
          fields: {
            type: 'Tipo',
            reason: 'Motivo',
            currencyCode: 'Moeda',
            amount: 'Valor',
            amountHint:
              'Use 1.200,00 ou 1200.00 — sempre positivo. O tipo (crédito/débito) define o sinal.',
            description: 'Descrição',
            descriptionPlaceholder: 'Ex.: desconto comercial aprovado em...',
            referenceId: 'Referência (opcional)',
            expiresAt: 'Expira em (opcional)',
            notes: 'Observações (opcional)',
          },
          errors: {
            amountInvalid: 'Valor inválido. Informe um valor positivo, ex.: 1.200,00.',
            descriptionRequired: 'Descrição é obrigatória.',
            currencyInvalid: 'Informe o código da moeda com 3 letras, ex.: BRL.',
          },
          confirm: 'Criar lançamento',
          success: 'Lançamento de saldo criado.',
        },
        cancel: {
          trigger: 'Cancelar lançamento',
          title: 'Cancelar lançamento de saldo?',
          description:
            'O lançamento deixa de estar disponível para consumo futuro. Esta ação não pode ser desfeita.',
          confirm: 'Confirmar cancelamento',
          success: 'Lançamento cancelado.',
          consumedError: 'Lançamentos já consumidos não podem ser cancelados.',
          liveConsumptionError:
            'Este lançamento ainda está consumido por uma fatura em rascunho (DRAFT). Exclua o rascunho ou libere o consumo antes de cancelar.',
        },
      },
      emails: {
        emptyTitle: 'Sem e-mails cadastrados',
        emptyDescription: 'Adicione e-mails de contato para o cliente.',
        roleFallback: 'Sem papel',
        addSuccess: 'E-mail adicionado.',
        addError: 'Erro ao adicionar e-mail.',
        removeSuccess: 'E-mail removido.',
        removeError: 'Erro ao remover e-mail.',
      },
      saveSuccess: 'Alterações salvas.',
      saveError: 'Erro ao salvar alterações.',
      notes: {
        emptyTitle: 'Sem notas',
        emptyDescription: 'Nenhuma observação registrada.',
      },
    },
  },
  invoices: {
    listing: { exportFilename: 'faturas-{{date}}.csv' },
    types: {
      standard: 'Padrão',
      transaction: 'Transação',
      gtvTransaction: 'Transação GTV',
      aggregate: 'Agregadora',
    },
    depositReportImport: {
      openAction: 'Importar relatório de liquidação',
      title: 'Importar relatório de liquidação',
      description:
        'Envie o relatório de liquidação. A prévia mostra cada depósito, o beneficiário e como ele resolve hoje — nada é gravado até confirmar. A importação é tudo-ou-nada por arquivo e idempotente por depósito.',
      entity: 'Entidade emissora',
      entityPlaceholder: 'Selecione a entidade',
      file: 'Arquivo (.xlsx)',
      previewAction: 'Prévia',
      importAction: 'Importar e projetar faturas',
      close: 'Fechar',
      refused: 'Recusado pelo contrato',
      alreadyIngested: 'Já importado (replay)',
      willCreateParty: 'Criará cliente/party',
      columns: {
        deposit: 'Depósito',
        payee: 'Beneficiário',
        transactions: 'Transações',
        net: 'Líquido depositado',
        resolution: 'Resolução',
      },
      resultTitle: 'Importação concluída',
      resultSummary:
        '{{deposits}} depósito(s) novo(s), {{replayed}} replay(s), {{events}} evento(s), {{invoices}} fatura(s) projetada(s), {{pending}} evento(s) pendente(s) (refund/chargeback aguardam regra — D6).',
    },
    settlementAggregate: {
      recognizedByReservation_one: 'Reconhecidos por reserva em {{count}} fatura de transação',
      recognizedByReservation_other: 'Reconhecidos por reserva em {{count}} faturas de transação',
      notRecognizedYet:
        'Receita e IVA ainda não reconhecidos: nenhuma fatura de transação desta fatura tem lançamento contábil.',
      settledByRetention: 'Liquidada por retenção no repasse',
      metadata: {
        payoutAccount: 'Conta de repasse',
        payoutAccountValue: '{{name}} (#{{id}})',
        sourceGroup: 'Grupo de origem',
        window: 'Período',
        windowValue: '{{start}} a {{end}}',
        glReclassification: 'Reclassificação contábil',
        glPosted: 'lançada',
        glPending: 'pendente — nova tentativa automática',
        glNothingOpen: 'nada a lançar — nenhuma fatura filha tem saldo não faturado',
        glNothingBilled: 'nada a lançar — a fatura não cobra nenhum recebível',
        glNothingGeneric: 'nada a lançar',
        glChildren_one: '{{count}} filha',
        glChildren_other: '{{count}} filhas',
        technicalDetails: 'Detalhes técnicos',
      },
      receivablesTitle: 'Recebíveis inclusas',
      receivablesCount_one: '{{count}} recebível de liquidação',
      receivablesCount_other: '{{count}} recebíveis de liquidação',
      receivablesWindow: 'Janela {{periodStart}} a {{periodEnd}}',
      receivablesNote:
        'Receita e IVA já reconhecidos por reserva. Esta fatura é o documento de cobrança e fiscal.',
      reservation: 'Reserva',
      competency: 'Competência',
      amount: 'Valor',
      status: 'Status',
      fiscal: 'Nota fiscal',
      fiscalLinked: 'vinculada',
      fiscalPending: 'pendente',
      searchLabel: 'Buscar recebível por reserva',
      searchPlaceholder: 'Buscar por reserva',
      empty: 'Nenhum recebível vinculado.',
      billedIn: 'Faturado na agregadora',
      openAggregate: 'Abrir fatura agregadora',
      reconciliation: {
        reconciled: 'Conciliado 100%',
        pending_one: '{{count}} pendência',
        pending_other: '{{count}} pendências',
        pillTitle:
          'Conciliado {{percent}}% — {{pending}} de {{total}} itens pendentes. Clique para ver.',
        reconciledTitle: 'Repasses e créditos do adquirente conciliados. Clique para ver.',
        title: 'Conciliação do agregado',
        description:
          'O CFDI só deveria sair com a conciliação em 100%. Resolva cada item abaixo na tela de conciliação.',
        loading: 'Carregando pendências…',
        loadFailed: 'Não foi possível carregar as pendências de conciliação.',
        allDone: 'Tudo conciliado: repasses ao hotel e créditos do adquirente.',
        summary:
          '{{pending}} de {{total}} itens pendentes ({{percent}}% conciliado) — repasses: {{custody}}, adquirente: {{rail}}.',
        columns: {
          item: 'Item',
          date: 'Data',
          amount: 'Valor',
          missing: 'O que falta',
          action: 'Ação',
        },
        kind: {
          custody: 'Repasse ao hotel · depósito {{id}}',
          rail: 'Crédito do adquirente · lote {{date}}',
        },
        children_one: '{{count}} recebível',
        children_other: '{{count}} recebíveis',
        missing: {
          PAYOUT_NOT_RECONCILED: 'O repasse ao hotel não foi conciliado com o banco',
          RAIL_CREDIT_NOT_RECONCILED: 'O crédito do adquirente deste lote não foi conciliado',
          RAIL_BATCH_NOT_IMPORTED:
            'O relatório do adquirente deste dia não foi importado — não há lote para conciliar',
        },
        openBankLine: 'Abrir lançamento',
        openInbox: 'Buscar na conciliação',
        close: 'Fechar',
        override: {
          banner:
            'Este agregado tem {{count}} pendência(s) de conciliação. Emitir o CFDI sem conciliar exige uma justificativa, que fica registrada com seu usuário e a data.',
          action: 'Emitir mesmo assim',
          reasonLabel: 'Justificativa (obrigatória)',
          reasonPlaceholder: 'Por que emitir antes de concluir a conciliação?',
          reasonHint: 'Mínimo de 5 caracteres. Fica registrada no histórico da fatura.',
          confirm: 'Emitir mesmo assim',
          back: 'Voltar',
          viewPending: 'Ver pendências',
        },
      },
      approve: {
        title: 'Aprovar e emitir o CFDI',
        description:
          'Receita e IVA já foram reconhecidos por reserva. Aprovar emite o CFDI desta fatura no SAT com os recebíveis inclusos.',
        exchangeRate: 'Tipo de câmbio {{currency}} → MXN (SAT TipoCambio)',
        exchangeRatePlaceholder: 'FIX do DOF do dia (automático)',
        exchangeRateHint:
          'Vazio: o CFDI declara o FIX publicado pelo Banxico no DOF do dia da emissão. Preencha só para sobrepor.',
        confirm: 'Emitir CFDI',
        emitted: 'CFDI emitido. A fatura passou a Emitida.',
        failed: 'O SAT não aceitou a emissão.',
      },
    },
    settlementGrouping: {
      title: 'Agrupamento fiscal consolidado',
      description:
        'Escolha a janela de competência: cada cliente recebe um CFDI consolidado (agregada) com as faturas avulsas do período que ainda não estão em nenhuma nota.',
      openAction: 'Agrupamento fiscal consolidado',
      entity: 'Entidade emissora',
      entityPlaceholder: 'Selecione a entidade',
      periodStart: 'Início do período',
      periodEnd: 'Fim do período',
      preview: 'Ver prévia',
      goToConfirm: 'Continuar',
      back: 'Voltar',
      confirm: 'Agrupar e emitir CFDIs',
      close: 'Fechar',
      runAgain: 'Nova execução',
      empty: 'Nenhuma fatura de liquidação sem nota fiscal nessa janela.',
      missingRfc: 'RFC não mapeado',
      unprojectedTitle: 'Trabalho não projetado nessa janela',
      unprojectedDescription:
        '{{count}} evento(s) de liquidação seguem PENDING (reembolsos/chargebacks sem regra de projeção) e não entram no agrupamento. O período pode estar incompleto.',
      issuerHint:
        'O emissor vem do vínculo da entidade no FiscalAPI e o CFDI é assinado com o CSD já sob custódia do provedor — nenhum certificado ou senha é enviado daqui. Envie o CSD uma única vez na tela de integrações.',
      expeditionZipCode: 'CEP de expedição (SAT) — vazio usa o da entidade',
      recipientTaxRegime: 'Regime fiscal do destinatário (padrão)',
      resultSummary: '{{emitted}} CFDI(s) emitido(s), {{failed}} falha(s).',
      statusEmitted: 'Emitido',
      statusFailed: 'Falhou',
      columns: {
        customer: 'Cliente',
        rfc: 'RFC',
        invoiceCount: 'Faturas',
        total: 'Total',
        currency: 'Moeda',
        status: 'Situação',
        detail: 'Detalhe',
      },
    },
    title: 'Contas a Receber',
    subtitle: 'Gerencie as faturas de clientes',
    statusViews: 'Status das faturas',
    table: {
      invoice: 'Fatura',
      customer: 'Cliente',
      amount: 'Valor',
      received: 'Recebido',
      due: 'Vencimento',
      status: 'Status',
      noResults: 'Nenhuma fatura encontrada.',
      loading: 'Carregando faturas...',
    },
    filters: {
      title: 'Filtros',
      search: 'Busca',
      searchPlaceholder: 'Cliente, número, referência...',
      status: 'Status',
      customerLabel: 'Cliente',
      customerPlaceholder: 'Selecione o cliente',
      searchCustomer: 'Buscar cliente...',
      proposedSelectEntityFirst: 'Selecione a entidade primeiro.',
      clearCustomer: 'Limpar cliente',
      clearAll: 'Limpar todos',
      activeFilters: 'Filtros ativos:',
      all: 'Todos',
      minAmount: 'Valor mínimo',
      maxAmount: 'Valor máximo',
    },
    tabs: {
      all: 'Todas',
      open: 'Em aberto',
      blocked: 'Bloqueadas',
      paid: 'Pagas',
      overdue: 'Vencidas',
    },
    statuses: {
      draft: 'Rascunho',
      stale: 'Desatualizada',
      awaitingNf: 'Aguardando NF',
      blocked: 'Bloqueada',
      issued: 'Emitida',
      recognized: 'Reconhecida',
      provisioned: 'Provisionada',
      partiallyPaid: 'Parcialmente paga',
      paidUnconfirmed: 'Pago (a confirmar)',
      // ALC-2824 — "Recebido parcial", NOT "Parcialmente paga" (which is `partiallyPaid`,
      // just above). The wording separates them on purpose: "paga" is about the CUSTOMER
      // having paid, "recebido" is about the money REACHING US. In a card installment sale
      // the customer paid in full on day one and the acquirer is settling the parcels, so
      // the invoice is fully paid and only partly received.
      partiallyReceived: 'Recebido parcial',
      paid: 'Paga',
      void: 'Cancelada',
      // Fatura migrada do sistema anterior na implantação: apenas informativa, sem ações.
      migrated: 'Migrada',
    },
    stats: {
      totalBilled: 'Total Faturado',
      open: 'Em Aberto',
      paid: 'Pagas',
      overdue: 'Vencidas',
      total: 'Total',
      paidAmount: 'Pago',
      pending: 'Pendente',
      overdueAmount: 'Em atraso',
      invoice: 'fatura',
      invoices: 'faturas',
    },
    listPage: {
      stats: {
        total: 'Total',
        paid: 'Pago',
        pending: 'Pendente',
        overdue: 'Em atraso',
        invoice: 'fatura',
        invoices: 'faturas',
      },
      indicators: {
        open: 'Em aberto',
        blocked: 'Bloqueadas',
        recentlyReceived: 'Recebido nos últimos 7 dias',
        noAmounts: 'Sem valores neste indicador',
        mixedFunctionalCurrencies: 'Selecione uma entidade para ver o total',
        loading: 'Carregando indicadores de faturas',
        loadErrorTitle: 'Não foi possível carregar os indicadores',
        loadErrorDescription: 'Tente novamente para atualizar os totais.',
        missingProvisionBasis_one:
          '{{count}} fatura sem moeda válida ou base funcional não entrou no total.',
        missingProvisionBasis_other:
          '{{count}} faturas sem moeda válida ou base funcional não entraram no total.',
        unresolvedEntities_one: '{{count}} entidade sem moeda funcional não entrou nos totais.',
        unresolvedEntities_other:
          '{{count}} entidades sem moeda funcional não entraram nos totais.',
      },
      periodHeader: {
        prevAria: 'Meses anteriores',
        nextAria: 'Próximos meses',
        complete: 'Quitado',
        loadError: 'Não foi possível carregar as estatísticas por período.',
        retry: 'Tentar novamente',
      },
      metadataFilter: {
        keyPlaceholder: 'Chave do metadado',
        valuePlaceholder: 'Valor do metadado',
        apply: 'Filtrar',
        clear: 'Limpar',
      },
    },
    selection: {
      emitFiscalNotes: 'Emitir Notas Fiscais',
      export: 'Exportar',
    },
    toasts: {
      emitFiscalNotesSuccess: '{{count}} nota(s) fiscal(is) emitida(s) com sucesso.',
    },
    pagination: {
      showing: 'Mostrando {{start}}–{{end}} de {{total}}',
      noResults: 'Nenhum resultado',
      page: 'Página {{current}} de {{total}}',
      previous: 'Anterior',
      next: 'Próxima',
    },
    details: {
      back: 'Voltar para faturas',
      backToPreBilling: 'Voltar para pré-faturamento',
      notFound: 'Fatura não encontrada',
      notFoundDescription: 'A fatura solicitada não existe ou foi removida.',
      payment: {
        title: 'Pagamento',
        received: 'Recebido',
        pending: 'Pendente',
        of: 'de',
      },
      statusChecks: {
        ariaLabel: 'Status da fatura',
        provisioned: 'Provisionada',
        fiscalNoteIssued: 'NF emitida',
        billingSent: 'Cobrança enviada',
        paymentReceived: 'Pagamento recebido',
        settled: 'Liquidada',
        recognized: 'Reconhecida',
        reconciled: 'Conciliada',
        awaitingReconciliation: 'Aguardando conciliação bancária',
        fiscalDocument: 'Documento fiscal',
        awaitingFiscalDocument: 'Aguardando CFDI consolidado',
        partialPayment: 'Parcial ({{amount}})',
        completed: 'concluído',
        pending: 'pendente',
        aggregateRecognized: 'Receita reconhecida (por reserva)',
        aggregateRecognizedPartial: '{{recognized}} de {{total}} faturas',
        aggregateCfdiIssued: 'CFDI emitido',
        aggregateRetained: 'Comissão retida no repasse',
        aggregateOpenBalance: 'Saldo em aberto nas faturas de transação',
        aggregateAwaitingCfdi: 'Definido ao emitir o CFDI',
      },
      header: {
        title: 'Fatura {{number}}',
        documentTitle: 'Fatura: {{code}} - {{customer}}',
        customer: 'Cliente',
        contract: 'Contrato',
        issuingEntity: 'Entidade emissora',
        issueDate: 'Emissão',
        dueDate: 'Vencimento',
        dueDateHint: 'vence {{date}}',
        competencyDate: 'Competência',
        managerialDate: 'Data gerencial',
        description: 'Descrição',
        descriptionPlaceholder: 'Descrição da fatura',
        invoiceDetails: 'Detalhes da fatura',
        openInKamino: 'Abrir no Kamino',
        orderRef: 'Pedido',
        metadata: 'Metadados',
      },
      footer: {
        save: 'Salvar',
        saving: 'Salvando...',
        saveSuccess: 'Alterações salvas com sucesso',
        saveError: 'Erro ao salvar alterações',
        nothingToSave: 'Nada para salvar',
        recalculateTaxes: 'Recalcular tributos',
        recalculateTaxesSuccess: 'Tributos recalculados com sucesso',
        recalculateTaxesError: 'Não foi possível recalcular os tributos',
        approve: 'Aprovar',
        approving: 'Aprovando...',
        approveSuccess: 'A NF foi enviada para emissão, após o sucesso, será postada no razão.',
        approveSuccessAfterReceipt:
          'Fatura aprovada. A NF é enviada para emissão quando o cliente pagar.',
        approveSuccessExternal:
          'Fatura aprovada. Vincule a NF emitida fora do Alchemy ERP quando a tiver.',
        approveSuccessPosted: 'Fatura aprovada e provisionada no razão',
        approveError: 'Não foi possível aprovar a fatura',
        approveDialogTitle: 'Aprovar fatura?',
        approveDialogDescription:
          'A NF será enviada para emissão e, após autorização, a fatura será provisionada no razão. Alterações pendentes serão salvas antes da aprovação.',
        approveDialogDescriptionAfterReceipt:
          'A fatura será provisionada no razão. O ciclo de receita dela emite a NF após o recebimento, então nenhuma NF é enviada agora. Alterações pendentes serão salvas antes da aprovação.',
        approveDialogDescriptionExternal:
          'A fatura será provisionada no razão. A NF é emitida fora do Alchemy ERP, então nenhuma NF é enviada daqui: vincule-a quando a tiver. Alterações pendentes serão salvas antes da aprovação.',
        approveDialogConfirm: 'Confirmar',
        approveDialogCancel: 'Cancelar',
        cancelInvoice: 'Cancelar fatura',
        canceling: 'Cancelando...',
        cancelSuccess: 'Fatura cancelada com sucesso.',
        cancelError: 'Não foi possível cancelar a fatura.',
        cancelGlPostedError:
          'Esta fatura já foi provisionada no razão. O cancelamento exige estorno e ainda não está disponível.',
        cancelDialogTitle: 'Cancelar fatura?',
        cancelDialogDescription: 'A fatura será anulada e não poderá mais ser aprovada ou editada.',
        cancelDialogConfirm: 'Confirmar cancelamento',
        cancelDialogCancel: 'Voltar',
        cancelFiscal: 'Cancelar',
        cancelFiscalGateTitle: 'Cancelar NF e fatura?',
        cancelFiscalGateDescription:
          'Esta ação solicita o cancelamento da NFSe, estorna a provisão contábil e pode reverter ou anular a fatura conforme sua escolha no fluxo seguinte.',
        cancelFiscalGateWarningTitle: 'Atenção: operação irreversível',
        cancelFiscalGateWarningBody:
          'O cancelamento será enviado à prefeitura via Focus NFe. Após confirmado, a nota fiscal deixa de valer e os lançamentos contábeis serão estornados.',
        cancelFiscalGatePhraseLabel: 'Digite "{{phrase}}" para continuar',
        cancelFiscalGateConfirm: 'Continuar',
        cancelFiscalGateCancel: 'Voltar',
      },
      boletos: {
        title: 'Boletos',
        loading: 'Carregando boletos',
        empty: 'Nenhum boleto emitido para esta fatura.',
        installment: 'Parcela {{number}}',
        singleBoleto: 'Boleto da fatura',
        dueDate: 'Vencimento {{date}}',
        nossoNumero: 'Nosso número {{value}}',
        linhaDigitavel: 'Linha digitável',
        barcode: 'Código de barras',
        copy: 'Copiar',
        copied: 'Copiado',
        copyLinhaDigitavel: 'Copiar linha digitável',
        copyBarcode: 'Copiar código de barras',
        proposedCancellationTimeout:
          'A baixa ainda está em processamento. Atualize a página em instantes.',
        proposedProcessingTimeout:
          'A emissão ainda está em processamento. Atualize a página em instantes.',
        pendingCodes: 'O banco ainda não devolveu a linha digitável.',
        paidAt: 'Pago em {{date}}',
        statuses: {
          pending: 'Emitindo',
          registered: 'Registrado',
          paidUnconfirmed: 'Pago (não conciliado)',
          settled: 'Pago',
          cancelled: 'Cancelado',
          failed: 'Falhou',
        },
        issueError: {
          title: 'Não foi possível emitir o boleto',
          retry: 'Tentar emitir novamente',
          retrying: 'Enviando…',
          retryQueued: 'Emissão reenviada. Atualize em instantes.',
          retryFailed: 'Não foi possível reenviar a emissão. Tente novamente.',
          codes: {
            NO_BILLING_GROUP: 'O contrato paga por boleto, mas não tem grupo de cobrança.',
            AMBIGUOUS_BILLING_GROUP: 'Os contratos desta fatura têm grupos de cobrança diferentes.',
            NO_BOLETO_SETTINGS: 'O grupo de cobrança não tem conta bancária para boleto.',
            NO_OPEN_INSTALLMENT: 'Nenhuma parcela desta fatura tem saldo a cobrar.',
            BOLETO_SETTINGS_INVALID:
              'A configuração de boleto do grupo de cobrança não é aceita pelo banco.',
            INSTRUCTIONS_TOO_LONG:
              'As instruções do boleto passam de 3 linhas de 50 caracteres aceitas pelo banco.',
            BANK_ACCOUNT_INVALID: 'A conta bancária do grupo de cobrança não pode emitir boletos.',
            CURRENCY_NOT_SUPPORTED: 'Boletos só podem ser emitidos em reais.',
            PAYER_INCOMPLETE: 'O cadastro do cliente está incompleto para emitir o boleto.',
            INTEGRATION_DISABLED: 'A integração de boletos do Itaú não está ativa.',
            ENTITY_NOT_CONFIGURED: 'A entidade não tem credenciais de boleto do Itaú.',
            CREDENTIALS_INVALID: 'As credenciais de boleto do Itaú são inválidas.',
            BANK_REFUSED: 'O banco recusou o boleto.',
            BANK_UNAVAILABLE: 'O banco não respondeu. Uma nova tentativa será feita.',
          },
          detail: 'Detalhe: {{message}}',
        },
      },
      sections: {
        sourceAndDocuments: 'Origem & documentos',
        lineItems: 'Itens da fatura',
        receipts: 'Recebimentos',
        timeline: 'Linha do tempo',
        amounts: 'Valores e impostos',
        classification: 'Classificação contábil',
      },
      staleReview: {
        title: 'Diferenças a revisar',
        titleResolved: 'Diferenças resolvidas',
        subtitleActive:
          'Os dados de origem mudaram após a revisão desta fatura. Decida cada diferença para liberar a fatura novamente.',
        subtitleResolved: 'Histórico das diferenças resolvidas na última revisão desta fatura.',
        progressPending: '{{pending}} de {{total}} diferença(s) pendente(s)',
        progressDone: 'Todas as {{total}} diferença(s) foram resolvidas.',
        resolvedNotice: 'A fatura voltou para rascunho e já pode ser aprovada novamente.',
        resolvedAtLabel: 'Resolvida em {{date}}',
        diffTypes: {
          lineAmountChanged: 'Valor alterado',
          lineAdded: 'Linha adicionada',
          lineRemoved: 'Linha removida',
        },
        decision: {
          pending: 'Pendente',
          applied: 'Aplicada',
          deferred: 'Adiada',
        },
        fields: {
          description: 'Descrição',
          quantity: 'Quantidade',
          unitPrice: 'Preço unitário',
          lineAmount: 'Valor da linha',
        },
        reviewedValue: 'Valor revisado',
        proposedValue: 'Valor proposto',
        noPreviousValue: 'Linha nova — sem valor revisado',
        noProposedValue: 'Linha removida — sem valor proposto',
        decisionReasonLabel: 'Motivo',
        decidedAtLabel: 'Decidido em {{date}}',
        unknownItemLabel: 'Item do contrato {{id}}',
        actions: {
          apply: 'Aplicar',
          defer: 'Adiar',
          applying: 'Aplicando...',
          deferring: 'Adiando...',
        },
        applyDialog: {
          title: 'Aplicar esta diferença?',
          description:
            'O valor proposto pelo motor de faturamento será adotado nesta linha. Isso recalcula o total da fatura e, se o total mudar, também os cronogramas de reconhecimento de receita e o consumo de saldo do cliente.',
          confirm: 'Aplicar diferença',
        },
        deferDialog: {
          title: 'Adiar esta diferença?',
          description:
            'O valor já revisado na fatura será mantido. Explique o motivo — ele fica registrado no histórico da fatura.',
          reasonLabel: 'Motivo do adiamento',
          reasonPlaceholder: 'Explique por que o valor revisado deve ser mantido',
          confirm: 'Adiar diferença',
        },
        errors: {
          loadError: 'Não foi possível carregar as diferenças desta fatura.',
          retry: 'Tentar novamente',
        },
        empty: 'Nenhuma diferença registrada para esta fatura.',
        loading: 'Carregando diferenças...',
        toasts: {
          applySuccess: 'Diferença aplicada.',
          deferSuccess: 'Diferença adiada.',
          resolvedToast: 'Todas as diferenças foram resolvidas — a fatura voltou para rascunho.',
          actionError: 'Não foi possível registrar a decisão.',
        },
      },
      customerCreditRelease: {
        title: 'Adiantamento de cliente em moeda estrangeira aguardando reconhecimento',
        description:
          'Uma liquidação em moeda estrangeira de um item faturado antecipadamente ficou como ' +
          'adiantamento de cliente ({{amount}}). Reconheça o valor como receita no mês de ' +
          'competência do serviço.',
        releasedTitle: 'Adiantamento reconhecido como receita',
        releasedDetail: '{{amount}} reconhecido como receita em {{month}}',
        releaseAction: 'Reconhecer como receita',
        reverseAction: 'Estornar reconhecimento',
        releaseDialog: {
          title: 'Reconhecer adiantamento como receita',
          description:
            'Lança Dr Adiantamento de cliente / Cr Receita de {{amount}} no mês de competência ' +
            'escolhido, pela taxa de câmbio histórica do adiantamento (sem variação cambial). ' +
            'O custo do serviço (ex.: royalty) também é provisionado no mesmo mês.',
          periodLabel: 'Mês de competência (período aberto)',
          noOpenPeriod: 'Não há período contábil aberto para esta entidade.',
          confirm: 'Reconhecer como receita',
          success: 'Receita reconhecida em {{month}}.',
        },
        reverseDialog: {
          title: 'Estornar reconhecimento como receita',
          description:
            'Estorna o lançamento de {{amount}} reconhecido em {{month}}. O valor volta para o ' +
            'adiantamento de cliente, e a provisão de custo do serviço também é estornada.',
          confirm: 'Estornar reconhecimento',
          success: 'Reconhecimento estornado. O valor voltou para o adiantamento de cliente.',
        },
        errors: {
          generic: 'Não foi possível concluir a operação. Tente novamente.',
          AR_CUSTOMER_CREDIT_RELEASE_NOTHING_TO_RELEASE:
            'Esta fatura não tem adiantamento de cliente em moeda estrangeira pendente de reconhecimento.',
          AR_CUSTOMER_CREDIT_RELEASE_PERIOD_NOT_OPEN:
            'O período contábil do mês de competência escolhido não está aberto. Abra o período ou escolha outro mês.',
          AR_CUSTOMER_CREDIT_RELEASE_BEFORE_SETTLEMENT:
            'O mês de competência escolhido termina antes do lançamento do recebimento que gerou o adiantamento. Escolha o mês do recebimento ou um mês posterior.',
          AR_CUSTOMER_CREDIT_RELEASE_ADVANCE_ACCOUNT_MISMATCH:
            'A conta de adiantamento de cliente mapeada no plano de contas do período escolhido não é a conta em que o adiantamento foi lançado. Escolha um mês do mesmo plano de contas ou ajuste o mapeamento.',
          AR_CUSTOMER_CREDIT_RELEASE_REVENUE_UNMAPPED:
            'Nenhuma conta de receita foi encontrada para o serviço da linha (classificação do serviço ou conta de receita de serviços nas contas de sistema). Mapeie a conta e tente novamente.',
          AR_CUSTOMER_CREDIT_RELEASE_RATE_UNRESOLVED:
            'Não foi possível determinar a taxa de câmbio histórica do adiantamento original.',
          AR_CUSTOMER_CREDIT_RELEASE_NOT_RELEASED:
            'Este adiantamento não tem reconhecimento como receita ativo para estornar.',
          AR_CUSTOMER_CREDIT_RELEASE_INVALID_MONTH:
            'Informe o mês de competência no formato AAAA-MM.',
          AR_CUSTOMER_CREDIT_RELEASE_INVALID_DATE:
            'Informe a data do estorno no formato AAAA-MM-DD.',
          AR_CUSTOMER_CREDIT_RELEASE_MASTER_APPROVER_REQUIRED:
            'Somente aprovadores master podem reconhecer ou estornar o adiantamento como receita.',
        },
      },
      blocked: {
        title: 'Fatura bloqueada',
        reasonLabel: 'Motivo:',
        recovery: 'Corrija o problema indicado acima e aprove a fatura novamente.',
        genericReason: 'Não foi possível provisionar a fatura no razão.',
        // ALC-1358: a fatura não expõe o id do contrato de origem — o link vai para a lista de
        // contratos; a dica nomeia o cliente para ajudar a localizar o contrato certo.
        pendingUsageHint:
          'Localize o contrato de {{customer}} em Contratos, abra a seção de Uso e finalize o ' +
          'uso pendente do período.',
        pendingUsageCta: 'Ir para Contratos',
      },
      activities: {
        created: 'Fatura criada via integração',
        issued: 'Fatura emitida',
        issueFailed: 'Falha na emissão da fatura',
        autoApproveFailed: 'Aprovação automática falhou',
        autoApproveFailedDetail: 'A fatura continua em revisão. Aprove-a manualmente.',
        awaitingNf: 'Fatura aguardando nota fiscal',
        blocked: 'Fatura bloqueada',
        stale: 'Fatura desatualizada: dados de origem mudaram após a revisão',
        staleResolved: 'Diferenças resolvidas; fatura voltou para rascunho',
        glPosted: 'Provisão contábil realizada',
        glPostingFailed: 'Falha na provisão contábil',
        fiscalCalculationOverride: 'Cálculo fiscal alterado manualmente',
        fiscalRecalculated: 'Tributos e recebível recalculados',
        fiscalNoteRoundingAccepted: 'Arredondamento aceito: valores da NFS-e anexada mantidos',
        fiscalNoteCleared: 'NF anexada removida',
        reconciliationOverride: 'CFDI emitido com conciliação pendente (justificativa registrada)',
        fiscalRecalculatedDetail:
          'Líquido anterior: {{previous}} · cálculo fiscal: {{calculated}} · valor final a receber: {{final}}',
        softDeleted: 'Fatura excluída',
        nfseRequested: 'Emissão da NFSe solicitada',
        nfseAuthorized: 'NFSe autorizada',
        nfseFailed: 'Falha na emissão da NFSe',
        nfseCancellationRequested: 'Cancelamento da NFSe solicitado',
        nfseCancellationPendingAdministrative:
          'Cancelamento da NFSe aguardando conclusão administrativa',
        nfseCancellationGlReversalError: 'Falha na reversão contábil do cancelamento da NFSe',
        nfseCancelled: 'NFSe cancelada',
        nfseCancellationFailed: 'Falha no cancelamento da NFSe',
        voided: 'Fatura cancelada',
        ownTaxReversedAfterGuide: 'ISS próprio estornado após a guia — valor a recuperar',
        settlementCustomerCredit: 'Crédito do cliente',
        settlementCustomerCreditDetail:
          '{{amount}} lançado como adiantamento de cliente · {{reason}}',
        customerCreditReasons: {
          AR_SETTLEMENT_DUPLICATE_BILLING_CUSTOMER_CREDIT:
            'Esta liquidação cobre um ciclo do contrato que já foi faturado por outro documento. Verifique a cobrança em duplicidade e devolva ou compense o valor com o cliente.',
          AR_SETTLEMENT_ADVANCE_FOREIGN_CURRENCY_CUSTOMER_CREDIT:
            'Liquidação em moeda estrangeira de um item faturado antecipadamente, que ainda não pode ser diferido no Passivo de Contrato. Reconheça o valor como receita no mês de competência do serviço.',
          AR_SETTLEMENT_USAGE_ASSET_CUSTOMER_CREDIT:
            'Esta liquidação cobre um ciclo cuja receita já foi reconhecida no Ativo de Contrato. A parte que o Ativo de Contrato do ciclo não comporta ficou como adiantamento de cliente: confira se o ciclo não foi cobrado a mais e devolva ou compense o valor com o cliente.',
          AR_INVOICE_DUPLICATE_BILLING_CUSTOMER_CREDIT:
            'Esta fatura cobre um ciclo do contrato que já foi faturado por outro documento (por exemplo, uma liquidação). Verifique a cobrança em duplicidade e devolva ou compense o valor com o cliente.',
        },
        usageAssetClaimReleased: 'Ativo de Contrato liberado para nova emissão',
        customerCreditReleased: 'Adiantamento de cliente reconhecido como receita',
        customerCreditReleaseReversed: 'Reconhecimento do adiantamento como receita estornado',
        usageAssetClaimReleasedDetail: '{{amount}} devolvido ao saldo faturável do cronograma',
        withholdingMismatch: 'Retenções divergentes',
        withholdingMismatchItem: '{{tax}}: NF {{stated}}, aplicado {{applied}}',
        issEvidenceMissing: 'NF sem valor de ISS',
        issEvidenceMissingDetail: 'O ISS continua provisionado até a NF informar o valor.',
        externalFiscalNoteLinked: 'NF externa vinculada',
        paymentReconciled: 'Pagamento conciliado',
        paymentDetail: '{{amount}} via conciliação bancária',
        paymentDetailWithMethod: '{{amount}} via {{method}} · conciliação bancária',
      },
      sidebar: {
        nextAction: {
          title: 'Próxima ação',
          situationTitle: 'Situação',
          draft: 'Revise os dados da fatura e aprove para emitir a NF e provisionar no razão.',
          draftAfterReceipt:
            'Revise os dados da fatura e aprove para provisionar no razão. A NF é enviada para emissão quando o cliente pagar.',
          draftExternal:
            'Revise os dados da fatura e aprove para provisionar no razão. A NF é emitida fora do Alchemy ERP: vincule-a quando a tiver.',
          provisioned: 'A NF está provisionada. O próximo passo é enviar a cobrança ao cliente.',
          partiallyPaid:
            'Há recebimentos parciais. Registre novos recebimentos ou envie cobrança do saldo.',
          paidUnconfirmed:
            'O cliente já pagou pelo sistema de origem. Aguardando conciliação bancária para ' +
            'confirmar o pagamento — não envie cobrança.',
          partiallyReceived:
            'Parcelas já liquidadas pela adquirente; as demais chegam nas datas previstas. ' +
            'O cliente não deve nada — não envie cobrança nem acione régua de inadimplência.',
          paid: 'Fatura quitada. Nenhuma ação pendente.',
          settledAwaitingFiscal:
            'Receita reconhecida e provisionada — aguardando a conciliação bancária do depósito e o CFDI consolidado.',
          settledComplete: 'Liquidada e com documento fiscal emitido. Nenhuma ação pendente.',
          void: 'Fatura anulada.',
          migrated:
            'Registro migrado do sistema anterior. Somente informativo: sem lançamento contábil, ' +
            'sem NFS-e e sem cobrança por aqui.',
          default: 'Revise o status da fatura e conclua a próxima etapa do fluxo.',
          sendBilling: 'Enviar cobrança',
          sendBillingQueued: 'Cobrança enviada para emissão dos boletos.',
          sendBillingFailed: 'Não foi possível enviar a cobrança. Tente novamente.',
          registerReceipt: 'Registrar recebimento',
          moreActions: 'Mais ações',
        },
        financialSummary: {
          title: 'Resumo financeiro',
          gross: 'Valor bruto',
          settledAtSource: 'Liquidado no depósito',
          revenueTaxes: '(-) Impostos sobre a receita',
          settledAtSourceHint:
            'A nossa parte já foi retida no próprio depósito do parceiro — não há cobrança em aberto.',
          withholdings: '(-) Retenções',
          toReceive: 'Valor a receber',
          received: 'Recebido',
          pending: 'Pendente',
        },
        receipts: {
          addReceipt: 'Adicionar recebimento',
        },
      },
      amounts: {
        foreignCurrencyEmissionWarning:
          'Essa é uma fatura em moeda estrangeira. Ao emitir o documento fiscal, os valores provisionados serão recalculados com a cotação do dia ({{authority}}).',
        fxAuthority: {
          BCB_PTAX: 'PTAX do BCB',
          BANXICO_DOF: 'FIX do DOF (Banxico)',
          FRB_H10: 'H.10 do Federal Reserve',
        },
        originalValue: 'Valor original',
        provisionedValue: 'Valor provisionado',
        provisionedIss: 'ISS provisionado',
        provisionedIva: 'IVA provisionado',
        recognizedRevenue: 'Receita reconhecida',
        recognizedIss: 'ISS reconhecido',
        recognizedIva: 'IVA reconhecido',
        viewRecognizedRevenue: 'Ver receita reconhecida',
        recognizedRevenueModalTitle: 'Receita reconhecida',
        recognizedRevenueModalDescription:
          'Base contabilizada na competência, preservada com a taxa de câmbio originalmente utilizada.',
        gross: 'Valor bruto',
        grossServices: 'Valor bruto dos serviços',
        taxes: 'ISS (Não retido)',
        withholdings: 'Retenções',
        withholdingsSectionTitle: 'Retenções na fonte — reduzem o valor a receber',
        withholdingsTotal: 'Total retido pelo cliente',
        nonRetainedSectionTitle: 'Tributos não retidos — não afetam o valor a receber',
        issCollectedByIssuer: 'recolhido pela emissora',
        issNonRetainedFootnote:
          'O ISS é despesa/obrigação da emissora e não é descontado do cliente — por isso não entra no cálculo do valor a receber.',
        ivaLabel: 'IVA',
        ivaCollectedByIssuer: 'trasladado no CFDI',
        ivaNonRetainedFootnote:
          'O IVA trasladado é somado ao valor a receber (o cliente paga serviços + IVA) e depois repassado ao SAT — por isso entra no total, como IVA por Pagar.',
        settlementSectionTitle: 'Custódia — valores de terceiros em trânsito',
        repasseLabel: 'Repasse a parceiros',
        repasseCollectedOnBehalf: 'cobrado por conta de terceiros',
        repasseFootnote:
          'Dinheiro de terceiros que passa por nós: registrado como passivo até ser repassado, nunca como receita.',
        gtvLabel: 'Valor transacionado (GTV)',
        grossRevenue: 'Receita bruta',
        revenueTaxesSectionTitle: 'Impostos sobre a receita',
        netRevenue: 'Receita líquida',
        ivaRemittedFootnote:
          'Imposto cobrado do cliente e recolhido ao fisco: reduz a receita bruta e não é receita nossa.',
        gtvFootnote:
          'Total que transita por nós: nossa comissão + impostos sobre ela + o repasse ao parceiro.',
        net: 'Valor líquido',
        netToReceive: 'Valor líquido a receber',
      },
      revenueTax: {
        title: 'Outros impostos sobre receita provisionados',
        helper: 'Tributos da empresa sobre esta receita. Não alteram o valor da fatura.',
        baseAndRate: 'Base {{base}} · alíquota {{rate}}',
        originalBaseAndRate: 'Base original {{base}} · alíquota {{rate}}',
        reversedDetail: 'provisionado {{provisioned}}, estornado {{reversed}}',
        reversalPendingDetail:
          'provisionado {{provisioned}}, estornado {{reversed}} (o estorno ainda não foi lançado por completo no razão)',
        openSetup: 'Abrir a configuração de tributos sobre a receita',
        export: {
          action: 'Revisar prova de exportação',
          title: 'Revisar elegibilidade da exportação',
          description:
            'Vincule a prova imutável ao lançamento e à conta de receita exatos. Marcar a conta como exportação não concede o tratamento tributário.',
          source: 'Lançamento e conta de receita',
          sourceUnavailable: 'Conta de receita sem identificação disponível',
          route: 'Rota legal comprovada',
          document: 'Documento de prova vinculado à fatura',
          upload: 'Anexar PDF de prova',
          receiptId: 'Recebimento canônico',
          receiptWithoutNumber: 'Recebimento sem número',
          fxEvidenceHint:
            'O recebimento pode estar parcialmente alocado. O PDF tipado deve comprovar a operação completa e a cadeia de ingresso ou conversão; a alocação, sozinha, não concede o tratamento.',
          paymentDate: 'Data do pagamento ou ingresso',
          paymentCurrency: 'Moeda',
          paymentAmount: 'Valor',
          evidenceCode: 'Código da evidência',
          evidenceDescription: 'Descrição da revisão',
          commercialExporterUnsupported:
            'Venda a comercial exportadora ainda não é suportada. Não selecione outra rota para contornar essa limitação.',
          routes: {
            DIRECT_GOODS: 'Exportação direta de bens',
            SERVICE_FX_INGRESS: 'Serviço com ingresso/conversão de divisas',
            SERVICE_FUNDS_RETAINED_ABROAD: 'Serviço com recursos mantidos no exterior',
          },
          preview: 'Revisar decisão',
          confirm: 'Confirmar elegibilidade',
          cancel: 'Cancelar',
          close: 'Fechar',
          reviewTitle: 'Decisão pronta para confirmação',
          immutable: 'A decisão será imutável e valerá somente para este lançamento e conta.',
          rereview:
            'Esta revisão cria uma nova decisão vinculada à anterior. O histórico aprovado permanece imutável.',
          boundSource:
            'Origem {{sourceAmount}} em {{lineCount}} linha(s); operação {{invoiceAmount}}.',
          saved: 'Elegibilidade salva e provisões pendentes reprocessadas pela rotina canônica.',
          evidenceInvalid:
            'A prova vinculada foi desfeita ou alterada. Esta exportação não pode ser reaprovada nem fechar o período. Vincule uma nova prova válida à mesma origem, revise a decisão e atualize a apuração.',
          errors: {
            REVENUE_TAX_EXPORT_COMMERCIAL_EXPORTER_UNSUPPORTED:
              'Venda a comercial exportadora não está disponível nesta etapa.',
            REVENUE_TAX_EXPORT_DOCUMENT_REQUIRED:
              'Anexe e selecione um PDF ativo vinculado a esta fatura.',
            REVENUE_TAX_EXPORT_FOREIGN_CUSTOMER_REQUIRED:
              'O cliente da operação precisa ter país estrangeiro válido.',
            REVENUE_TAX_EXPORT_GOODS_SOURCE_REQUIRED:
              'A rota direta de bens exige uma fatura composta somente por bens identificados.',
            REVENUE_TAX_EXPORT_SERVICE_SOURCE_REQUIRED:
              'A rota de serviços exige uma fatura composta somente por serviços identificados.',
            REVENUE_TAX_EXPORT_MIXED_SOURCE_UNSUPPORTED:
              'A fatura mistura bens, serviços ou itens sem tipo. Separe ou corrija a origem antes da revisão.',
            REVENUE_TAX_EXPORT_PAYMENT_EVIDENCE_REQUIRED:
              'Informe data, moeda e valor da evidência de pagamento ou dos recursos mantidos no exterior.',
            REVENUE_TAX_EXPORT_RECEIPT_REQUIRED:
              'Selecione um recebimento canônico com alocação positiva nesta fatura. A alocação pode ser parcial; o PDF tipado deve comprovar a operação de exportação do serviço como um todo e a cadeia de ingresso ou conversão.',
            REVENUE_TAX_EXPORT_ELIGIBILITY_SOURCE_CHANGED:
              'A origem mudou após a revisão. Recarregue e revise novamente.',
            REVENUE_TAX_EXPORT_ELIGIBILITY_ALREADY_REVIEWED:
              'A prova atual ainda é válida. Uma nova decisão só pode substituir uma prova canonicamente invalidada.',
            REVENUE_TAX_EXPORT_SOURCE_PERIOD_OPEN_REQUIRED:
              'Reabra o período contábil da origem antes de confirmar a nova prova.',
            REVENUE_TAX_EXPORT_ELIGIBILITY_CHAIN_AMBIGUOUS:
              'O histórico de decisões desta origem está inconsistente. Corrija a cadeia antes de revisar.',
            REVENUE_TAX_EXPORT_SOURCE_INVALID:
              'O lançamento, a conta ou o vínculo contábil da fatura não é válido para esta revisão.',
            REVENUE_TAX_EXPORT_SOURCE_CHANGED:
              'Os fatos informados não formam uma evidência canônica válida. Revise a rota e a origem.',
            unknown: 'Não foi possível concluir a revisão de exportação.',
          },
        },
        transition: {
          action: 'Classificar transição de 2027',
          title: 'Classificar transição tributária da operação',
          description:
            'Registre a destinação legal desta operação e a evidência da revisão. Depois de salva, a classificação não poderá ser alterada.',
          source: 'Origem',
          entity: 'Entidade',
          books: 'Livros',
          invoiceSource: 'Fatura {{number}}',
          currentEntity: 'Entidade emissora da fatura',
          treatment: 'Tratamento na transição',
          selectTreatment: 'Selecione sem aplicar uma opção padrão',
          evidenceCode: 'Código da evidência',
          evidenceDescription: 'Descrição da evidência',
          confirm: 'Salvar classificação',
          cancel: 'Cancelar',
          close: 'Fechar',
          saved: 'Classificação salva para toda a operação.',
          classifiedAt: 'Classificada em {{date}}.',
          immutable: 'Classificação concluída e bloqueada para edição.',
          treatments: {
            ORDINARY_LEGACY_PIS_COFINS: 'PIS/COFINS do regime anterior',
            OPTIONAL_REAL_ESTATE_CBS: 'CBS opcional para operação imobiliária',
            NOT_ELIGIBLE: 'Operação não elegível para a transição',
          },
          errors: {
            REVENUE_TAX_TRANSITION_SOURCE_NOT_FOUND:
              'As provisões desta operação não foram encontradas.',
            REVENUE_TAX_TRANSITION_EVIDENCE_REQUIRED:
              'Informe o código e a descrição da evidência.',
            REVENUE_TAX_TRANSITION_CLASSIFICATION_CONFLICT:
              'As provisões da operação têm dados divergentes. Revise os dados antes de tentar novamente.',
            REVENUE_TAX_TRANSITION_CLASSIFICATION_IMMUTABLE:
              'Esta operação já foi classificada e não pode ser alterada.',
            REVENUE_TAX_TRANSITION_ASSESSMENT_EXISTS:
              'A operação já participa de uma apuração de 2027 e não pode mais ser classificada.',
            REVENUE_TAX_TRANSITION_SOURCE_DATE_MISSING:
              'A data da operação original não foi encontrada. Revise a competência/data da fatura, nota de débito ou reconhecimento contratual.',
            REVENUE_TAX_TRANSITION_SOURCE_DATE_INVALID:
              'A data informada na origem da fatura, nota de débito ou reconhecimento contratual não é válida. Corrija a origem antes de classificar.',
            REVENUE_TAX_TRANSITION_SOURCE_AFTER_CUTOFF:
              'A operação original é posterior a 31/12/2026 e não pode usar o tratamento ordinário de legado de PIS/COFINS.',
            REVENUE_TAX_TRANSITION_SOURCE_EVIDENCE_MISSING:
              'A origem canônica da fatura, nota de débito ou reconhecimento contratual não foi encontrada ou não é suportada para esta transição.',
            unknown: 'Não foi possível salvar a classificação. Tente novamente.',
          },
        },
        status: {
          pending: 'Pendente',
          reversed: 'Estornado',
          reversalPending: 'Estorno pendente',
          partlyReversed: 'Estornado em parte',
        },
      },
      classification: {
        revenueAccount: 'Conta de receita',
        costCenter: 'Centro de custo',
        department: 'Departamento',
        managerialAccount: 'Conta gerencial',
        segment: 'Segmento',
        unclassifiedLine: 'Sem classificação',
        lockedAfterPosting: 'Classificação bloqueada após lançamento no razão',
        lockedFromContract:
          'Classificação definida pelo contrato, a partir dos serviços de faturamento. Para alterá-la, ajuste a classificação do serviço no contrato.',
        viewGlPostings: 'Ver lançamentos contábeis',
        loadingGlPostings: 'Carregando lançamentos...',
        save: 'Salvar classificação',
        saving: 'Salvando...',
        saveSuccess: 'Classificação salva com sucesso',
        saveError: 'Erro ao salvar classificação',
        modeChangeSuccess: 'Modo de classificação alterado',
        modeChangeError: 'Erro ao alterar modo de classificação',
        item: 'item',
        items: 'itens',
        noLineItems: 'Nenhum item na fatura',
        reclassify: 'Modificar classificação',
        reclassifyConfirm:
          'Os lançamentos existentes serão revertidos e a fatura será relançada com a nova classificação.',
        reclassifyReviewFallback: 'Uma solicitação de revisão contábil será criada.',
        reclassifyBanner: 'Modifique as classificações e confirme para relançar no razão',
        reclassifySuccess: 'Classificação atualizada e relançada no razão',
        reclassifyError: 'Erro ao reclassificar fatura',
        confirmReclassify: 'Confirmar reclassificação',
        cancel: 'Cancelar',
        selectPeriod: 'Período de estorno',
        loadingPeriods: 'Carregando períodos...',
        mode: {
          billLevel: 'Fatura',
          lineItem: 'Item',
          custom: 'Customizado',
        },
      },
      source: {
        externalRef: 'Referência Externa',
        cfdiConsolidatedTitle: 'Documento fiscal — CFDI consolidado',
        cfdiFromGrouping:
          'Será emitido pelo agrupamento fiscal consolidado (CFDI agregada), não por fatura.',
        cfdiIssued: 'CFDI consolidado emitido e vinculado a esta fatura.',
        attachedDocuments: 'Documentos Anexos',
        noDocuments: 'Nenhum documento anexado',
        noFiscalNote: 'Fatura sem NF vinculada',
        noFiscalNoteDescription: 'Nenhuma nota fiscal foi recebida ou emitida para esta fatura.',
        documentPdf: '{{type}} — PDF',
        openDocument: 'Abrir',
        openInNewTab: 'Nova aba',
        download: 'Baixar',
        previewDocument: 'Pré-visualizar documento',
        documentNumber: 'NFS-e',
        cfdiFolio: 'Folio',
        consolidatedCount: 'Cobre {{count}} faturas deste período',
        series: 'Série',
        rpsNumber: 'RPS',
        rpsSeries: 'Série do RPS',
        accessKey: 'Chave',
        pdfUnavailable: 'PDF indisponível',
        attachEmitted: 'Anexar NF emitida',
        attachEmittedTitle: 'NF emitida fora do sistema',
        attachEmittedDescription: 'Envie o XML ou PDF da nota emitida.',
        clearUploaded: 'Limpar NF anexada',
        clearUploadedDialogTitle: 'Limpar a NF anexada?',
        clearUploadedDialogDescription:
          'A NF e seus arquivos serão removidos. Os valores, a moeda e as datas da fatura não serão alterados.',
        clearUploadedCancel: 'Cancelar',
        clearUploadedConfirm: 'Limpar NF',
        clearingUploaded: 'Limpando...',
        clearUploadedSuccess: 'NF anexada removida com sucesso.',
        clearUploadedRefreshWarning:
          'A NF foi removida, mas os dados da tela não foram atualizados. Atualize a página.',
        clearUploadedError: 'Não foi possível limpar a NF anexada.',
        retryClearUploaded: 'Tentar novamente',
        close: 'Fechar',
      },
      lineItems: {
        product: 'Produto/Serviço',
        service: 'Serviço',
        servicePlaceholder: 'Selecionar serviço',
        description: 'Descrição',
        descriptionPlaceholder: 'Descrição do item',
        editDescription: 'Editar descrição',
        clickToEditDescription: 'Clique para editar',
        saveDescription: 'Salvar',
        cancelDescription: 'Cancelar',
        quantity: 'Qtd',
        unitPrice: 'Preço Unit.',
        total: 'Total',
        subtotal: 'Subtotal',
        taxes: 'Impostos',
        invoiceTotal: 'Total da Fatura',
      },
      receipts: {
        noReceipts: 'Nenhum recebimento registrado para esta fatura.',
        date: 'Data',
        method: 'Método',
        amount: 'Valor',
        allocated: 'Alocado',
        reference: 'Ref',
      },
      timeline: {
        invoiceIssued: 'Fatura emitida',
        paymentReceived: 'Pagamento recebido',
        invoicePaid: 'Fatura paga',
      },
      withholdingTaxTypes: {
        IRRF: 'IRRF',
        PIS: 'PIS',
        COFINS: 'COFINS',
        CSLL: 'CSLL',
        INSS: 'INSS',
        ISS: 'ISS',
      },
    },
  },
  invoiceIssues: {
    title: 'Pendências',
    filter: 'Com pendências',
    column: 'Pendências',
    tagMore: '{{first}} +{{count}}',
    unknownIssue: 'Outra pendência',
    where: {
      line: 'Linha {{n}}',
    },
    steps: {
      RECORD: 'Registro da fatura',
      APPROVE: 'Aprovação e lançamento contábil',
      NFSE: 'Emissão da NFS-e',
    },
    blocks: {
      RECORD: 'Bloqueia o registro da fatura',
      APPROVE: 'Bloqueia a aprovação',
      NFSE: 'Bloqueia a emissão da NFS-e',
    },
    codes: {
      SERVICE_NOT_MAPPED: {
        title: 'Serviço não cadastrado',
        problem: 'Uma linha da fatura usa um serviço que não está cadastrado.',
        fix: 'Cadastre o serviço ou escolha um serviço existente na linha.',
      },
      REVENUE_ACCOUNT_MISSING: {
        title: 'Fatura sem classificação contábil',
        problem: 'A fatura não tem conta de receita definida.',
        fix: 'Classifique a fatura antes de aprová-la.',
      },
      GL_PERIOD_CLOSED: {
        title: 'Período contábil fechado',
        problem:
          'O período contábil da data de emissão está fechado, então a receita não pode ser lançada.',
        fix: 'Reabra o período ou altere a data de emissão da fatura.',
      },
      CUSTOMER_TAX_ID_INVALID: {
        title: 'CPF ou CNPJ do cliente inválido',
        problem: 'O CPF ou CNPJ do cliente não é válido, então a NFS-e não pode ser emitida.',
        fix: 'Corrija o CPF ou CNPJ no cadastro do cliente.',
      },
      CUSTOMER_TAX_ID_MISSING: {
        title: 'CNPJ do cliente não informado',
        problem: 'O cliente é uma empresa sem CNPJ, então a NFS-e não pode ser emitida.',
        fix: 'Informe o CNPJ no cadastro do cliente.',
      },
      CUSTOMER_ADDRESS_INCOMPLETE: {
        title: 'Endereço do cliente incompleto',
        problem:
          'A cidade e o estado do cliente não correspondem a um município brasileiro, então a NFS-e não pode ser emitida.',
        fix: 'Corrija a cidade e o estado no endereço do cliente.',
      },
      SERVICE_FISCAL_CODE_MISSING: {
        title: 'Serviço sem código fiscal',
        problem:
          'O serviço não tem um código de serviço LC 116 válido, então a NFS-e não pode ser emitida.',
        fix: 'Defina o tipo de serviço fiscal no cadastro do serviço.',
      },
    },
    panel: {
      intro: 'Enquanto houver pendências abertas, a fatura não pode ser aprovada.',
      problemLabel: 'O que está errado',
      blocksLabel: 'O que bloqueia',
      fixLabel: 'Como corrigir',
    },
    approve: {
      title: 'A fatura não pode ser aprovada',
      description_one: 'Corrija a pendência aberta e aprove a fatura de novo.',
      description_other: 'Corrija as {{count}} pendências abertas e aprove a fatura de novo.',
      close: 'Fechar',
    },
    history: {
      events: {
        EXTERNAL_CREATED_WITH_ISSUES: 'Fatura recebida da integração com pendências',
        EXTERNAL_UPDATED: 'Fatura atualizada pela integração',
        CUSTOMER_CHANGED: 'Cliente da fatura alterado pela integração',
        ISSUE_OPENED: 'Pendência aberta',
        ISSUE_RESOLVED: 'Pendência resolvida',
        AUTO_APPROVE_SKIPPED_OPEN_ISSUES: 'Aprovação automática não executada',
        DRAFT_EDITED: 'Rascunho editado',
      },
      details: {
        autoApproveSkipped: 'A fatura tem pendências abertas: {{issues}}.',
        customerChanged: 'Cliente {{old}} trocado por {{new}}',
        customerChangedNoCode: 'O cliente da fatura foi trocado',
      },
      actors: {
        api: 'Integração externa',
        system: 'Sistema',
      },
      changedTo: 'alterado para',
      noValue: 'sem valor',
      unknownAccount: 'conta não encontrada',
      fields: {
        customerTaxId: 'CPF ou CNPJ do cliente',
        customerId: 'Cliente',
        invoiceNumber: 'Número da fatura',
        currency: 'Moeda',
        issueDate: 'Data de emissão',
        dueDate: 'Vencimento',
        competencyDate: 'Competência',
        managerialDate: 'Data gerencial',
        description: 'Descrição',
        grossAmount: 'Valor bruto',
        netAmount: 'Valor líquido',
        totalAmount: 'Valor total',
        subtotalAmount: 'Subtotal',
        taxTotalAmount: 'Total de impostos',
        withholdingTotalAmount: 'Total de retenções',
        revenueGlAccountId: 'Conta de receita',
        externalFiscalNoteNumber: 'Número da NF externa',
        externalFiscalNoteIssueDate: 'Emissão da NF externa',
        lineCount: 'Quantidade de linhas',
        installmentCount: 'Quantidade de parcelas',
        line: 'Linha {{n}}: {{field}}',
        lineFields: {
          amount: 'valor',
          description: 'descrição',
          serviceCode: 'código do serviço',
          service: 'serviço',
        },
        installment: 'Parcela {{n}}: {{field}}',
        installmentFields: {
          amount: 'valor',
          dueDate: 'vencimento',
        },
        withholding: 'Retenção de {{tax}}',
        unknown: 'Outro campo',
      },
    },
  },
  approveErrors: {
    ownTaxOriginReversalExceedsAvailable:
      'O estorno é maior que o saldo do imposto próprio apurado para esta fatura. Revise os valores estornados e tente novamente.',
    ownTaxOriginAdjustmentUnsupported:
      'Linhas de ajuste não podem lançar em uma conta de imposto apurado vinculada a esta fatura. Estorne a linha original correspondente.',
    ownTaxOriginReversalConflict:
      'O saldo do imposto próprio desta fatura mudou durante o estorno (por exemplo, uma guia foi estornada ao mesmo tempo). Recarregue a fatura e tente novamente.',
    originAllocationMoveConflict:
      'O imposto desta fatura mudou enquanto a reclassificação transferia o pagamento da guia para o novo lançamento (por exemplo, uma guia foi aprovada ou estornada ao mesmo tempo). Recarregue a fatura e tente novamente.',
    taxAccountNotMapped:
      'Para aprovar, configure o mapeamento das contas tributárias no plano de contas da competência.',
    taxAccountSlotNotFound:
      'Conta tributária não configurada. Verifique o mapeamento de contas tributárias.',
    noOpenPeriod:
      'Não há período contábil aberto para a data de emissão da fatura/nota fiscal. Abra esse período e tente novamente.',
    proposedBoletoCancelPending:
      'Aguarde a baixa dos boletos anteriores antes de aprovar ou emitir esta fatura novamente.',
    invoiceCannotBeIssued: 'A fatura não pode ser aprovada no status atual.',
    billingServiceRequired: 'Vincule um serviço de faturamento à fatura antes de aprová-la.',
    focusNfeNotConfigured:
      'A integração FocusNFe não está configurada para a entidade. Verifique o token e reinicie a API após alterar o ambiente.',
    fiscalParametersRequired: 'Parâmetros fiscais obrigatórios ausentes: {{reason}}',
    fiscalAmountsMismatch:
      'Os valores fiscais da fatura diferem do cálculo atual. Recalcule os tributos e tente novamente.',
    nfseValidationFailed: 'A validação da NFSe falhou: {{reason}}',
    contractAssetCarrierMismatch:
      'A exposição cambial do Ativo de Contrato aponta para uma conta diferente da que o reconhecimento debitou. Revise o razão do contrato antes de aprovar a fatura.',
    contractAssetCarrierReliefUnresolved:
      'O saldo que as contas do Ativo de Contrato ainda carregam, descontadas as faturas anteriores, não cobre esta fatura. Revise o razão do contrato antes de aprovar a fatura.',
    contractAssetReliefEntityMismatch:
      'A fatura, o contrato e o lançamento do Ativo de Contrato pertencem a entidades diferentes. Confira a entidade da fatura e do contrato antes de aprovar.',
    issOwnTaxLegAmbiguous:
      'A conta de ISS Apurado recebe mais de um crédito neste lançamento e nenhum corresponde ao ISS próprio da nota. Use uma conta de ISS Apurado exclusiva para o ISS no trilho de Revenue Tax.',
    customerAdvanceUnmapped:
      'Este documento cobre um ciclo do contrato já faturado e deve ser lançado como adiantamento de cliente, mas a conta de adiantamento de clientes não está mapeada nas contas de sistema. Mapeie a conta de adiantamento de clientes e tente novamente.',
    settlementAdvanceCycleBilledConcurrently:
      'Outro documento faturou este ciclo do contrato enquanto a liquidação era reconhecida. Tente aprovar de novo.',
    goToTaxMapping: 'Ir para Mapeamento',
    goToPeriods: 'Ir para períodos contábeis',
  },
  preBilling: {
    title: 'Pré-faturamento',
    subtitle: 'Revise e aprove faturas em rascunho antes da emissão',
    newInvoice: {
      action: 'Nova fatura',
      title: 'Nova fatura',
      description: 'Preencha os dados para criar um rascunho de fatura no pré-faturamento.',
      cancel: 'Cancelar',
      createDraft: 'Criar como rascunho',
      creating: 'Criando...',
      success: 'Fatura criada como rascunho',
      updated: 'Rascunho existente atualizado',
      validation: {
        requiredFields: 'Preencha os campos obrigatórios',
        entityRequired: 'Selecione a entidade',
        entityCnpjRequired: 'A entidade selecionada precisa de CNPJ',
        customerRequired: 'Selecione o cliente',
        customerIdentityRequired: 'O cliente precisa de CNPJ/CPF ou código',
        customerEntityMismatch: 'O cliente selecionado não pertence a esta entidade',
        amountRequired: 'Informe um valor maior que zero',
        netExceedsGross: 'O valor líquido não pode ser maior que o bruto',
        withholdingBreakdownMissing:
          'O valor líquido precisa ser o bruto menos as retenções informadas. Deixe o líquido em branco para calcular pelo serviço.',
        issOutOfRange: 'O ISS próprio deve ficar entre zero e o valor bruto',
        issueDateRequired: 'Informe a data de emissão',
        serviceRequired: 'Selecione o serviço',
        amountInvalid: 'Informe um valor válido',
      },
      errors: {
        createError: 'Erro ao criar fatura: {{message}}',
        networkError: 'Erro de conexão. Tente novamente.',
        serverError: 'Erro interno ao criar a fatura.',
        currencyUnconfigured: 'A entidade não tem moeda funcional configurada para esta fatura.',
        currencyDivergent: 'Os livros da entidade não compartilham uma moeda funcional.',
        currencyUnsupported: 'A moeda funcional da entidade não pode ser gravada na fatura.',
        enrichmentFailed: 'Não foi possível consultar o CNPJ na Receita Federal.',
        invalidTaxId: 'O CNPJ ou CPF do cliente é inválido.',
      },
      form: {
        entity: 'Entidade',
        customer: 'Cliente',
        customerPlaceholder: 'Selecione um cliente...',
        value: 'Valor bruto',
        currency: 'Moeda',
        currencyHint: 'Em branco, a fatura usa a moeda funcional da entidade.',
        issueDate: 'Emissão',
        competencyDate: 'Competência',
        managerialDate: 'Data gerencial',
        dueDate: 'Vencimento',
        invoiceNumber: 'Número da fatura',
        invoiceNumberPlaceholder: 'Opcional',
        description: 'Descrição',
        descriptionPlaceholder: 'Ex: Serviços contábeis - Jun/2026',
        service: 'Serviço',
        servicePlaceholder: 'Selecione o serviço',
        selectPlaceholder: 'Selecione',
        taxes: 'Impostos',
        taxesHint:
          'Deixe em branco para calcular o líquido e as retenções a partir do serviço, como na importação CSV.',
        netAmount: 'Valor líquido',
        irrf: 'IRRF',
        inss: 'INSS',
        pisRetido: 'PIS retido',
        cofinsRetido: 'COFINS retido',
        csllRetido: 'CSLL retido',
        issRetido: 'ISS retido',
        issProprio: 'ISS próprio',
        noServices: 'Nenhum serviço ativo para esta entidade.',
        loadingServices: 'Carregando serviços...',
      },
    },
    batchJobs: {
      title: 'Em processamento',
      description: 'Acompanhe importações e aprovações em andamento.',
      historyTitle: 'Histórico de processamento',
      historyDescription: 'Consulte importações e aprovações anteriores.',
      viewHistory: 'Ver histórico de processamento',
      hideHistory: 'Ocultar histórico de processamento',
      loading: 'Carregando lotes…',
      empty: 'Nenhum lote processado recentemente.',
      loadError: 'Não foi possível carregar o histórico de lotes.',
      details: 'Detalhes do lote',
      file: 'Arquivo',
      type: 'Tipo',
      createdAt: 'Criado em',
      progress: 'Progresso',
      result: 'Resultado',
      errors: 'Erros',
      attempts: 'Tentativas',
      sourceRow: 'Linha',
      sourceId: 'ID de origem',
      stage: 'Etapa',
      updatedAt: 'Atualizado em',
      allItems: 'Todos os itens',
      failedItems: 'Somente erros',
      viewItems: 'Visualizar',
      filterItems: 'Filtrar itens do lote',
      noItems: 'Nenhum item nesta página.',
      succeeded: '{{count}} concluídos',
      failed: '{{count}} com erro',
      processed: '{{processed}} de {{total}} processados',
      invoicesIssuing: 'Faturas em emissão: {{queued}}/{{total}}',
      retryFailed: 'Tentar erros novamente',
      approveImport: 'Aprovar faturas deste lote',
      retryTitle: 'Tentar itens com erro novamente?',
      retryDescription:
        'Uma nova tentativa será criada somente para os itens com erro. O histórico anterior será preservado.',
      approveTitle: 'Aprovar todas as faturas importadas?',
      approveDescription:
        'A associação deste lote será congelada e as faturas válidas serão enviadas para o fluxo normal de aprovação e emissão.',
      accepted: 'Solicitação recebida no lote {{jobId}}.',
      acceptedTitle: 'Solicitação recebida',
      viewAcceptedJob: 'Acompanhar lote',
      actionError: 'Não foi possível iniciar a solicitação.',
      processingAction: 'Registrando a solicitação com segurança…',
      idempotencyCleanupError:
        'A solicitação foi recebida, mas o navegador não conseguiu limpar a chave local. Consulte o histórico antes de tentar novamente.',
      close: 'Fechar',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      previous: 'Anterior',
      next: 'Próxima',
      page: 'Página {{page}} de {{totalPages}}',
      status: {
        PENDING: 'Pendente',
        PROCESSING: 'Processando',
        COMPLETED: 'Concluído',
        PARTIAL: 'Parcial',
        FAILED: 'Falhou',
        CANCELLED: 'Cancelado',
        SUCCEEDED: 'Concluído',
        RETRY_SCHEDULED: 'Nova tentativa agendada',
      },
      types: {
        AR_PRE_BILLING_IMPORT: 'Importação',
        AR_PRE_BILLING_APPROVAL: 'Aprovação e emissão',
      },
      stages: {
        IMPORT: 'Importação',
        APPROVAL: 'Aprovação',
        EMISSION: 'Emissão',
        POSTING: 'Contabilização',
      },
    },
    stats: {
      totalDrafts: 'Em pré-faturamento',
      withFiscalNote: 'Com nota fiscal',
      missingRevenueAccount: 'Sem conta de receita',
      overdue: 'Vencidas',
    },
    summary: {
      totalAmount: 'Valor total',
      grossNetHint: 'bruto / líquido',
      grossAmount: 'Valor bruto',
      grossFooter: '{{invoiceCount}} faturas · {{clientCount}} clientes',
      withholdingAmount: 'Retenções na fonte',
      withholdingFooter: '{{percent}}% do bruto',
      withholdingShare: '{{percent}} do bruto',
      showByCustomer: 'Ver por cliente',
      loadError: 'Não foi possível carregar os totais.',
      netAmount: 'Valor líquido',
      netFooter: 'a receber dos clientes',
      clientCount: 'Clientes',
      invoiceCount: 'Faturas',
      clientsDialogTitle: 'Totais por cliente',
      invoicesColumn: 'Faturas',
    },
    filters: {
      title: 'Filtros',
      search: 'Busca',
      searchPlaceholder: 'Cliente, número da fatura, descrição...',
      minAmount: 'Valor mínimo',
      maxAmount: 'Valor máximo',
      issueDateFrom: 'Emissão de',
      issueDateTo: 'Emissão até',
      unclassifiedOnly: 'Faturas sem classificação',
      sourceGroupExclude: 'Excluir grupo de origem',
      clearAll: 'Limpar todos',
      activeFilters: 'Filtros ativos:',
      apply: 'Aplicar',
      customerPlaceholder: 'Selecionar clientes',
      invoicePlaceholder: 'Filtrar por fatura...',
      descriptionPlaceholder: 'Filtrar por descrição...',
      amountPlaceholder: 'Valor',
      dueDatePlaceholder: 'Período de vencimento',
      invoiceIssueDatePlaceholder: 'Período de emissão da fatura',
      fiscalNoteIssueDatePlaceholder: 'Período de emissão da NF',
      fiscalNoteAll: 'Todas',
      fiscalNoteWith: 'Com NF',
      fiscalNoteWithout: 'Sem NF',
      glPostingAll: 'Todas',
      glPostingPosted: 'Postadas',
      glPostingNotPosted: 'Não postadas',
      minCharsHint: 'Mínimo de {{count}} caracteres.',
      amountOperators: {
        eq: 'Igual',
        gte: 'Maior ou igual',
        lte: 'Menor ou igual',
        eqSymbol: '=',
        gteSymbol: '≥',
        lteSymbol: '≤',
      },
    },
    table: {
      customer: 'Cliente',
      customerCode: 'Código do cliente',
      customerTaxId: 'CNPJ/CPF',
      entityName: 'Entidade',
      invoice: 'Fatura',
      externalRef: 'Referência externa',
      status: 'Status',
      description: 'Descrição',
      grossAmount: 'Valor bruto',
      amount: 'Valor líquido',
      withholding: 'Retenções',
      currency: 'Moeda',
      sourceGroup: 'Grupo de origem',
      dueDate: 'Vencimento',
      expectedCashDate: 'Previsão de caixa',
      competencyDate: 'Competência',
      managerialDate: 'Data gerencial',
      invoiceIssueDate: 'Emissão da fatura',
      fiscalNoteIssueDate: 'Data Emissão NF',
      fiscalNoteNumber: 'Nº NF',
      revenueAccount: 'Conta contábil',
      revenueGlAccountName: 'Conta contábil (nome)',
      fiscalNote: 'NF',
      glPosting: 'Postado no razão',
      externalFiscalNote: 'NF externa',
      actions: 'Ações',
      noResults: 'Nenhuma fatura em pré-faturamento encontrada.',
      loading: 'Carregando faturas em pré-faturamento...',
      hasFiscalNote: 'NF vinculada',
      noFiscalNote: 'Sem NF',
      missingFiscalNoteAlert: 'Sem NF',
      fiscalPending: 'Fiscal pendente',
      glPosted: 'Sim',
      glNotPosted: 'Não',
      sortAsc: 'crescente',
      sortDesc: 'decrescente',
      sortBy: 'Ordenar por {{field}}{{direction}}',
      sortTooltip: 'Clique para ordenar. Shift+clique para ordenação secundária.',
      filterColumnTooltip: 'Clique para filtrar por essa coluna',
      filterCustomerTooltip: 'Clique para filtrar clientes',
      groupSummary: '{{count}} faturas · bruto {{gross}} · líquido {{net}}',
      groupInvoiceCount: '{{count}} faturas',
      groupGrossLabel: 'bruto',
      groupNetLabel: 'líquido',
      collapseGroup: 'Recolher faturas de {{label}}',
      expandGroup: 'Expandir faturas de {{label}}',
      selectGroupInvoices: 'Selecionar faturas de {{label}}',
      selectCustomerInvoices: 'Selecionar faturas de {{customer}}',
      dueInDays: '{{count}} dias',
      dueOverdue: '{{count}} dias em atraso',
      dueToday: 'vence hoje',
      settledByRetention: 'Liquidada por retenção',
      aggregate: 'Agregadora',
      aggregatePeriod: 'Agregadora · {{period}}',
      paid: 'Paga',
      paidOn: 'Paga em {{date}}',
    },
    density: {
      decrease: 'Diminuir tamanho da tabela',
      increase: 'Aumentar tamanho da tabela',
    },
    groups: {
      expandAll: 'Expandir tudo',
      collapseAll: 'Minimizar tudo',
      groupByLabel: 'Agrupar por',
      noDueDate: 'Sem vencimento',
      noIssueDate: 'Sem emissão',
      noService: 'Sem serviço',
      noPropertyGroup: 'Sem grupo de propriedades',
      propertyGroup: 'Grupo {{id}}',
      propertyGroupIdOnly: 'só o ID (o feed não traz o nome)',
      gross: 'bruto',
      net: 'líquido',
      invoice_one: 'fatura',
      invoice_other: 'faturas',
      by: {
        customer: 'Cliente',
        dueDate: 'Vencimento',
        issueDate: 'Emissão',
        service: 'Serviço',
        propertyGroup: 'Grupo de propriedades',
        none: 'Sem agrupamento',
      },
    },
    columns: {
      aria: 'Colunas da tabela',
      title: 'Colunas',
      defaultsHint: 'Marque ou desmarque as colunas exibidas na tabela.',
      reorderHint: 'Arraste pela alça para alterar a ordem das colunas na tabela.',
      resetOrder: 'Restaurar ordem padrão',
      dragHandleAria: 'Reordenar coluna',
      dataType: {
        date: 'Data',
        text: 'Texto',
        status: 'Status',
        currency: 'Valor',
        classification: 'Classificação',
        boolean: 'Sim/Não',
        actions: 'Ações',
      },
    },
    actions: {
      openDetails: 'Editar detalhes',
      openInvoiceDetails: 'Detalhes',
      rowMenu: 'Ações de {{number}}',
      reconciliation: 'Ver conciliação',
      cancelInvoice: 'Cancelar fatura',
      approve: 'Aprovar',
      approveAllDrafts: 'Aprovar todos os rascunhos',
      blockedApproveHint:
        'Fatura bloqueada. Corrija o motivo nos detalhes antes de aprovar novamente.',
      classificationRequiredHint:
        'Classifique contabilmente a fatura antes de aprovar ou emitir a NFS-e.',
      approveSelected: 'Aprovar selecionadas',
      delete: 'Excluir',
      deleteSelected: 'Excluir selecionadas',
      classifyMenu: 'Classificar',
      bulkActions: 'Ações em lote',
      postToGl: 'Postar Razão',
      postingToGl: 'Postando...',
      bill: 'Faturar',
      billAndPost: 'Faturar e Postar',
      billing: 'Faturando...',
      classifySelected: 'Classificar selecionadas',
      classifyAll: 'Classificar todas como...',
      overwriteRevenueAccount: 'Sobrescrever contas existentes',
      linkServiceMenu: 'Vincular serviço',
      selectService: 'Selecione o serviço',
      overwriteService: 'Sobrescrever serviços existentes',
      linkServiceSelected: 'Vincular selecionadas',
      dueDateMenu: 'Vencimento',
      dueDateSelected: 'Alterar vencimento das selecionadas',
      cancel: 'Cancelar',
      canceling: 'Cancelando...',
      saving: 'Salvando...',
      approving: 'Aprovando...',
      generatingNfse: 'Gerando NFS',
      deleting: 'Excluindo...',
      bulk: {
        countBadge: '{{count}} faturas',
        back: 'Voltar',
        classifyTitle: 'Classificar conta',
        classifyDescription: 'Atribuir conta do plano de contas',
        classifyBlockedDescription: 'Nenhuma fatura selecionada está elegível para classificação.',
        classifyAccountLabel: 'Conta contábil',
        classifyConfirm: 'Classificar {{count}}',
        overwriteRevenueAccountHint: 'Substitui classificações já feitas no lote',
        linkServiceTitle: 'Vincular serviço',
        linkServiceDescription: 'Associar a um serviço cadastrado',
        serviceLabel: 'Serviço',
        linkServiceConfirm: 'Vincular {{count}}',
        overwriteServiceHint: 'Substitui vínculos já feitos no lote',
        dueDateTitle: 'Alterar vencimento',
        dueDateDescription: 'Definir nova data para o lote',
        dueDateLabel: 'Novo vencimento',
        dueDateHint: 'Aplica a mesma data a todas as faturas do lote.',
        dueDateConfirm: 'Alterar {{count}}',
        managementDatesTitle: 'Alterar datas gerenciais',
        managementDatesDescription: 'Definir competência e/ou data gerencial',
        competencyDateLabel: 'Competência',
        managerialDateLabel: 'Data gerencial',
        managementDatesHint:
          'Preencha ao menos um campo. Apenas os campos informados serão atualizados.',
        managementDatesConfirm: 'Alterar {{count}}',
        recalculateTaxesTitle: 'Recalcular tributos',
        recalculateTaxesDescription: 'Atualizar tributos conforme a configuração fiscal atual',
        recalculateTaxesHint:
          'Os valores fiscais e as parcelas das faturas elegíveis serão recalculados e registrados no histórico.',
        recalculateTaxesConfirm: 'Recalcular {{count}}',
        billTitle: 'Faturar',
        billDescription: 'Gerar fatura para as contas',
        cancelTitle: 'Cancelar faturas',
        cancelDescription: 'Anular as selecionadas que ainda podem ser canceladas',
        billBlockedDescription: 'Nenhuma fatura selecionada está elegível para faturamento.',
        clearUploadedFiscalNoteTitle: 'Limpar NF anexada',
        clearUploadedFiscalNoteDescription: 'Remover a NF enviada de {{count}} fatura(s)',
        deleteTitle: 'Excluir',
        deleteDescription: 'Remover contas selecionadas',
        cancelBlockedDescription: 'Nenhuma fatura selecionada pode ser cancelada.',
      },
    },
    import: {
      processingHint: 'Aguarde enquanto as faturas são importadas.',
    },
    views: {
      label: 'Visões do pré-faturamento',
      all: 'Todas',
      drafts: 'Rascunhos',
      awaitingNf: 'Aguardando NF',
      blocked: 'Bloqueadas',
      issuedUnposted: 'Emitidas sem razão',
    },
    dialogs: {
      approveAllDraftsTitle: 'Aprovar todos os rascunhos?',
      approveAllDraftsCount: '{{count}} de {{total}} rascunhos',
      approveAllDraftsStale_one: '{{count}} desatualizado precisa de revisão',
      approveAllDraftsStale_other: '{{count}} desatualizados precisam de revisão',
      approveAllDraftsOther_one: '{{count}} fica de fora (agregadora ou já contabilizada)',
      approveAllDraftsOther_other: '{{count}} ficam de fora (agregadoras ou já contabilizadas)',
      approveSkipped: '{{skipped}} de {{total}} selecionadas ficam de fora: {{reasons}}.',
      skipAggregate: 'agregadora (aprovada no próprio diálogo)',
      skipPosted: 'já contabilizada',
      skipUnclassified: 'sem classificação contábil',
      skipStatus: 'status que não se aprova',
      back: 'Voltar',
      emitNfseTitle: 'Emitir a NFS-e?',
      emitNfseDescription:
        'A NFS-e de {{count}} fatura(s) será enviada à prefeitura. Uma nota emitida só é desfeita pelo cancelamento.',
      emitNfseConfirm: 'Emitir',
      rowApproveTitle: 'Aprovar esta fatura?',
      rowDeleteTitle: 'Excluir esta fatura?',
      rowDeleteDescription:
        'A fatura será excluída do pré-faturamento. Essa ação não pode ser desfeita.',
      rowCancelTitle: 'Cancelar esta fatura?',
      approveAllDraftsChanged:
        'A fila mudou desde que esta confirmação abriu. Confira a nova contagem e aprove de novo.',
      approveAllDraftsDescription:
        '{{count}} faturas em rascunho serão enfileiradas para aprovação, emissão da NFS-e e contabilização. O processamento continuará em segundo plano; acompanhe os resultados e erros no lote.',
      approveClassificationRequired:
        '{{count}} fatura(s) sem classificação contábil. Classifique-as antes de aprovar o lote.',
      approveClassificationUnknown:
        'Não foi possível verificar as faturas sem classificação contábil. Feche e tente de novo.',
      approveTitle: 'Aprovar faturas selecionadas?',
      approveDescription:
        'A NF será enviada para emissão e, após autorização, a fatura será provisionada no razão.',
      approveDescriptionPlural:
        '{{count}} faturas terão a NF enviada para emissão e, após autorização, serão provisionadas no razão.',
      // A selection that holds a cycle other than Padrão: each invoice gets its NF the way its
      // cycle says, so the dialog does not promise an emission at approval.
      approveDescriptionByCycle:
        'A fatura será provisionada no razão e a NF segue o ciclo de receita dela: enviada para emissão agora, após o recebimento ou emitida fora do Alchemy ERP.',
      approveDescriptionByCyclePlural:
        '{{count}} faturas serão provisionadas no razão. A NF de cada uma segue o ciclo de receita da fatura: enviada para emissão agora, após o recebimento ou emitida fora do Alchemy ERP.',
      deleteTitle: 'Excluir faturas selecionadas?',
      deleteDescription:
        'As faturas selecionadas serão excluídas do pré-faturamento. Essa ação não pode ser desfeita.',
      cancelTitle: 'Cancelar faturas selecionadas?',
      cancelDescription: 'A fatura será anulada e não poderá mais ser aprovada ou editada.',
      cancelDescriptionPlural:
        '{{count}} faturas serão anuladas e não poderão mais ser aprovadas ou editadas.',
      clearUploadedFiscalNoteTitle: 'Limpar NFs anexadas?',
      clearUploadedFiscalNoteDescription:
        'A NF enviada será removida de {{count}} fatura(s). Os valores, a moeda e as datas das faturas não serão alterados.',
      clearUploadedFiscalNoteFailureItem: 'Fatura {{invoiceId}}: {{error}}',
      confirm: 'Confirmar',
      cancel: 'Cancelar',
      retry: 'Tentar novamente',
      close: 'Fechar',
    },
    toasts: {
      updateSuccess: 'Fatura atualizada com sucesso.',
      updateError: 'Não foi possível atualizar a fatura.',
      revenueAccountUpdated: 'Conta de receita atualizada com sucesso.',
      revenueAccountError: 'Não foi possível atualizar a conta de receita.',
      revenueAccountRequired: 'Selecione uma conta de receita.',
      revenueAccountNoEligible: 'Nenhuma fatura elegível para classificar.',
      revenueAccountBatchSuccess: '{{count}} fatura(s) classificadas com sucesso.',
      revenueAccountPartial:
        '{{success}} classificada(s), {{failed}} falha(s). Verifique os itens com erro.',
      revenueAccountBatchError: 'Não foi possível classificar as faturas.',
      serviceRequired: 'Selecione um serviço.',
      serviceNoEligible: 'Nenhuma fatura elegível para vincular serviço.',
      serviceBatchSuccess: '{{count}} fatura(s) vinculada(s) ao serviço com sucesso.',
      servicePartial: '{{success}} vinculada(s), {{failed}} falha(s). Verifique os itens com erro.',
      serviceBatchError: 'Não foi possível vincular o serviço às faturas.',
      dueDateRequired: 'Selecione uma data de vencimento.',
      dueDateNoEligible: 'Nenhuma fatura em rascunho selecionada para alterar o vencimento.',
      dueDateBatchSuccess: '{{count}} fatura(s) com vencimento atualizado com sucesso.',
      dueDatePartial:
        '{{success}} atualizada(s), {{failed}} falha(s). Verifique os itens com erro.',
      dueDateBatchError: 'Não foi possível atualizar o vencimento das faturas.',
      managementDatesRequired: 'Informe ao menos competência ou data gerencial.',
      managementDatesNoEligible:
        'Nenhuma fatura em rascunho selecionada para alterar datas gerenciais.',
      managementDatesBatchSuccess: '{{count}} fatura(s) com datas gerenciais atualizadas.',
      managementDatesPartial:
        '{{success}} atualizada(s), {{failed}} falharam. Revise os itens com erro.',
      managementDatesBatchError: 'Não foi possível atualizar as datas gerenciais das faturas.',
      recalculateTaxesNoEligible: 'Nenhuma fatura em rascunho selecionada para recalcular.',
      recalculateTaxesBatchSuccess: '{{count}} fatura(s) recalculada(s) com sucesso.',
      recalculateTaxesPartial:
        '{{success}} recalculada(s), {{failed}} falharam. Revise os itens com erro.',
      recalculateTaxesBatchError: 'Não foi possível recalcular os tributos das faturas.',
      recalculateTaxesBatchLimit: 'Selecione no máximo {{max}} faturas por recalculo em lote.',
      recalculateTaxesFailureItem: 'Fatura {{invoiceId}}: {{reason}}',
      recalculateTaxesUnknownError: 'Erro desconhecido ao recalcular tributos.',
      clearUploadedFiscalNoteSuccess: 'NF removida de {{count}} fatura(s).',
      clearUploadedFiscalNotePartial:
        'NF removida de {{success}} fatura(s); {{failed}} não puderam ser alteradas.',
      clearUploadedFiscalNoteError: 'Não foi possível limpar as NFs anexadas.',
      openInvoice: 'Abrir fatura',
      approveSuccess: 'A NF foi enviada para emissão, após o sucesso, será postada no razão.',
      approveBatchSuccess:
        '{{count}} fatura(s) aprovada(s). A NF foi enviada para emissão e, após autorização, serão postadas no razão.',
      approveBatchPartial:
        '{{success}} aprovada(s), {{failed}} falha(s). Verifique os itens com erro.',
      approveBatchFailureReason: '{{count}} fatura(s) não aprovada(s): {{reason}}',
      approveError: 'Não foi possível aprovar a fatura.',
      postToGlSuccess: '{{count}} fatura(s) postada(s) no GL.',
      postToGlPartial: '{{success}} postada(s), {{failed}} falha(s). Verifique os itens com erro.',
      postToGlPartialWithReason: '{{success}} postada(s), {{failed}} falha(s). {{reason}}',
      postToGlAllFailed: 'Não foi possível postar as faturas no GL.',
      postToGlAllFailedWithReason: 'Não foi possível postar as faturas no GL: {{reason}}',
      fiscalConfigRequiredForTaxProvisioning:
        'Configuração fiscal da entidade é obrigatória para provisionamento de impostos. Configure e tente novamente.',
      goToFiscalSettings: 'Ir para configuração fiscal',
      glPostingReasons: {
        invoiceNotFound: 'Fatura não encontrada.',
        invoiceAlreadyPosted: 'A fatura já foi postada no GL.',
        missingRevenueAccount: 'A fatura não possui conta de receita configurada.',
        missingEntity: 'A fatura não possui empresa vinculada.',
        missingCustomer: 'A fatura não possui cliente vinculado.',
        missingIssueDate: 'A fatura não possui data de emissão.',
        invalidInvoiceAmount: 'A fatura precisa ter valor total positivo.',
        invalidCustomerOffsetSettings:
          'As configurações de conta de offset de cliente estão inválidas.',
        missingCustomerOffsetSettings:
          'Configure o mapeamento da conta-raiz de clientes (contas a receber) em Configurações → Contabilidade e Fiscal → Mapeamento de contas (aba AR).',
        noOpenPeriod:
          'Não há período contábil aberto para a data de emissão da fatura/nota fiscal em nenhum livro. Abra esse período e tente novamente.',
        entityWithoutBooks: 'A empresa não possui livros contábeis configurados para postagem.',
        invalidInvoiceStatus:
          'A fatura precisa estar com status Emitida, Paga ou Parcialmente Paga para postar no GL.',
      },
      postToGlError: 'Não foi possível postar as faturas no GL.',
      billSuccess: '{{count}} fatura(s) faturada(s) com sucesso.',
      billPartial: '{{success}} faturada(s), {{failed}} falha(s). Verifique os itens com erro.',
      billError: 'Não foi possível faturar as faturas.',
      cancelSuccess: '{{count}} fatura(s) cancelada(s) com sucesso.',
      cancelPartial: '{{success}} cancelada(s), {{failed}} falha(s). Verifique os itens com erro.',
      cancelError: 'Não foi possível cancelar as faturas.',
      deleteSuccess: 'Fatura excluída com sucesso.',
      deleteBatchSuccess: '{{count}} fatura(s) excluída(s) com sucesso.',
      deleteError: 'Não foi possível excluir a fatura.',
      importSuccess: '{{created}} criada(s), {{updated}} atualizada(s).',
      importPartial:
        'Importação concluída com {{errors}} erro(s). {{created}} criada(s), {{updated}} atualizada(s).',
    },
    selection: {
      selected: '{{count}} fatura selecionada',
      selectedPlural: '{{count}} faturas selecionadas',
      total: 'Total selecionado',
    },
    pagination: {
      showing: 'Mostrando {{start}}-{{end}} de {{total}}',
      noResults: 'Nenhum resultado',
      page: 'Página {{current}} de {{total}}',
      previous: 'Anterior',
      next: 'Próxima',
      itemsPerPage: 'Itens por página',
      itemsPerPageOption: '{{count}} / página',
    },
  },
  fiscalNoteUpload: {
    help: 'Como anexar a nota',
    verification: {
      processing: 'Conferindo dados…',
      success: 'Dados conferidos',
      failed: 'Não foi possível conferir os dados',
      back: 'Voltar',
      retry: 'Tentar novamente',
    },
    steps: {
      document: '1. Documento',
      review: '2. Conferência',
      processing: 'Anexando',
      success: 'Concluído',
      error: 'Não foi possível anexar',
      discard: 'Descartar alterações',
    },
    extraction: {
      processing: 'Lendo o PDF…',
      ready: 'Dados extraídos',
      review: 'Confira os campos antes de continuar.',
      failed: 'Não foi possível ler o PDF',
      retry: 'Tentar leitura novamente',
      warnings: {
        REVIEW_REQUIRED: 'Confira os dados extraídos.',
        MISSING_FIELDS: 'Complete os campos não identificados.',
        LOW_CONFIDENCE: 'Alguns dados precisam de conferência.',
        ISSUER_MISMATCH: 'O emitente difere da entidade da fatura.',
        RECIPIENT_MISMATCH: 'O tomador difere do cliente da fatura.',
        WITHHOLDINGS_REQUIRE_REVIEW: 'Confira as retenções no PDF.',
      },
    },
    lifecycle: {
      processing: 'Anexando documento e aplicando os dados conferidos…',
      success: 'Nota {{number}} anexada. Os dados conferidos foram salvos.',
      failed: 'Não foi possível anexar a nota',
      errorDetails: 'Código do erro',
      close: 'Concluir',
      retry: 'Revisar e tentar novamente',
      refreshError: 'A nota foi anexada. Recarregue a conta para atualizar os dados exibidos.',
      discardTitle: 'Descartar os dados conferidos?',
      discardDescription:
        'O PDF e os dados informados ainda não foram anexados. Ao sair, será necessário informá-los novamente.',
      discardConfirm: 'Descartar e sair',
      keepEditing: 'Continuar conferindo',
    },
    manual: {
      select: 'Selecione',
      xmlMode: 'XML assinado',
      pdfMode: 'Somente PDF',
      pdfRequired: 'PDF da nota',
      reviewAction: 'Conferir dados',
      warningTitle: 'Assinatura não verificada',
      warning:
        'Confira no PDF a chave, as partes, a emissão, o valor e todos os tributos. A assinatura digital e a situação na prefeitura não serão verificadas. Um XML inválido não será utilizado neste envio.',
      reviewed: 'Conferi os dados e a situação da nota.',
      reviewHelp: 'O que estou confirmando?',
      reviewedDetails:
        'Conferi os dados e tributos no PDF e confirmo que a nota foi emitida e não está cancelada.',
      documentType: 'Tipo de NFS-e',
      national: 'NFS-e nacional',
      municipal: 'NFS-e municipal',
      documentNumber: 'Número da nota',
      accessKey: 'Chave de acesso / identificação',
      issueDate: 'Data de emissão',
      issuerTaxId: 'CNPJ do emitente',
      recipientTaxId: 'CPF/CNPJ do tomador',
      totalAmount: 'Valor bruto',
      issScenario: 'Tratamento do ISS',
      issAmount: 'Valor do ISS',
      irrfAmount: 'IRRF retido',
      pisAmount: 'PIS retido',
      cofinsAmount: 'COFINS retido',
      csllAmount: 'CSLL retida',
      inssAmount: 'INSS retido',
      csrf: {
        label: 'CSRF retido na NFS-e',
        invoiceSum: 'PIS + COFINS + CSLL da fatura',
        pis: 'PIS',
        cofins: 'COFINS',
        csll: 'CSLL',
        confirmInvoiceBreakdown:
          'Confirmo que o total agregado da NFS-e confere e autorizo usar a divisão de PIS, COFINS e CSLL calculada na fatura.',
        matches: 'O total da NFS-e confere com o detalhamento fiscal da fatura.',
        mismatch:
          'O total da NFS-e não confere com a fatura. Corrija a configuração fiscal da fatura ou anexe a nota correta.',
      },
      sourceLabel: 'PDF conferido manualmente · sem verificação de assinatura',
      scenarios: {
        ISS_OWED: 'ISS próprio',
        ISS_RETAINED: 'ISS retido',
        EXEMPT: 'Isento / não incidente',
        SIMPLES: 'Simples Nacional',
      },
    },

    title: 'Anexar {{document}} emitida',
    description:
      'A {{document}} precisa ter sido emitida por esta entidade, para este cliente e na mesma moeda da fatura. Envie o XML assinado ou o PDF para extrair os dados. Confira e corrija os campos antes de anexar. Se os valores forem diferentes, você poderá aplicá-los à fatura após conferência.',
    document: {
      nfse: 'NFS-e',
      cfdi: 'CFDI',
    },
    fields: {
      xml: 'XML da {{document}}',
      xmlHint:
        'Obrigatório. XML autorizado com assinatura digital, como baixado do portal ou do PAC.',
      pdf: 'PDF (opcional)',
    },
    actions: {
      verify: 'Verificar',
      back: 'Trocar arquivo',
      attach: 'Anexar',
      applyAmounts: 'Aplicar valores da NFS-e',
      cancel: 'Cancelar',
    },
    preview: {
      title: 'Confira antes de anexar',
      number: 'Número',
      issueDate: 'Emissão',
      total: 'Valor',
      issuer: 'Emitente',
      recipient: 'Tomador',
      accessKey: 'Chave',
      reuses:
        'Este documento já consta no sistema (recebido por integração). Ele será apenas vinculado.',
    },
    amountConfirmation: {
      title: 'Os valores são diferentes',
      description:
        'Ao confirmar, os valores, impostos, retenções, itens, classificações e parcelas da fatura serão ajustados para refletir o documento fiscal.',
      invoice: 'Fatura atual',
      document: 'Documento enviado',
      tax: 'ISS próprio',
      withholding: 'Retenções',
      net: 'Líquido',
    },
    toasts: {
      attached:
        'Documento {{number}} anexado (emitido em {{issueDate}}). Aprove a fatura para lançar.',
    },
    signatureErrors: {
      MALFORMED_XML:
        'Não foi possível ler a estrutura do XML. Baixe o arquivo novamente no portal emissor e envie sem editar.',
      SIGNATURE_MISSING:
        'O XML não contém assinatura digital. Baixe o XML autorizado no portal emissor.',
      CERTIFICATE_MISSING:
        'A assinatura do XML não inclui um certificado válido. Solicite o XML autorizado completo ao emissor.',
      WEAK_ALGORITHM:
        'A assinatura do XML usa um algoritmo não aceito. Solicite ao emissor um XML com assinatura compatível.',
      SIGNATURE_INVALID:
        'A assinatura digital não corresponde ao conteúdo do XML. Baixe o arquivo original novamente e envie sem editar.',
      CERTIFICATE_EXPIRED:
        'O certificado da assinatura está fora do período de validade. Solicite a análise do documento ao suporte.',
      CERTIFICATE_UNTRUSTED:
        'Não foi possível validar a cadeia de confiança do certificado. Solicite ao suporte a verificação da configuração ICP-Brasil e do certificado do emissor.',
      SIGNED_CONTENT_INCOMPLETE:
        'A assinatura não cobre todos os dados necessários da NFS-e. Solicite a análise do XML original ao suporte.',
    },
    errors: {
      generic: 'Não foi possível anexar o documento. Tente novamente.',
      invalidPdf: 'Selecione um PDF válido de até 5 MB.',
      AR_FISCAL_NOTE_PDF_EXTRACTION_FAILED:
        'Não foi possível ler o PDF. Tente novamente ou preencha os dados.',
      AR_FISCAL_NOTE_PDF_DOCUMENT_UNSUPPORTED: 'Selecione o PDF de uma NFS-e emitida.',
      AR_FISCAL_NOTE_UPLOAD_MANUAL_INVALID:
        'Informe um PDF e confira os campos obrigatórios, a data de emissão, o valor bruto positivo e os tributos. As retenções não podem superar o bruto; ISS isento ou Simples deve ter valor zero.',
      AR_FISCAL_NOTE_UPLOAD_MANUAL_REVIEW_REQUIRED:
        'Confirme a conferência dos dados e de todos os tributos no PDF antes de anexar.',
      AR_FISCAL_NOTE_UPLOAD_MANUAL_EXISTING_NOTE:
        'Esta chave já está cadastrada. Use o XML verificado ou vincule a nota existente; o PDF manual não substitui os dados fiscais já registrados.',
      AR_FISCAL_NOTE_UPLOAD_INVALID_STATUS:
        'Só é possível anexar em fatura em rascunho ou bloqueada.',
      AR_FISCAL_NOTE_UPLOAD_ALREADY_HAS_NOTE:
        'Esta fatura já tem um documento fiscal ativo. Cancele ou desvincule o atual antes de anexar outro.',
      AR_FISCAL_NOTE_UPLOAD_COUNTRY_UNSUPPORTED:
        'Anexo de documento emitido fora só está disponível para entidades do Brasil e do México.',
      AR_FISCAL_NOTE_UPLOAD_XML_INVALID:
        'O conteúdo assinado não foi reconhecido como NFS-e (São Paulo, Nacional ou ABRASF) com chave, data e valor. Verifique o arquivo.',
      AR_FISCAL_NOTE_UPLOAD_UNSIGNED:
        'Não foi possível verificar a assinatura digital e a cadeia de confiança do XML. Envie o XML autorizado, como baixado do portal ou do PAC.',
      AR_FISCAL_NOTE_UPLOAD_ISSUER_MISMATCH:
        'O documento foi emitido por {{issuerTaxId}}, que não é a entidade desta fatura.',
      AR_FISCAL_NOTE_UPLOAD_RECIPIENT_MISMATCH:
        'O documento foi emitido para {{recipientTaxId}}, que não é o cliente desta fatura.',
      AR_FISCAL_NOTE_UPLOAD_CURRENCY_MISMATCH:
        'O documento está em {{documentCurrency}} e a fatura em {{invoiceCurrency}}.',
      AR_FISCAL_NOTE_UPLOAD_TOTAL_MISMATCH:
        'O valor do documento ({{documentTotal}}) é diferente do valor da fatura ({{invoiceTotal}}). Corrija a fatura ou envie o documento certo.',
      AR_FISCAL_NOTE_UPLOAD_AMOUNT_CONFIRMATION_REQUIRED:
        'Os valores do documento são diferentes. Confira a comparação e confirme a aplicação dos valores antes de anexar.',
      AR_FISCAL_NOTE_UPLOAD_ISS_MISMATCH:
        'O ISS declarado no documento ({{documentIss}}) é diferente do ISS calculado para a fatura ({{invoiceIss}}). Recalcule os impostos da fatura ou envie o documento certo.',
      AR_FISCAL_NOTE_UPLOAD_TAX_MISMATCH:
        'O IVA do documento é diferente do total de impostos da fatura. Recalcule os impostos ou envie o documento certo.',
      AR_FISCAL_NOTE_UPLOAD_FISCAL_PARAMETERS_MISSING:
        'A fatura está sem parâmetros fiscais (serviço, alíquota). Complete os dados fiscais antes de anexar.',
      AR_FISCAL_NOTE_UPLOAD_ALREADY_LINKED: 'Este documento já está vinculado a outra fatura.',
      AR_FISCAL_NOTE_UPLOAD_NOTE_CANCELLED:
        'Este documento consta como cancelado e não pode ser anexado.',
      AR_FISCAL_NOTE_UPLOAD_EMISSION_IN_PROGRESS:
        'Há uma emissão de NFS-e em andamento ({{emissionStatus}}) para esta fatura. Aguarde ou cancele a emissão antes de anexar.',
      AR_FISCAL_NOTE_UPLOAD_CONCURRENT_CHANGE:
        'A fatura mudou enquanto o documento era anexado. Recarregue e tente de novo.',
      AR_FISCAL_NOTE_UPLOAD_CFDI_NOT_INGRESO:
        'Só um CFDI de ingreso (tipo I) pode ser anexado a um recebível.',
      AR_FISCAL_NOTE_UPLOAD_FILE_REQUIRED: 'Selecione o XML do documento.',
      AR_INVOICE_ISSUE_FISCAL_NOTE_MISMATCH:
        'O documento anexado não bate mais com o valor ou a moeda da fatura. Anexe o documento certo ou corrija a fatura antes de aprovar.',
    },
  },
  nfseEmission: {
    title: 'Emissão NFSe',
    currentStatus: 'Status',
    providerSubtitle: '{{mode}} · via FocusNFe',
    providerOnly: 'via FocusNFe',
    settingsHint: 'Configure a integração FocusNFe em',
    mode: {
      NACIONAL: 'Nacional',
      MUNICIPAL: 'Municipal',
    },
    environment: {
      homologacao: 'Homologação',
      producao: 'Produção',
    },
    status: {
      none: 'Não iniciada',
      PENDING: 'Pendente',
      PROCESSING: 'Processando',
      AUTHORIZED: 'Autorizada',
      CANCELLING: 'Cancelando',
      ERROR: 'Erro',
      CANCELLED: 'Cancelada',
    },
    actions: {
      emit: 'Emitir NFSe',
      retry: 'Reemitir NFSe',
      openPdf: 'Abrir DANFSe',
      openSettings: 'Configurações FocusNFe',
    },
    errors: {
      title: 'Falha na emissão',
    },
    toasts: {
      enqueued: 'Emissão de NFSe enfileirada.',
      emitError: 'Não foi possível solicitar a emissão da NFSe.',
      validationError: 'Dados fiscais incompletos para emissão da NFSe.',
      notConfigured: 'FocusNFe não configurada para esta entidade.',
      pdfError: 'Não foi possível abrir o PDF da NFSe.',
    },
  },
  nfseCancel: {
    title: 'Cancelar NFSe',
    confirmTitle: 'Confirmar cancelamento administrativo',
    retryTitle: 'Corrigir estorno contábil',
    description:
      'Selecione o tipo de cancelamento, confirme a justificativa e revise o estorno contábil linha a linha.',
    retryDescription:
      'A NFSe já foi cancelada na prefeitura. Ajuste a data e os lançamentos de estorno contábil para concluir o cancelamento.',
    justificativa: 'Justificativa (15 a 255 caracteres)',
    reversalDate: 'Data do estorno contábil',
    defaultKeepIss: 'ISS mantido por padrão',
    lineDebit: 'Débito {{amount}}',
    lineCredit: 'Crédito {{amount}}',
    balanced: 'balanceado',
    unbalanced: 'desbalanceado',
    bookBalance: 'D {{debit}} / C {{credit}} — {{balanced}}',
    balanceDifference: 'Diferença: {{amount}}',
    postingKindAccrual: 'Lançamento da fatura',
    postingKindIssReclass: 'Reclassificação de ISS provisionado',
    reissueFullReversalNote:
      'Na reemissão, o estorno é total, inclusive o ISS. A nova nota lança o valor novo e o próprio ISS.',
    reissueRequiresFullReversal:
      'Na reemissão, o estorno contábil precisa ser total: estorne cada lançamento por inteiro. Para manter parte do valor, escolha cancelar definitivamente.',
    reissueRequiresFullReversalRetry:
      'Na reemissão, o estorno contábil precisa ser total. As linhas já mostram o estorno total proposto: confirme para concluir o cancelamento.',
    postingKeptInFull:
      'Nenhuma linha será estornada — este lançamento permanece integralmente após o cancelamento.',
    noGlReversal:
      'Esta fatura não foi lançada na contabilidade. O cancelamento da NFSe não exige estorno contábil.',
    noGlReversalTitle: 'Nenhum estorno contábil necessário',
    result: {
      processing: 'Enviando solicitação de cancelamento…',
      requested: {
        title: 'Cancelamento solicitado',
        description:
          'A prefeitura ainda precisa processar a solicitação. Acompanhe o resultado nesta fatura.',
      },
      confirmed: {
        title: 'Cancelamento confirmado',
        description:
          'A NFSe e a fatura foram atualizadas. Você pode conferir o resultado na página da fatura.',
      },
      error: { title: 'Não foi possível concluir o cancelamento' },
      close: 'Fechar',
    },
    adjustmentDescription: 'Ajuste manual do estorno',
    cancellationStatus: 'Cancelamento: {{status}}',
    fields: {
      account: 'Conta',
      description: 'Descrição',
      debit: 'Débito',
      credit: 'Crédito',
      actions: 'Ações',
    },
    cancelType: {
      label: 'Tipo de cancelamento',
      direct: 'Direto (dentro do prazo)',
      administrative: 'Administrativo (após o prazo)',
    },
    postCancelAction: {
      label: 'Resultado após cancelamento',
      revertToDraft: 'Reverter para rascunho (editar e reemitir)',
      void: 'Cancelar definitivamente (void)',
    },
    actions: {
      openDialog: 'Cancelar NFSe',
      submit: 'Solicitar cancelamento',
      confirmAdministrative: 'Confirmar cancelamento',
      retryGlReversal: 'Corrigir estorno contábil',
      addAdjustment: 'Adicionar ajuste',
      next: 'Avançar',
      back: 'Voltar',
      cancel: 'Cancelar',
    },
    steps: {
      details: 'Cancelamento',
      detailsDesc: 'Tipo, justificativa e data do estorno',
      reversal: 'Estorno contábil',
      reversalDesc: 'Revise os lançamentos linha a linha',
    },
    status: {
      REQUESTED: 'Solicitado',
      PROCESSING: 'Processando',
      PENDING_ADMINISTRATIVE: 'Aguardando confirmação administrativa',
      GL_REVERSAL_ERROR: 'Erro no estorno contábil',
      CONFIRMED: 'Confirmado',
      FAILED: 'Falhou',
    },
    glReversalError: {
      title: 'NFSe cancelada — estorno contábil pendente',
      description:
        'A NFSe foi cancelada na prefeitura. Para concluir o cancelamento, corrija o estorno contábil.',
      reasonLabel: 'Motivo:',
      bookSuffix: ' no livro {{bookCode}}',
      reasons: {
        reversalDateBeforePosting:
          'A data do estorno é anterior à data do lançamento contábil original ({{date}}){{bookSuffix}}.',
        noOpenPeriod:
          'Não há período contábil aberto para a data do estorno{{bookSuffix}}. Abra o período ou escolha outra data.',
        insufficientLines: 'O estorno precisa ter pelo menos duas linhas por livro{{bookSuffix}}.',
        unbalanced: 'As linhas de estorno não estão balanceadas{{bookSuffix}}.',
        noActivePosting: 'Não há lançamento contábil ativo para estornar{{bookSuffix}}.',
        postingChanged:
          'Os lançamentos mudaram após a prévia ({{activePostingCount}} ativos; {{requestedPostingCount}} enviados). Refaça a prévia do estorno. Lançamento ativo: {{activePostingId}}.',
        postingChangedUnknown: 'Os lançamentos mudaram após a prévia. Refaça a prévia do estorno.',
        genericFinalizeFailure:
          'Não foi possível lançar o estorno contábil automaticamente. Revise a data e os lançamentos.',
        reissueRequiresFull:
          'A NFSe foi cancelada para reemissão, e a reemissão exige o estorno contábil total — o estorno solicitado era parcial. Abra “Corrigir estorno contábil” e confirme o estorno total proposto para concluir o cancelamento.',
      },
    },
    validation: {
      required: 'Campo obrigatório.',
      justificativa: 'A justificativa deve ter entre 15 e 255 caracteres.',
      justificativaMax: 'A justificativa deve ter no máximo 255 caracteres.',
      formIncomplete: 'Preencha todos os campos obrigatórios antes de continuar.',
      balance: 'Cada livro precisa ter pelo menos duas linhas e estar balanceado.',
      reversalDateBeforePosting:
        'A data do estorno não pode ser anterior à data do lançamento contábil original.',
    },
    tooltips: {
      cancelType:
        'Direto: cancelamento dentro do prazo municipal, processado automaticamente na prefeitura. Administrativo: após o prazo; a solicitação fica pendente até confirmação manual quando a prefeitura aceitar.',
      cancelTypeAria: 'Ajuda sobre o tipo de cancelamento',
      postCancelAction:
        'Reverter para rascunho: a fatura volta a rascunho para edição e nova emissão de NFSe. Cancelar definitivamente: a fatura é anulada (void) e não pode ser reemitida.',
      postCancelActionAria: 'Ajuda sobre o resultado após cancelamento',
      reversalDate:
        'Data em que o estorno contábil será lançado. Deve ser igual ou posterior à data do lançamento original.',
      reversalDateAria: 'Ajuda sobre a data do estorno contábil',
      reversalDateRetry:
        'Ajuste a data do estorno. Ela deve ser igual ou posterior à data do lançamento contábil original e cair em um período contábil aberto.',
      reversalDateRetryAria: 'Ajuda sobre correção da data do estorno contábil',
      justificativa:
        'Enviada à prefeitura via FocusNFe e registrada no histórico da fatura. Obrigatória para auditoria fiscal.',
      justificativaAria: 'Ajuda sobre a justificativa',
    },
    toasts: {
      previewError: 'Não foi possível carregar a prévia do estorno.',
      submitError: 'Não foi possível solicitar o cancelamento.',
      validationError: 'Revise os lançamentos de estorno antes de continuar.',
      requested: 'Cancelamento de NFSe enfileirado.',
      confirmed: 'Cancelamento administrativo confirmado e estorno lançado.',
      retrySuccess: 'Estorno contábil concluído e cancelamento finalizado.',
    },
  },
};

export const arEn = {
  collectionSettings: {
    title: 'Collection Settings',
    subtitle: 'Per-customer learned collection behavior',
    cardTitle: 'Collection behavior',
    lookbackInvoices: 'Settled invoices considered',
    lookbackInvoicesHint:
      'How many most-recent settled invoices feed the collection-behavior estimate (per customer, billing group, or tenant). Between 1 and 24.',
    lookbackInvoicesInvalid: 'Enter a whole number between 1 and 24.',
    save: 'Save',
    saving: 'Saving...',
    discard: 'Discard',
    lastUpdated: 'Last updated on {{date}} by {{user}}',
    noChangesRecorded: 'No changes recorded',
    loadError: 'Failed to load settings',
    saveSuccess: 'Settings saved',
    saveError: 'Failed to save settings',
  },
  invoiceApprovalSettings: {
    cardTitle: 'Invoice approval',
    cardDescription: 'Rules that approve invoices without a person clicking approve.',
    autoApproveTitle: 'Auto approve invoices issued outside Alchemy',
    autoApproveDescription:
      'When an invoice is created and every service on it has its fiscal note issued outside Alchemy, the system approves the invoice and books the revenue. If the approval fails, the invoice stays a draft and the reason shows in its history.',
    noPermission: 'Only people who can approve invoices can change this option.',
    save: 'Save',
    saving: 'Saving...',
    discard: 'Discard',
    lastUpdated: 'Last changed on {{date}}',
    noChangesRecorded: 'No changes recorded',
    loadErrorTitle: 'Could not load the setting',
    loadErrorDescription: 'Try again in a moment.',
    saveSuccess: 'Setting saved',
    saveError: 'Could not save the setting. Try again.',
    confirmLeave: {
      title: 'Discard changes?',
      description: 'You have unsaved changes. If you leave now, they will be lost.',
      confirm: 'Leave without saving',
      stay: 'Keep editing',
    },
  },
  arForecastSettings: {
    title: 'AR forecast — variable usage',
    subtitle: 'History window for projecting variable-item quantities',
    cardTitle: 'Usage projection',
    lookbackPeriods: 'Usage periods considered',
    lookbackPeriodsHint:
      'How many most-recent FINALIZED service periods feed the arithmetic-mean projected quantity for variable items. Between 1 and 24; default 3.',
    lookbackPeriodsInvalid: 'Enter a whole number between 1 and 24.',
    save: 'Save',
    saving: 'Saving...',
    discard: 'Discard',
    lastUpdated: 'Last updated on {{date}} by {{user}}',
    noChangesRecorded: 'No changes recorded',
    loadError: 'Failed to load settings',
    saveSuccess: 'Settings saved',
    saveError: 'Failed to save settings',
    systemUser: 'System',
  },
  expectedCash: {
    label: 'Expected cash',
    expectedOn: 'Expected on {{date}}',
    lowConfidence: 'Low confidence',
    highConfidence: 'High confidence',
    sourceCustomer: 'Customer history',
    sourceBillingGroup: 'Billing-group history',
    sourceTenant: 'Tenant history (same entity)',
    sourceNone: 'No history — due date',
    sampleSize: '{{count}} settled invoices in sample',
    installments: 'Installments',
    installment: 'Installment',
    dueDate: 'Due date',
    amount: 'Amount',
    paid: 'Paid',
    estimatedHint: 'Date estimated from learned collection behavior',
  },
  receipts: {
    title: 'Receipts',
    subtitle: 'Manage customer receipts',
    table: {
      receipt: 'Receipt',
      customer: 'Customer',
      method: 'Method',
      amount: 'Amount',
      allocation: 'Allocation',
      status: 'Status',
      noResults: 'No receipts found.',
      loading: 'Loading receipts...',
    },
    filters: {
      title: 'Filters',
      search: 'Search',
      searchPlaceholder: 'Customer, number, reference...',
      status: 'Status',
      paymentMethod: 'Payment Method',
      clearAll: 'Clear all',
      activeFilters: 'Active filters:',
      all: 'All',
    },
    types: {
      standard: 'Standard',
      transaction: 'Transaction',
      gtvTransaction: 'GTV transaction',
      aggregate: 'Aggregate',
    },
    statuses: {
      draft: 'Draft',
      posted: 'Posted',
      partiallyAllocated: 'Partial',
      fullyAllocated: 'Allocated',
      void: 'Void',
    },
    paymentMethods: {
      pix: 'PIX',
      ted: 'TED',
      boleto: 'Boleto',
      card: 'Card',
    },
    stats: {
      totalReceived: 'Total Received',
      allocated: 'Allocated',
      pending: 'Pending',
      reconciled: 'Reconciled',
      receipts: 'receipts',
    },
    empty: {
      title: 'No receipts found',
      description: 'No receipts match the selected filters.',
    },
    selection: {
      selected: '{{count}} receipt selected',
      selectedPlural: '{{count}} receipts selected',
      export: 'Export',
      allocateToInvoices: 'Allocate to invoices',
    },
    details: {
      reviewReconciliation: 'Review reconciliation',
      reviewReconciliationHint:
        'Undoes the bank reconciliation and its linked allocations and entries. It does not record a bank refund.',
    },
    pagination: {
      showing: 'Showing {{start}}–{{end}} of {{total}}',
      noResults: 'No results',
      pageSize: 'Page size:',
      page: 'Page {{current}} of {{total}}',
      previous: 'Previous',
      next: 'Next',
    },
  },
  debitNotes: {
    title: 'Debit notes',
    subtitle: 'Bill back client-reimbursable expenses',
    loading: 'Loading...',
    featureDisabled:
      'Client-reimbursable expenses are not enabled for this tenant. Enable them in global approval settings.',
    tabs: {
      notes: 'Notes',
      customers: 'By customer',
    },
    eligible: {
      title: 'Eligible expenses',
      create: 'Generate debit note',
      empty: 'No open reimbursable expenses.',
    },
    customers: {
      title: 'Customers with reimbursable expenses',
      empty: 'No customers have open reimbursable expenses.',
      openCustomer: 'Open customer details',
    },
    customerDetail: {
      title: 'Customer detail',
      selectCustomer: 'Select a customer to view reimbursable expenses.',
      empty: 'No expenses found for this customer.',
      emptyFiltered: 'No expenses in this status.',
      summary:
        '{{count}} bills · future {{future}} · pending {{pending}} · reimbursed {{reimbursed}}',
      summaryExtended:
        '{{count}} bills · future {{future}} · ready {{ready}} · pending {{pending}} · reimbursed {{reimbursed}}',
      modalTitle: 'Customer reimbursable expenses',
      modalTitleWithCustomer: 'Reimbursable Expenses · {{customerName}}',
      modalDescription: 'Select ready expenses to generate a debit note.',
      tabs: {
        all: 'All',
        ready: 'Ready',
        future: 'Future',
        pending: 'In note',
        reimbursed: 'Reimbursed',
      },
      stats: {
        ready: 'Ready for note',
        future: 'Future',
        pending: 'In note / pending',
        reimbursed: 'Reimbursed',
        expenseCountOne: '{{count}} expense',
        expenseCountOther: '{{count}} expenses',
        noteCountOne: '{{count}} note',
        noteCountOther: '{{count}} notes',
      },
      selection: {
        none: 'No expense selected',
        selectedOne: '{{count}} expense selected · {{amount}}',
        selectedOther: '{{count}} expenses selected · {{amount}}',
        selectedShort: 'selected',
        selectAllReady: 'Select all ready',
        toggleVisibleReady: 'Select visible ready expenses',
        toggleBill: 'Select expense',
      },
      metadata: {
        billRef: 'Bill {{id}}',
        debitNoteRef: 'Note {{number}}',
        downloadDebitNote: 'Download note {{number}}',
        category: 'Category',
        booleanTrue: 'Yes',
        booleanFalse: 'No',
      },
      issueReview: {
        title: 'Review debit note',
        description: 'Review the selected expenses and set the due date before issuing.',
        stepSelect: 'Select expenses',
        stepReview: 'Review & issue',
        dueDateLabel: 'Due date',
        dueDateHintOne: 'Due in 1 day',
        dueDateHintOther: 'Due in {{count}} days',
        totalLabel: 'Total to reimburse via debit note',
        entityLabel: 'Issuing entity',
        bankAccountLabel: 'Receiving bank account',
        bankAccountPlaceholder: 'Select the bank account',
        bankAccountEmpty: 'No active bank account for this entity.',
        expensesTitle: 'Included expenses',
        proofColumn: 'Receipt',
        hasProof: 'Has receipt',
        noProof: 'No receipt',
        attachOriginalDocuments: 'Attach original documents',
        attachOriginalDocumentsDescriptionOne:
          'Includes 1 expense receipt in the note download package.',
        attachOriginalDocumentsDescriptionOther:
          'Includes {{count}} expense receipts in the note download package.',
        attachOriginalDocumentsCountOne: '1 attachment',
        attachOriginalDocumentsCountOther: '{{count}} attachments',
        back: 'Back',
        confirm: 'Issue note',
      },
    },
    buckets: {
      ready: 'Ready for reimbursement (reconciled)',
      awaiting: 'Awaiting payment confirmation',
      billed: 'Generated debit notes / pending',
      reimbursed: 'Reimbursed',
      empty: 'No bills in this stage.',
    },
    billStatus: {
      AWAITING_PAYMENT: 'Awaiting payment',
      READY_FOR_REIMBURSEMENT: 'Ready for reimbursement',
      BILLED: 'Pending reimbursement',
      REIMBURSED: 'Reimbursed',
    },
    list: {
      title: 'Issued debit notes',
      empty: 'No debit notes found.',
    },
    dueDateDialog: {
      title: 'Debit note due date',
    },
    detail: {
      title: 'Debit note',
      description: 'Issued note data for customer reimbursement.',
      back: 'Back',
      summary: 'Summary',
      totalLabel: 'Debit note total',
      allocated: 'Allocated',
      lines: 'Linked expenses',
      noLines: 'No linked expenses.',
      allocations: 'Receipts',
      noAllocations: 'No receipts allocated.',
      receipt: 'Receipt',
      date: 'Date',
      payment: 'Payment',
      paymentDate: 'Payment date',
      openBill: 'Open bill',
      expenseCountOne: '{{count}} expense',
      expenseCountOther: '{{count}} expenses',
      footerSummary: '{{countLabel}} · {{amount}}',
    },
    filters: {
      competencyRange: 'Competency',
      competencyRangePlaceholder: 'Select competency',
      competencyFrom: 'Competency from',
      competencyTo: 'Competency to',
      numberPlaceholder: 'Note number',
      amount: 'Amount',
      amountPlaceholder: 'Amount',
      amountMin: 'Min amount',
      amountMax: 'Max amount',
      amountOperators: {
        eqSymbol: '=',
        gteSymbol: '≥',
        lteSymbol: '≤',
      },
      status: 'Note status',
      billStatus: 'Bill status',
      createdRangePlaceholder: 'Select created date',
      dueRange: 'Due date',
      dueRangePlaceholder: 'Select due date',
      dueFrom: 'Due from',
      dueTo: 'Due to',
      customerPlaceholder: 'Customer or tax ID',
      billsPlaceholder: 'Bills',
      all: 'All',
      clear: 'Clear filters',
      apply: 'Apply',
      filterColumn: 'Filter column',
      filterAmount: 'Filter amount',
      active: 'Active filters:',
      clearAll: 'Clear all',
      datePlaceholder: 'Any date',
    },
    table: {
      description: 'Description',
      vendor: 'Vendor',
      customer: 'Customer',
      bills: 'Bills',
      bill: 'Bill',
      future: 'Future',
      ready: 'Ready for reimbursement',
      pending: 'Pending reimbursement',
      reimbursed: 'Reimbursed',
      amount: 'Amount',
      number: 'Number',
      status: 'Status',
      date: 'Date',
      createdAt: 'Created at',
      dueDate: 'Due date',
      actions: 'Actions',
    },
    tableTooltips: {
      amount: 'Total amount of the debit note issued to the customer.',
      future:
        'Reimbursable expenses that are not ready to bill yet, usually because payment or confirmation is still pending.',
      ready:
        'Expenses ready to generate a debit note, with payment/reimbursement conditions confirmed.',
      pending: 'Expenses already included in a debit note and still pending reimbursement.',
      reimbursed: 'Expenses already reimbursed by the customer.',
    },
    actions: {
      issue: 'Issue',
      void: 'Void',
      cancel: 'Cancel note',
      close: 'Close',
      download: 'Download PDF',
      downloadWithDocuments: 'Download PDF + docs',
      openCustomer: 'Open customer',
      removeLine: 'Remove expense from note',
      delete: 'Delete',
      deleting: 'Deleting...',
      clearingUploadedFiscalNote: 'Clearing fiscal note...',
    },
    dialogs: {
      cancel: 'Cancel',
      deleteTitle: 'Delete debit note?',
      deleteDescription:
        'Debit note {{number}} will be voided and linked bills will become eligible for reimbursement again. This action cannot be undone.',
      deleteConfirm: 'Delete note',
      deleteUnavailable: 'Received, voided, or allocated debit notes cannot be deleted.',
    },
    voidDialog: {
      title: 'Cancel debit note?',
      description:
        'The debit note will be voided and the linked expenses will return to the reimbursement queue. This action cannot be undone.',
      writeOffLabel: 'Write off the expenses as a loss (they will not be reimbursed)',
      writeOffHint:
        'A loss journal entry will be posted and the expenses will no longer be eligible for another debit note.',
      confirm: 'Cancel note',
    },
    status: {
      DRAFT: 'Draft',
      ISSUED: 'Issued',
      PARTIALLY_RECEIVED: 'Partial',
      RECEIVED: 'Received',
      VOID: 'Void',
    },
    toast: {
      created: 'Debit note created.',
      createError: 'Could not create debit note.',
      issued: 'Debit note issued.',
      issueError: 'Could not issue debit note.',
      voided: 'Debit note voided.',
      voidError: 'Could not void debit note.',
      deleted: 'Debit note deleted.',
      deleteError: 'Could not delete debit note.',
      lineRemoved: 'Bill removed from debit note.',
      lineRemoveError: 'Could not remove bill from debit note.',
      downloadError: 'Could not download debit note PDF.',
      downloadDocumentsError: 'Could not download debit note PDF with documents.',
    },
  },
  customers: {
    title: 'Customers',
    subtitle: 'Manage your customers',
    table: {
      name: 'Name',
      code: 'Code',
      email: 'Email',
      taxId: 'Tax ID',
      status: 'Status',
      noResults: 'No customers found.',
      loading: 'Loading customers...',
    },
    statuses: {
      active: 'Active',
      inactive: 'Inactive',
      blocked: 'Blocked',
    },
    stats: {
      total: 'Total',
      active: 'Active',
      blocked: 'Blocked',
      withTaxId: 'With Tax ID',
    },
    filters: {
      title: 'Filters',
      search: 'Search',
      searchPlaceholder: 'Name, code, email...',
      status: 'Status',
      clearAll: 'Clear all',
      activeFilters: 'Active filters:',
      all: 'All',
    },
    empty: {
      title: 'No customers found',
      description: 'No customers match the selected filters.',
    },
    // The listing's own texts, written into the page in Portuguese before it used i18n: they
    // stay Portuguese in English too — except the tax id, which names no country's document.
    listing: {
      columns: {
        name: 'Cliente',
        code: 'Código',
        email: 'E-mail',
        taxId: 'Tax ID',
        status: 'Status',
      },
      statusBadge: {
        ACTIVE: 'Ativo',
        BLOCKED: 'Inativo',
      },
      noEntity: 'Sem entidade',
      create: 'Novo Cliente',
      exportSelected: 'Exportar selecionados',
      nounOne: 'cliente',
      nounOther: 'clientes',
    },
    actions: {
      cancel: 'Cancel',
      create: 'Create customer',
      saveChanges: 'Save changes',
      edit: 'Edit',
      backToList: 'Back to customers',
    },
    form: {
      titleNew: 'New customer',
      titleEdit: 'Edit customer',
      subtitle: 'Customer profile and settings',
      tabs: {
        identity: 'Identity',
        contact: 'Contact',
        emails: 'Emails',
        contracts: 'Contracts',
        group: 'Group',
        balance: 'Balance',
        customerBalance: 'Credits & debits',
        address: 'Address',
        reimbursableExpenses: 'Reimbursable expenses',
      },
      emailRoles: {
        FINANCIAL: 'Financial',
        GENERAL: 'General',
        ACCOUNTING: 'Accounting',
        NFE_RECIPIENT: 'NF-e recipient',
      },
      emails: {
        add: 'Add',
        addPlaceholder: 'Email',
        remove: 'Remove',
        tableEmail: 'Email',
        tableRole: 'Role',
        empty: 'No emails registered.',
      },
      validation: {
        entityRequired: 'Select the entity',
        customerTypeRequired: 'Select the document type',
        taxIdRequired: 'Enter the tax document',
        taxIdInvalid: 'Invalid document',
        countryCodeRequired: 'Enter the country of residence or incorporation',
        cepLookupError: 'Could not look up the postal code. Check the number and try again.',
        codeRequired: 'Enter the code',
        legalNameRequired: 'Enter legal name',
        tradeNameRequired: 'Enter trade name',
        phoneRequired: 'Enter phone number',
      },
      saveBeforeEditingHint: 'Save the customer before editing other information',
      sections: {
        identity: {
          title: 'Identity',
          description: 'Legal and tax information',
        },
        contact: {
          title: 'Contact',
          description: 'Communication channels',
        },
        emails: {
          title: 'Emails',
          description: 'Registered emails and roles',
        },
        address: {
          title: 'Address',
          description: 'Primary address',
        },
        billing: {
          title: 'Billing settings',
          description: 'Financial parameters and preferences',
        },
        status: {
          title: 'Customer status',
          description: 'Block status and reasons',
        },
        crm: {
          title: 'CRM integrations',
          description: 'External system IDs',
        },
        fiscal: {
          title: 'Fiscal information (RF)',
          description: 'Public data from Receita Federal',
          emptyHint: 'Enter a CNPJ and click Search at RF to auto-fill fiscal data',
        },
      },
      fields: {
        entity: {
          label: 'Entity',
          placeholder: 'Select entity',
        },
        country: {
          label: 'Country',
          placeholder: 'Select country',
        },
        taxRegimeCode: {
          label: 'Tax regime (SAT)',
          placeholder: '601',
          hint: 'The customer’s c_RegimenFiscal as a CFDI recipient. E.g. 601 legal entity, 612 individual, 616 no tax obligations.',
        },
        paymentFormCode: {
          label: 'Payment form (SAT)',
          hint: 'The c_FormaPago the customer’s CFDI states. Without one the CFDI states 03. A PPD CFDI always states 99; 99 is refused on a PUE CFDI.',
          placeholder: 'Select the payment form',
          none: 'Not recorded (03)',
          options: {
            '01': 'Cash',
            '02': 'Nominative check',
            '03': 'Electronic funds transfer',
            '04': 'Credit card',
            '05': 'Electronic wallet',
            '06': 'Electronic money',
            '08': 'Food vouchers',
            '12': 'Payment in kind (dación en pago)',
            '13': 'Payment by subrogation',
            '14': 'Payment by consignment',
            '15': 'Debt forgiveness (condonación)',
            '17': 'Offset (compensación)',
            '23': 'Novation',
            '24': 'Merger of debtor and creditor (confusión)',
            '25': 'Debt remission',
            '26': 'Statute of limitations or expiry',
            '27': 'To the creditor’s satisfaction',
            '28': 'Debit card',
            '29': 'Services card',
            '30': 'Application of advances',
            '31': 'Payment intermediary',
            '99': 'To be defined',
          },
        },
        code: {
          label: 'Code',
          placeholder: 'CLI-001',
          hint: 'Leave empty to auto-generate',
        },
        partyType: {
          label: 'Party type',
          placeholder: 'Select type',
          options: {
            organization: 'Organization',
            individual: 'Individual',
          },
        },
        legalName: {
          label: 'Legal name',
          placeholder: 'Enter legal name',
        },
        tradeName: {
          label: 'Trade name',
          placeholder: 'Optional',
        },
        taxIdType: {
          label: 'Document type',
          placeholder: 'Select type',
          options: {
            cnpj: 'CNPJ',
            cpf: 'CPF',
            other: 'Other',
          },
        },
        customerType: {
          label: 'Document type',
          placeholder: 'Select type',
          options: {
            cnpj: 'CNPJ',
            cpf: 'CPF',
            rfc: 'RFC (Mexico)',
            ein: 'EIN (United States)',
            international: 'Foreign',
          },
        },
        taxIdValue: {
          label: 'Document',
          hint: 'Enter the document for the selected type',
          placeholder: '00.000.000/0000-00',
          einPlaceholder: '12-3456789',
          internationalPlaceholder: 'EIN, RFC, or other tax identifier',
        },
        email: {
          label: 'Primary email',
          placeholder: 'billing@customer.com',
        },
        phoneNumber: {
          label: 'Phone',
          placeholder: 'E.g. +1 212 555 0100',
        },
        addressLine1: {
          label: 'Address line 1',
          placeholder: 'Street, avenue, number',
        },
        addressNumber: {
          label: 'Number',
          placeholder: 'E.g. 123 or N/A',
        },
        addressLine2: {
          label: 'Address line 2',
          placeholder: 'Suite, neighborhood',
        },
        addressCity: {
          label: 'City',
          placeholder: 'Sao Paulo',
        },
        addressState: {
          label: 'State',
          placeholder: 'SP',
        },
        addressPostalCode: {
          label: 'Postal code',
          placeholder: '00000-000',
        },
        addressCountryCode: {
          label: 'Country',
          placeholder: 'BR',
        },
        billingGroupId: {
          label: 'Billing group',
          placeholder: 'Select group',
          none: 'No group',
        },
        creditLimit: {
          label: 'Credit limit',
          placeholder: '1000.00',
        },
        paymentTerms: {
          label: 'Payment terms',
          placeholder: 'e.g. 30 days',
        },
        boletoInstructions: {
          label: 'Boleto instructions',
          placeholder: 'Additional instructions',
        },
        communicationChannels: {
          label: 'Communication channels',
          placeholder: 'email, whatsapp',
        },
        autoCollectionEnabled: {
          label: 'Automatic collection',
        },
        negativacaoEnabled: {
          label: 'Negative listing',
        },
        negativacaoDays: {
          label: 'Days to negative listing',
          placeholder: '30',
        },
        glOffsetAccountId: {
          label: 'GL account',
          placeholder: 'Select account',
        },
        billingNotes: {
          label: 'Billing notes',
          hint: 'Internal notes',
          placeholder: 'Additional information...',
        },
        isBlocked: {
          label: 'Customer blocked',
        },
        blockReason: {
          label: 'Block reason',
          placeholder: 'Describe the reason',
        },
        hubspotContactId: {
          label: 'HubSpot ID',
          placeholder: 'Optional',
        },
        intercomContactId: {
          label: 'Intercom ID',
          placeholder: 'Optional',
        },
        fiscal: {
          regimeTributario: 'Tax regime',
          porte: 'Company size',
          situacaoCadastral: 'Registration status',
          naturezaJuridica: 'Legal nature',
          cnaePrincipal: 'Primary CNAE',
          dataAbertura: 'Opening date',
        },
      },
      taxIdChange: {
        title: 'Change the document',
        description:
          'The document changed from {{from}} to {{to}}. Is this a correction to the same record, or is it a different company or person?',
        correct: {
          label: 'Correct the document',
          description:
            'It is the same company or person and the document was wrong. The record and all its history stay, now with the new document.',
        },
        otherParty: {
          label: 'It is a different company or person',
          description:
            'The customer moves to a new record. The current record keeps the old document and its history.',
        },
        sharedNote:
          'This record is also used elsewhere (as a vendor, an employee, or a customer in another entity). Correcting the document changes it there too.',
        // First document of a customer that has none yet, on a shared record.
        added: {
          title: 'Add the document',
          description:
            'This customer has no document yet. Add {{to}} to its current record, or give the customer a record of its own?',
          correct: {
            label: 'Add to the current record',
            description:
              'The document is written on the record the customer already uses, with all its history.',
          },
          otherParty: {
            label: 'Create its own record',
            description:
              'The customer gets a new record with this document. The current record does not change.',
          },
          sharedNote:
            'This record is also used elsewhere (as a vendor, an employee, or a customer in another entity). Adding the document here writes it there too.',
        },
      },
      serpro: {
        button: 'Validate at RF',
        searchAtRf: 'Search at RF',
        disabledTooltip:
          'Enter a valid complete CNPJ (14 digits) to fetch data from the Federal Revenue',
        disabledTooltipEdit: 'Not available when editing customer',
        disabledTooltipValidated: 'Data already validated at RF',
        disabledTooltipLoading: 'Fetching data from RF...',
        loading: 'Validating...',
        validated: 'Verified',
        validatedAt: 'Verified on {{date}}',
        invalidCnpj: 'Provide a valid CNPJ to validate',
        genericError: 'Failed to validate at RF',
        notFound: 'CNPJ not found at Receita Federal',
      },
    },
    detail: {
      titleFallback: 'Customer details',
      code: 'Code: {{code}}',
      title: 'Customer: {{name}}',
      subtitle: 'Complete customer view',
      invalidIdTitle: 'Customer not found',
      invalidIdDescription: 'The customer identifier is invalid.',
      loadErrorTitle: 'Failed to load customer',
      loadErrorDescription: 'We could not load customer data.',
      tabs: {
        overview: 'Overview',
        balance: 'Balance',
        emails: 'Emails',
        notes: 'Notes',
        reimbursableExpenses: 'Reimbursable expenses',
      },
      sections: {
        summary: {
          title: 'Summary',
          description: 'Main information',
        },
        registrationData: {
          title: 'Registration data',
          description: 'Main information',
        },
        identity: {
          title: 'Identity',
          description: 'Legal details and contacts',
        },
        fiscal: {
          title: 'Fiscal information',
          source: 'Federal Revenue',
          suspendedVerify: 'Verify before issuing fiscal documents.',
        },
        billing: {
          title: 'Billing',
          description: 'Financial parameters',
        },
        address: {
          title: 'Address',
          description: 'Primary location',
        },
        audit: {
          title: 'Audit',
          description: 'Created and updated dates',
        },
        balance: {
          title: 'Recoverables',
          description: 'Reimbursable expenses recorded in the counterparty balance',
        },
        emails: {
          title: 'Emails',
          description: 'Registered channels',
        },
        notes: {
          title: 'Billing notes',
          description: 'Internal notes',
        },
      },
      fields: {
        code: 'Code',
        taxId: 'Document',
        status: 'Status',
        legalName: 'Legal name',
        tradeName: 'Trade name',
        partyType: 'Party type',
        email: 'Email',
        phone: 'Phone',
        billingGroup: 'Billing group',
        creditLimit: 'Credit limit',
        paymentTerms: 'Payment terms',
        taxRegimeCode: 'Tax regime (SAT)',
        paymentFormCode: 'Payment form (SAT)',
        autoCollection: 'Automatic collection',
        negativacao: 'Negative listing',
        address: 'Address',
        addressCity: 'City',
        addressState: 'State',
        addressPostalCode: 'Postal code',
        createdAt: 'Created at',
        updatedAt: 'Updated at',
      },
      status: {
        active: 'Active',
        inactive: 'Inactive',
        blocked: 'Blocked',
      },
      boolean: {
        yes: 'Yes',
        no: 'No',
      },
      balance: {
        recoverable: 'Recoverable',
        entryCount: 'Entries',
        currency: 'Currency',
        entryTypes: {
          CREDIT: 'Increase',
          DEBIT: 'Decrease',
        },
        emptyTitle: 'No entries',
        emptyDescription: 'There are no open reimbursable expenses for this customer.',
        showInvoices: 'show invoices',
        hideInvoices: 'hide invoices',
        invoicesLoading: 'Loading invoices…',
        invoicesEmpty: 'No invoice behind this movement.',
        invoicesTotal: '{{count}} invoices',
        colReservation: 'Reservation',
        colCompetency: 'Competency',
        colGtv: 'GTV',
        colFee: 'Fee + tax',
        openInvoice: 'Open',
      },
      creditsDebits: {
        loading: 'Loading entries...',
        loadError: 'Failed to load balance entries.',
        summary: {
          credits: 'Credits',
          debits: 'Debits',
          net: 'Net balance',
        },
        table: {
          type: 'Type',
          reason: 'Reason',
          description: 'Description',
          amount: 'Amount',
          remaining: 'Remaining',
          status: 'Status',
          createdAt: 'Created at',
          actions: 'Actions',
        },
        type: {
          CREDIT: 'Credit',
          DEBIT: 'Debit',
        },
        reason: {
          COMMERCIAL_DISCOUNT: 'Commercial discount',
          OVERPAYMENT: 'Overpayment',
          CREDIT_NOTE: 'Credit note',
          GOODWILL: 'Goodwill',
          PENALTY: 'Penalty',
          UNBILLED_CHARGE: 'Unbilled charge',
          CARRY_FORWARD: 'Carried-forward balance',
          OTHER: 'Other',
        },
        status: {
          AVAILABLE: 'Available',
          PARTIALLY_CONSUMED: 'Partially consumed',
          CONSUMED: 'Consumed',
          EXPIRED: 'Expired',
          CANCELLED: 'Cancelled',
        },
        cancelledInfo: 'Cancelled by {{user}} on {{date}}',
        empty: {
          title: 'No entries',
          description: 'There are no manual credit or debit entries recorded for this customer.',
        },
        create: {
          trigger: 'New entry',
          title: 'New balance entry',
          description:
            'Records a manual credit or debit that becomes part of the customer balance, consumed by future invoices.',
          fields: {
            type: 'Type',
            reason: 'Reason',
            currencyCode: 'Currency',
            amount: 'Amount',
            amountHint:
              'Use 1,200.00 — always positive. The type (credit/debit) determines the sign.',
            description: 'Description',
            descriptionPlaceholder: 'E.g.: commercial discount approved on...',
            referenceId: 'Reference (optional)',
            expiresAt: 'Expires at (optional)',
            notes: 'Notes (optional)',
          },
          errors: {
            amountInvalid: 'Invalid amount. Enter a positive value, e.g. 1,200.00.',
            descriptionRequired: 'Description is required.',
            currencyInvalid: 'Enter a 3-letter currency code, e.g. BRL.',
          },
          confirm: 'Create entry',
          success: 'Balance entry created.',
        },
        cancel: {
          trigger: 'Cancel entry',
          title: 'Cancel balance entry?',
          description:
            'The entry stops being available for future consumption. This action cannot be undone.',
          confirm: 'Confirm cancellation',
          success: 'Entry cancelled.',
          consumedError: 'Already-consumed entries cannot be cancelled.',
          liveConsumptionError:
            'This entry is still consumed by a draft (pre-fiscal) invoice. Delete the draft or release the consumption before cancelling.',
        },
      },
      emails: {
        emptyTitle: 'No emails',
        emptyDescription: 'Add contact emails for this customer.',
        roleFallback: 'No role',
        addSuccess: 'Email added.',
        addError: 'Failed to add email.',
        removeSuccess: 'Email removed.',
        removeError: 'Failed to remove email.',
      },
      saveSuccess: 'Changes saved.',
      saveError: 'Failed to save changes.',
      notes: {
        emptyTitle: 'No notes',
        emptyDescription: 'No notes recorded.',
      },
    },
  },
  invoices: {
    listing: { exportFilename: 'invoices-{{date}}.csv' },
    types: {
      standard: 'Standard',
      transaction: 'Transaction',
      gtvTransaction: 'GTV transaction',
      aggregate: 'Aggregate',
    },
    depositReportImport: {
      openAction: 'Import deposit report',
      title: 'Import settlement report',
      description:
        'Upload the settlement report. The preview shows each deposit, its beneficiary and how it resolves today — nothing is written until you confirm. The import is all-or-nothing per file and idempotent per deposit.',
      entity: 'Issuing entity',
      entityPlaceholder: 'Select the entity',
      file: 'File (.xlsx)',
      previewAction: 'Preview',
      importAction: 'Import and project invoices',
      close: 'Close',
      refused: 'Refused by the contract',
      alreadyIngested: 'Already imported (replay)',
      willCreateParty: 'Will create customer/party',
      columns: {
        deposit: 'Deposit',
        payee: 'Beneficiary',
        transactions: 'Transactions',
        net: 'Net deposited',
        resolution: 'Resolution',
      },
      resultTitle: 'Import finished',
      resultSummary:
        '{{deposits}} new deposit(s), {{replayed}} replay(s), {{events}} event(s), {{invoices}} invoice(s) projected, {{pending}} pending event(s) (refund/chargeback await a rule — D6).',
    },
    settlementAggregate: {
      recognizedByReservation_one: 'Recognised per reservation in {{count}} transaction invoice',
      recognizedByReservation_other: 'Recognised per reservation in {{count}} transaction invoices',
      notRecognizedYet:
        'Revenue and tax not recognised yet: none of the transaction invoices behind this invoice has a journal.',
      settledByRetention: 'Settled by retention at payout',
      metadata: {
        payoutAccount: 'Payout account',
        payoutAccountValue: '{{name}} (#{{id}})',
        sourceGroup: 'Source group',
        window: 'Period',
        windowValue: '{{start}} to {{end}}',
        glReclassification: 'GL reclassification',
        glPosted: 'posted',
        glPending: 'pending — it will be retried automatically',
        glNothingOpen: 'nothing to post — no child invoice has an unbilled balance',
        glNothingBilled: 'nothing to post — the invoice bills no receivable',
        glNothingGeneric: 'nothing to post',
        glChildren_one: '{{count}} child',
        glChildren_other: '{{count}} children',
        technicalDetails: 'Technical details',
      },
      receivablesTitle: 'Included receivables',
      receivablesCount_one: '{{count}} settlement receivable',
      receivablesCount_other: '{{count}} settlement receivables',
      receivablesWindow: 'Window {{periodStart}} to {{periodEnd}}',
      receivablesNote:
        'Revenue and tax already recognised per reservation. This invoice is the billing and fiscal document.',
      reservation: 'Reservation',
      competency: 'Competency',
      amount: 'Amount',
      status: 'Status',
      fiscal: 'Fiscal note',
      fiscalLinked: 'linked',
      fiscalPending: 'pending',
      searchLabel: 'Search receivables by reservation',
      searchPlaceholder: 'Search by reservation',
      empty: 'No receivable linked.',
      billedIn: 'Billed in aggregate',
      openAggregate: 'Open aggregate invoice',
      reconciliation: {
        reconciled: '100% reconciled',
        pending_one: '{{count}} pending item',
        pending_other: '{{count}} pending items',
        pillTitle:
          '{{percent}}% reconciled — {{pending}} of {{total}} items pending. Click to review.',
        reconciledTitle: 'Hotel payouts and acquirer credits reconciled. Click to review.',
        title: 'Aggregate reconciliation',
        description:
          'The CFDI should only go out at 100% reconciliation. Resolve each item below on the reconciliation screen.',
        loading: 'Loading pending items…',
        loadFailed: 'Could not load the reconciliation pending items.',
        allDone: 'Everything reconciled: hotel payouts and acquirer credits.',
        summary:
          '{{pending}} of {{total}} items pending ({{percent}}% reconciled) — payouts: {{custody}}, acquirer: {{rail}}.',
        columns: {
          item: 'Item',
          date: 'Date',
          amount: 'Amount',
          missing: 'What is missing',
          action: 'Action',
        },
        kind: {
          custody: 'Payout to the hotel · deposit {{id}}',
          rail: 'Acquirer credit · batch {{date}}',
        },
        children_one: '{{count}} receivable',
        children_other: '{{count}} receivables',
        missing: {
          PAYOUT_NOT_RECONCILED: 'The payout to the hotel is not reconciled with the bank',
          RAIL_CREDIT_NOT_RECONCILED: 'The acquirer credit for this batch is not reconciled',
          RAIL_BATCH_NOT_IMPORTED:
            'The acquirer report for this day was not imported — there is no batch to reconcile',
        },
        openBankLine: 'Open bank line',
        openInbox: 'Find in reconciliation',
        close: 'Close',
        override: {
          banner:
            'This aggregate has {{count}} reconciliation item(s) pending. Issuing the CFDI without reconciling needs a reason, recorded with your user and the date.',
          action: 'Issue anyway',
          reasonLabel: 'Reason (required)',
          reasonPlaceholder: 'Why issue before reconciliation is complete?',
          reasonHint: 'At least 5 characters. It is recorded in the invoice history.',
          confirm: 'Issue anyway',
          back: 'Back',
          viewPending: 'View pending items',
        },
      },
      approve: {
        title: 'Approve and issue the CFDI',
        description:
          'Revenue and tax were already recognised per reservation. Approving issues this invoice’s CFDI with the SAT over the included receivables.',
        exchangeRate: 'Exchange rate {{currency}} → MXN (SAT TipoCambio)',
        exchangeRatePlaceholder: "Today's DOF FIX (automatic)",
        exchangeRateHint:
          'Empty: the CFDI states the FIX Banxico published in the DOF on the emission day. Fill it only to override.',
        confirm: 'Issue CFDI',
        emitted: 'CFDI issued. The invoice is now Issued.',
        failed: 'The SAT rejected the emission.',
      },
    },
    settlementGrouping: {
      title: 'Consolidated fiscal grouping',
      description:
        'Pick the competency window: each customer gets one consolidated CFDI for the period invoices that are not linked to any fiscal note yet.',
      openAction: 'Consolidated fiscal grouping',
      entity: 'Issuing entity',
      entityPlaceholder: 'Select the entity',
      periodStart: 'Period start',
      periodEnd: 'Period end',
      preview: 'Preview',
      goToConfirm: 'Continue',
      back: 'Back',
      confirm: 'Group and emit CFDIs',
      close: 'Close',
      runAgain: 'Run again',
      empty: 'No settlement invoice without a fiscal note in this window.',
      missingRfc: 'RFC not mapped',
      unprojectedTitle: 'Unprojected work in this window',
      unprojectedDescription:
        '{{count}} settlement event(s) are still PENDING (refunds/chargebacks with no projection rule) and are not part of the grouping. The period may be incomplete.',
      issuerHint:
        'The issuer comes from the entity binding at FiscalAPI and the CFDI is signed with the CSD already in the provider custody — no certificate or password is sent from here. Upload the CSD once on the integrations screen.',
      expeditionZipCode: 'Expedition zip code (SAT) — empty uses the entity’s',
      recipientTaxRegime: 'Recipient tax regime (default)',
      resultSummary: '{{emitted}} CFDI(s) emitted, {{failed}} failure(s).',
      statusEmitted: 'Emitted',
      statusFailed: 'Failed',
      columns: {
        customer: 'Customer',
        rfc: 'RFC',
        invoiceCount: 'Invoices',
        total: 'Total',
        currency: 'Currency',
        status: 'Status',
        detail: 'Detail',
      },
    },
    title: 'Accounts Receivable',
    subtitle: 'Manage customer invoices',
    statusViews: 'Invoice statuses',
    table: {
      invoice: 'Invoice',
      customer: 'Customer',
      amount: 'Amount',
      received: 'Received',
      due: 'Due',
      status: 'Status',
      noResults: 'No invoices found.',
      loading: 'Loading invoices...',
    },
    filters: {
      title: 'Filters',
      search: 'Search',
      searchPlaceholder: 'Customer, number, reference...',
      status: 'Status',
      proposedSelectEntityFirst: 'Select the entity first.',
      clearAll: 'Clear all',
      activeFilters: 'Active filters:',
      all: 'All',
      minAmount: 'Min amount',
      maxAmount: 'Max amount',
    },
    tabs: {
      all: 'All',
      open: 'Open',
      blocked: 'Blocked',
      paid: 'Paid',
      overdue: 'Overdue',
    },
    statuses: {
      draft: 'Draft',
      stale: 'Stale',
      awaitingNf: 'Awaiting NF',
      blocked: 'Blocked',
      issued: 'Issued',
      recognized: 'Recognized',
      provisioned: 'Provisioned',
      partiallyPaid: 'Partially paid',
      paidUnconfirmed: 'Paid (unconfirmed)',
      // ALC-2824 — "received", not "paid": the customer has paid in full, the acquirer is
      // still settling. Deliberately distinct from `partiallyPaid` above.
      partiallyReceived: 'Partially received',
      paid: 'Paid',
      void: 'Void',
      // Migrated from the previous system at onboarding: informational only, no actions.
      migrated: 'Migrated',
    },
    stats: {
      totalBilled: 'Total Billed',
      open: 'Open',
      paid: 'Paid',
      overdue: 'Overdue',
      total: 'Total',
      paidAmount: 'Paid',
      pending: 'Pending',
      overdueAmount: 'Overdue',
      invoice: 'invoice',
      invoices: 'invoices',
    },
    listPage: {
      stats: {
        total: 'Total',
        paid: 'Paid',
        pending: 'Pending',
        overdue: 'Overdue',
        invoice: 'invoice',
        invoices: 'invoices',
      },
      indicators: {
        open: 'Open',
        blocked: 'Blocked',
        recentlyReceived: 'Received in the last 7 days',
        noAmounts: 'No amounts for this indicator',
        mixedFunctionalCurrencies: 'Select an entity to see the total',
        loading: 'Loading invoice indicators',
        loadErrorTitle: 'Could not load the indicators',
        loadErrorDescription: 'Try again to refresh the totals.',
        missingProvisionBasis_one:
          '{{count}} invoice without a valid currency or functional basis was omitted from the total.',
        missingProvisionBasis_other:
          '{{count}} invoices without a valid currency or functional basis were omitted from the total.',
        unresolvedEntities_one:
          '{{count}} entity without a functional currency was omitted from the totals.',
        unresolvedEntities_other:
          '{{count}} entities without a functional currency were omitted from the totals.',
      },
      periodHeader: {
        prevAria: 'Previous months',
        nextAria: 'Next months',
        complete: 'Settled',
        loadError: 'Failed to load period statistics.',
        retry: 'Retry',
      },
      metadataFilter: {
        keyPlaceholder: 'Metadata key',
        valuePlaceholder: 'Metadata value',
        apply: 'Filter',
        clear: 'Clear',
      },
    },
    selection: {
      emitFiscalNotes: 'Issue fiscal notes',
      export: 'Export',
    },
    toasts: {
      emitFiscalNotesSuccess: '{{count}} fiscal note(s) issued successfully.',
    },
    pagination: {
      showing: 'Showing {{start}}–{{end}} of {{total}}',
      noResults: 'No results',
      page: 'Page {{current}} of {{total}}',
      previous: 'Previous',
      next: 'Next',
    },
    details: {
      back: 'Back to invoices',
      backToPreBilling: 'Back to pre-billing',
      notFound: 'Invoice not found',
      notFoundDescription: 'The requested invoice does not exist or has been removed.',
      activities: {
        created: 'Invoice created via integration',
        issued: 'Invoice issued',
        issueFailed: 'Invoice issuance failed',
        autoApproveFailed: 'Automatic approval failed',
        autoApproveFailedDetail: 'The invoice stays in review. Approve it manually.',
        awaitingNf: 'Invoice awaiting fiscal note',
        blocked: 'Invoice blocked',
        stale: 'Invoice stale: source data changed after review',
        staleResolved: 'Differences resolved; invoice returned to draft',
        glPosted: 'Accounting provision posted',
        glPostingFailed: 'Accounting provision failed',
        fiscalCalculationOverride: 'Fiscal calculation manually overridden',
        fiscalRecalculated: 'Taxes and receivable recalculated',
        fiscalNoteRoundingAccepted: 'Rounding accepted: attached NFS-e amounts kept',
        fiscalNoteCleared: 'Attached fiscal note removed',
        reconciliationOverride: 'CFDI issued with reconciliation pending (reason recorded)',
        fiscalRecalculatedDetail:
          'Previous net: {{previous}} · fiscal calculation: {{calculated}} · final receivable: {{final}}',
        softDeleted: 'Invoice deleted',
        nfseRequested: 'NFSe issuance requested',
        nfseAuthorized: 'NFSe authorized',
        nfseFailed: 'NFSe issuance failed',
        nfseCancellationRequested: 'NFSe cancellation requested',
        nfseCancellationPendingAdministrative:
          'NFSe cancellation awaiting administrative completion',
        nfseCancellationGlReversalError: 'NFSe cancellation accounting reversal failed',
        nfseCancelled: 'NFSe cancelled',
        nfseCancellationFailed: 'NFSe cancellation failed',
        voided: 'Invoice cancelled',
        ownTaxReversedAfterGuide: 'Own ISS reversed after the guide — amount to recover',
        settlementCustomerCredit: 'Customer credit',
        settlementCustomerCreditDetail: '{{amount}} booked as a customer advance · {{reason}}',
        customerCreditReasons: {
          AR_SETTLEMENT_DUPLICATE_BILLING_CUSTOMER_CREDIT:
            'This settlement covers a contract cycle another document already billed. Check the duplicate billing and refund or offset the amount with the customer.',
          AR_SETTLEMENT_ADVANCE_FOREIGN_CURRENCY_CUSTOMER_CREDIT:
            'A foreign-currency settlement of an advance-billed item, which cannot be deferred to Contract Liability yet. Recognize the amount as revenue in the service competency month.',
          AR_SETTLEMENT_USAGE_ASSET_CUSTOMER_CREDIT:
            'This settlement covers a cycle whose revenue was already recognized on the Contract Asset. The part the cycle Contract Asset cannot take stays a customer advance: check the cycle was not overbilled and refund or offset the amount with the customer.',
          AR_INVOICE_DUPLICATE_BILLING_CUSTOMER_CREDIT:
            'This invoice covers a contract cycle another document (for example, a settlement) already billed. Check the duplicate billing and refund or offset the amount with the customer.',
        },
        usageAssetClaimReleased: 'Contract Asset released for reissue',
        customerCreditReleased: 'Customer advance recognized as revenue',
        customerCreditReleaseReversed: 'Customer advance revenue recognition reversed',
        usageAssetClaimReleasedDetail: '{{amount}} returned to the schedule billable balance',
        withholdingMismatch: 'Withholdings differ',
        withholdingMismatchItem: '{{tax}}: NF {{stated}}, applied {{applied}}',
        issEvidenceMissing: 'NF states no ISS amount',
        issEvidenceMissingDetail: 'The ISS stays provisioned until the NF states the amount.',
        externalFiscalNoteLinked: 'External NF linked',
        paymentReconciled: 'Payment reconciled',
        paymentDetail: '{{amount}} via bank reconciliation',
        paymentDetailWithMethod: '{{amount}} via {{method}} · bank reconciliation',
      },
      payment: {
        title: 'Payment',
        received: 'Received',
        pending: 'Pending',
        of: 'of',
      },
      statusChecks: {
        ariaLabel: 'Invoice status',
        provisioned: 'Provisioned',
        settled: 'Settled',
        recognized: 'Recognized',
        reconciled: 'Reconciled',
        awaitingReconciliation: 'Awaiting bank reconciliation',
        fiscalDocument: 'Fiscal document',
        awaitingFiscalDocument: 'Awaiting consolidated CFDI',
        fiscalNoteIssued: 'Fiscal note issued',
        billingSent: 'Billing sent',
        paymentReceived: 'Payment received',
        partialPayment: 'Partial ({{amount}})',
        completed: 'completed',
        pending: 'pending',
        aggregateRecognized: 'Revenue recognised (per reservation)',
        aggregateRecognizedPartial: '{{recognized}} of {{total}} invoices',
        aggregateCfdiIssued: 'CFDI issued',
        aggregateRetained: 'Commission retained at payout',
        aggregateOpenBalance: 'Open balance on the transaction invoices',
        aggregateAwaitingCfdi: 'Decided when the CFDI is issued',
      },
      header: {
        title: 'Invoice {{number}}',
        customer: 'Customer',
        issuingEntity: 'Issuing entity',
        issueDate: 'Issue date',
        dueDate: 'Due date',
        dueDateHint: 'due {{date}}',
        competencyDate: 'Competency',
        managerialDate: 'Managerial date',
        description: 'Description',
        descriptionPlaceholder: 'Invoice description',
        invoiceDetails: 'Invoice details',
        openInKamino: 'Open in Kamino',
        orderRef: 'Order',
        metadata: 'Metadata',
      },
      footer: {
        save: 'Save',
        saving: 'Saving...',
        saveSuccess: 'Changes saved successfully',
        saveError: 'Failed to save changes',
        nothingToSave: 'Nothing to save',
        recalculateTaxes: 'Recalculate taxes',
        recalculateTaxesSuccess: 'Taxes recalculated successfully',
        recalculateTaxesError: 'Failed to recalculate taxes',
        approve: 'Approve',
        approving: 'Approving...',
        approveSuccess:
          'The fiscal note was sent for emission; after authorization, the invoice will be posted to the ledger.',
        approveSuccessAfterReceipt:
          'Invoice approved. The fiscal note is sent for emission once the customer pays.',
        approveSuccessExternal:
          'Invoice approved. Link the fiscal note issued outside Alchemy ERP once you have it.',
        approveSuccessPosted: 'Invoice approved and posted to GL',
        approveError: 'Failed to approve invoice',
        approveDialogTitle: 'Approve invoice?',
        approveDialogDescription:
          'The fiscal note will be sent for emission and, after authorization, the invoice will be posted to the ledger. Pending changes will be saved before approval.',
        approveDialogDescriptionAfterReceipt:
          'The invoice will be posted to the ledger. Its revenue cycle issues the fiscal note after the payment, so none is sent now. Pending changes will be saved before approval.',
        approveDialogDescriptionExternal:
          'The invoice will be posted to the ledger. Its fiscal note is issued outside Alchemy ERP, so none is sent from here: link it once you have it. Pending changes will be saved before approval.',
        approveDialogConfirm: 'Confirm',
        approveDialogCancel: 'Cancel',
        cancelInvoice: 'Cancel invoice',
        canceling: 'Canceling...',
        cancelSuccess: 'Invoice cancelled successfully.',
        cancelError: 'Could not cancel the invoice.',
        cancelGlPostedError:
          'This invoice has already been posted to the ledger. Cancellation requires reversal and is not available yet.',
        cancelDialogTitle: 'Cancel invoice?',
        cancelDialogDescription:
          'The invoice will be voided and can no longer be approved or edited.',
        cancelDialogConfirm: 'Confirm cancellation',
        cancelDialogCancel: 'Back',
        cancelFiscal: 'Cancel',
        cancelFiscalGateTitle: 'Cancel fiscal note and invoice?',
        cancelFiscalGateDescription:
          'This requests NFSe cancellation, reverses the GL provision, and may revert or void the invoice depending on your choice in the next step.',
        cancelFiscalGateWarningTitle: 'Warning: irreversible operation',
        cancelFiscalGateWarningBody:
          'Cancellation will be submitted to the municipality via Focus NFe. Once confirmed, the fiscal note is voided and accounting entries are reversed.',
        cancelFiscalGatePhraseLabel: 'Type "{{phrase}}" to continue',
        cancelFiscalGateConfirm: 'Continue',
        cancelFiscalGateCancel: 'Back',
      },
      boletos: {
        title: 'Boletos',
        loading: 'Loading boletos',
        empty: 'No boleto has been issued for this invoice.',
        installment: 'Installment {{number}}',
        singleBoleto: 'Invoice boleto',
        dueDate: 'Due {{date}}',
        nossoNumero: 'Nosso número {{value}}',
        linhaDigitavel: 'Payment line',
        barcode: 'Barcode',
        copy: 'Copy',
        copied: 'Copied',
        copyLinhaDigitavel: 'Copy payment line',
        copyBarcode: 'Copy barcode',
        proposedCancellationTimeout:
          'Cancellation is still processing. Refresh the page in a moment.',
        proposedProcessingTimeout: 'Issuance is still processing. Refresh the page in a moment.',
        pendingCodes: 'The bank has not returned the payment line yet.',
        paidAt: 'Paid on {{date}}',
        statuses: {
          pending: 'Issuing',
          registered: 'Registered',
          paidUnconfirmed: 'Paid (not reconciled)',
          settled: 'Paid',
          cancelled: 'Cancelled',
          failed: 'Failed',
        },
        issueError: {
          title: 'The boleto could not be issued',
          retry: 'Try issuing again',
          retrying: 'Sending…',
          retryQueued: 'Issue sent again. Refresh in a moment.',
          retryFailed: 'Could not send the issue again. Try again.',
          codes: {
            NO_BILLING_GROUP: 'The contract pays by boleto but has no billing group.',
            AMBIGUOUS_BILLING_GROUP: 'The contracts on this invoice have different billing groups.',
            NO_BOLETO_SETTINGS: 'The billing group has no boleto bank account.',
            NO_OPEN_INSTALLMENT: 'No installment of this invoice has a balance left to charge.',
            BOLETO_SETTINGS_INVALID: 'The bank does not accept the billing group boleto settings.',
            INSTRUCTIONS_TOO_LONG:
              'The boleto instructions exceed the 3 lines of 50 characters the bank accepts.',
            BANK_ACCOUNT_INVALID: 'The billing group bank account cannot issue boletos.',
            CURRENCY_NOT_SUPPORTED: 'Boletos can only be issued in reais.',
            PAYER_INCOMPLETE: 'The customer record is incomplete to issue the boleto.',
            INTEGRATION_DISABLED: 'The Itaú boleto integration is not active.',
            ENTITY_NOT_CONFIGURED: 'The entity has no Itaú boleto credentials.',
            CREDENTIALS_INVALID: 'The Itaú boleto credentials are invalid.',
            BANK_REFUSED: 'The bank refused the boleto.',
            BANK_UNAVAILABLE: 'The bank did not answer. Another attempt will be made.',
          },
          detail: 'Detail: {{message}}',
        },
      },
      sections: {
        sourceAndDocuments: 'Source & documents',
        lineItems: 'Invoice line items',
        receipts: 'Receipts',
        timeline: 'Timeline',
        amounts: 'Amounts & taxes',
        classification: 'Accounting classification',
      },
      staleReview: {
        title: 'Differences to review',
        titleResolved: 'Resolved differences',
        subtitleActive:
          'Source data changed after this invoice was reviewed. Decide each difference to release the invoice again.',
        subtitleResolved: "History of the differences resolved in this invoice's last review.",
        progressPending: '{{pending}} of {{total}} difference(s) pending',
        progressDone: 'All {{total}} difference(s) have been resolved.',
        resolvedNotice: 'The invoice is back to draft and can be approved again.',
        resolvedAtLabel: 'Resolved on {{date}}',
        diffTypes: {
          lineAmountChanged: 'Amount changed',
          lineAdded: 'Line added',
          lineRemoved: 'Line removed',
        },
        decision: {
          pending: 'Pending',
          applied: 'Applied',
          deferred: 'Deferred',
        },
        fields: {
          description: 'Description',
          quantity: 'Quantity',
          unitPrice: 'Unit price',
          lineAmount: 'Line amount',
        },
        reviewedValue: 'Reviewed value',
        proposedValue: 'Proposed value',
        noPreviousValue: 'New line — no reviewed value',
        noProposedValue: 'Removed line — no proposed value',
        decisionReasonLabel: 'Reason',
        decidedAtLabel: 'Decided on {{date}}',
        unknownItemLabel: 'Contract item {{id}}',
        actions: {
          apply: 'Apply',
          defer: 'Defer',
          applying: 'Applying...',
          deferring: 'Deferring...',
        },
        applyDialog: {
          title: 'Apply this difference?',
          description:
            "The billing engine's proposed value will be adopted for this line. This recalculates the invoice total and, if the total changes, also the revenue-recognition schedules and the customer balance consumption.",
          confirm: 'Apply difference',
        },
        deferDialog: {
          title: 'Defer this difference?',
          description:
            'The already-reviewed value on the invoice will be kept. Explain why — it is recorded on the invoice history.',
          reasonLabel: 'Reason for deferring',
          reasonPlaceholder: 'Explain why the reviewed value should be kept',
          confirm: 'Defer difference',
        },
        errors: {
          loadError: 'Could not load this invoice’s differences.',
          retry: 'Retry',
        },
        empty: 'No differences recorded for this invoice.',
        loading: 'Loading differences...',
        toasts: {
          applySuccess: 'Difference applied.',
          deferSuccess: 'Difference deferred.',
          resolvedToast: 'All differences resolved — the invoice is back to draft.',
          actionError: 'Could not record the decision.',
        },
      },
      customerCreditRelease: {
        title: 'Foreign-currency customer advance awaiting recognition',
        description:
          'A foreign-currency settlement of an item billed in advance was held as a customer ' +
          'advance ({{amount}}). Recognize it as revenue in the service competency month.',
        releasedTitle: 'Customer advance recognized as revenue',
        releasedDetail: '{{amount}} recognized as revenue in {{month}}',
        releaseAction: 'Recognize as revenue',
        reverseAction: 'Reverse recognition',
        releaseDialog: {
          title: 'Recognize customer advance as revenue',
          description:
            'Posts Dr Customer advance / Cr Revenue of {{amount}} in the chosen competency month, ' +
            'at the historical exchange rate of the advance (no FX gain or loss). ' +
            'The cost of the service (e.g. royalty) is provisioned in the same month too.',
          periodLabel: 'Competency month (open period)',
          noOpenPeriod: 'There is no open accounting period for this entity.',
          confirm: 'Recognize as revenue',
          success: 'Revenue recognized in {{month}}.',
        },
        reverseDialog: {
          title: 'Reverse revenue recognition',
          description:
            'Reverses the {{amount}} recognized in {{month}}. The amount goes back to the ' +
            'customer advance, and the service cost provision is reversed too.',
          confirm: 'Reverse recognition',
          success: 'Recognition reversed. The amount is back on the customer advance.',
        },
        errors: {
          generic: 'The operation could not be completed. Try again.',
          AR_CUSTOMER_CREDIT_RELEASE_NOTHING_TO_RELEASE:
            'This invoice has no foreign-currency customer advance awaiting recognition.',
          AR_CUSTOMER_CREDIT_RELEASE_PERIOD_NOT_OPEN:
            'The accounting period of the chosen competency month is not open. Open the period or choose another month.',
          AR_CUSTOMER_CREDIT_RELEASE_BEFORE_SETTLEMENT:
            'The chosen competency month ends before the receipt that created the advance was posted. Choose the receipt month or a later one.',
          AR_CUSTOMER_CREDIT_RELEASE_ADVANCE_ACCOUNT_MISMATCH:
            'The customer advance account mapped in the chosen period chart of accounts is not the account the advance was posted to. Choose a month on the same chart or fix the mapping.',
          AR_CUSTOMER_CREDIT_RELEASE_REVENUE_UNMAPPED:
            'No revenue account was found for the line service (service classification or the service revenue system account). Map the account and try again.',
          AR_CUSTOMER_CREDIT_RELEASE_RATE_UNRESOLVED:
            'The historical exchange rate of the original advance could not be determined.',
          AR_CUSTOMER_CREDIT_RELEASE_NOT_RELEASED:
            'This advance has no live revenue recognition to reverse.',
          AR_CUSTOMER_CREDIT_RELEASE_INVALID_MONTH: 'Enter the competency month as YYYY-MM.',
          AR_CUSTOMER_CREDIT_RELEASE_INVALID_DATE: 'Enter the reversal date as YYYY-MM-DD.',
          AR_CUSTOMER_CREDIT_RELEASE_MASTER_APPROVER_REQUIRED:
            'Only master approvers can recognize or reverse the advance as revenue.',
        },
      },
      blocked: {
        title: 'Invoice blocked',
        reasonLabel: 'Reason:',
        recovery: 'Fix the issue described above, then approve the invoice again.',
        genericReason: 'The invoice could not be posted to the ledger.',
        pendingUsageHint:
          "Find {{customer}}'s contract in Contracts, open its Usage section, and finalize the " +
          'pending usage for the period.',
        pendingUsageCta: 'Go to Contracts',
      },
      sidebar: {
        nextAction: {
          title: 'Next action',
          situationTitle: 'Status',
          draft:
            'Review the invoice data and approve to emit the fiscal note and post to the ledger.',
          draftAfterReceipt:
            'Review the invoice and approve it to post it to the ledger. The fiscal note is sent for emission once the customer pays.',
          draftExternal:
            'Review the invoice and approve it to post it to the ledger. Its fiscal note is issued outside Alchemy ERP: link it once you have it.',
          provisioned:
            'The fiscal note is provisioned. The next step is to send billing to the customer.',
          partiallyPaid:
            'Partial receipts exist. Register new receipts or send billing for the balance.',
          paidUnconfirmed:
            'The customer has already paid in the source system. Awaiting bank reconciliation to ' +
            'confirm the payment — do not send billing.',
          partiallyReceived:
            'Some installments have been settled by the acquirer; the rest arrive on their ' +
            'scheduled dates. The customer owes nothing — do not send billing or start dunning.',
          paid: 'Invoice fully paid. No pending actions.',
          settledAwaitingFiscal:
            'Revenue recognized and provisioned — awaiting the deposit bank reconciliation and the consolidated CFDI.',
          settledComplete: 'Settled with fiscal document issued. No pending actions.',
          void: 'Invoice voided.',
          migrated:
            'Record migrated from the previous system. Informational only: no GL posting, ' +
            'no fiscal note and no billing from here.',
          default: 'Review the invoice status and complete the next workflow step.',
          sendBilling: 'Send billing',
          sendBillingQueued: 'Billing sent for boleto issuance.',
          sendBillingFailed: 'Could not send the billing. Try again.',
          registerReceipt: 'Register receipt',
          moreActions: 'More actions',
        },
        financialSummary: {
          title: 'Financial summary',
          gross: 'Gross amount',
          settledAtSource: 'Settled in the deposit',
          revenueTaxes: '(-) Taxes on revenue',
          settledAtSourceHint:
            'The amount already arrived netted in the partner deposit — there is nothing left to collect.',
          withholdings: '(-) Withholdings',
          toReceive: 'Amount to receive',
          received: 'Received',
          pending: 'Pending',
        },
        receipts: {
          addReceipt: 'Add receipt',
        },
      },
      amounts: {
        foreignCurrencyEmissionWarning:
          "This invoice is denominated in a foreign currency. When the fiscal document is issued, provisioned amounts will be recalculated at that day's exchange rate ({{authority}}).",
        fxAuthority: {
          BCB_PTAX: 'BCB PTAX',
          BANXICO_DOF: 'Banxico DOF FIX',
          FRB_H10: 'Federal Reserve H.10',
        },
        originalValue: 'Original amount',
        provisionedValue: 'Provisioned amount',
        provisionedIss: 'Provisioned ISS',
        provisionedIva: 'Provisioned IVA',
        recognizedRevenue: 'Recognized revenue',
        recognizedIss: 'Recognized ISS',
        recognizedIva: 'Recognized IVA',
        viewRecognizedRevenue: 'View recognized revenue',
        recognizedRevenueModalTitle: 'Recognized revenue',
        recognizedRevenueModalDescription:
          'The accounting basis posted for the recognition period, preserved with its original exchange rate.',
        gross: 'Gross amount',
        grossServices: 'Gross service amount',
        taxes: 'ISS (Not withheld)',
        withholdings: 'Withholdings',
        withholdingsSectionTitle: 'Withholdings at source — reduce the amount to receive',
        withholdingsTotal: 'Total withheld by the customer',
        nonRetainedSectionTitle: 'Non-retained taxes — do not affect the amount to receive',
        issCollectedByIssuer: 'collected by the issuer',
        issNonRetainedFootnote:
          'ISS is an issuer expense/obligation and is not deducted from the customer — therefore it is not included in the amount to receive.',
        ivaLabel: 'IVA',
        ivaCollectedByIssuer: 'transferred on the CFDI',
        ivaNonRetainedFootnote:
          'Transferred IVA is added to the amount to receive (the customer pays services + IVA) and later remitted to the SAT — so it is part of the total, as IVA payable.',
        settlementSectionTitle: 'Custodial — third-party funds in transit',
        repasseLabel: 'Payout to partners',
        repasseCollectedOnBehalf: 'collected on behalf of others',
        repasseFootnote:
          'Third-party money passing through us: booked as a liability until it is paid on, never as revenue.',
        gtvLabel: 'Gross transaction value (GTV)',
        grossRevenue: 'Gross revenue',
        revenueTaxesSectionTitle: 'Taxes on revenue',
        netRevenue: 'Net revenue',
        ivaRemittedFootnote:
          'Tax charged to the customer and remitted to the authority: it reduces gross revenue and is not ours.',
        gtvFootnote:
          'Everything that flows through us: our commission + taxes on it + the partner payout.',
        net: 'Net amount',
        netToReceive: 'Net amount to receive',
      },
      revenueTax: {
        title: 'Other revenue taxes provisioned',
        helper: "The company's taxes on this revenue. They do not change the invoice amount.",
        baseAndRate: 'Base {{base}} · rate {{rate}}',
        originalBaseAndRate: 'Original base {{base}} · rate {{rate}}',
        reversedDetail: 'provisioned {{provisioned}}, reversed {{reversed}}',
        reversalPendingDetail:
          'provisioned {{provisioned}}, reversed {{reversed}} (the reversal is not fully posted to the ledger yet)',
        openSetup: 'Open the revenue tax setup',
        export: {
          action: 'Review export evidence',
          title: 'Review export eligibility',
          description:
            'Bind immutable evidence to the exact journal and revenue account. Marking an account as export does not grant the tax treatment.',
          source: 'Revenue journal and account',
          sourceUnavailable: 'Revenue account identification unavailable',
          route: 'Proven legal route',
          document: 'Evidence document linked to the invoice',
          upload: 'Attach evidence PDF',
          receiptId: 'Canonical receipt',
          receiptWithoutNumber: 'Receipt without a number',
          fxEvidenceHint:
            'The receipt may be partially allocated. The typed PDF must support the complete operation and its ingress or conversion chain; the allocation alone does not grant the treatment.',
          paymentDate: 'Payment or proceeds date',
          paymentCurrency: 'Currency',
          paymentAmount: 'Amount',
          evidenceCode: 'Evidence code',
          evidenceDescription: 'Review description',
          commercialExporterUnsupported:
            'Sales to a commercial exporter are not supported yet. Do not select another route to bypass this limitation.',
          routes: {
            DIRECT_GOODS: 'Direct export of goods',
            SERVICE_FX_INGRESS: 'Service with foreign-exchange proceeds',
            SERVICE_FUNDS_RETAINED_ABROAD: 'Service with proceeds retained abroad',
          },
          preview: 'Review decision',
          confirm: 'Confirm eligibility',
          cancel: 'Cancel',
          close: 'Close',
          reviewTitle: 'Decision ready for confirmation',
          immutable: 'The decision is immutable and applies only to this journal and account.',
          rereview:
            'This review creates a new decision linked to the prior one. Approved history remains immutable.',
          boundSource:
            'Source {{sourceAmount}} across {{lineCount}} line(s); operation {{invoiceAmount}}.',
          saved: 'Eligibility saved and pending provisions reprocessed by the canonical engine.',
          evidenceInvalid:
            'The linked evidence was reversed or changed. This export cannot be reapproved or close the period. Link new valid evidence to the same source, review the decision, and refresh the assessment.',
          errors: {
            REVENUE_TAX_EXPORT_COMMERCIAL_EXPORTER_UNSUPPORTED:
              'Sales to a commercial exporter are unavailable in this slice.',
            REVENUE_TAX_EXPORT_DOCUMENT_REQUIRED:
              'Attach and select an active PDF linked to this invoice.',
            REVENUE_TAX_EXPORT_FOREIGN_CUSTOMER_REQUIRED:
              'The operation customer must have a valid foreign country.',
            REVENUE_TAX_EXPORT_GOODS_SOURCE_REQUIRED:
              'The direct-goods route requires an invoice containing identified goods only.',
            REVENUE_TAX_EXPORT_SERVICE_SOURCE_REQUIRED:
              'The service route requires an invoice containing identified services only.',
            REVENUE_TAX_EXPORT_MIXED_SOURCE_UNSUPPORTED:
              'The invoice mixes goods, services, or untyped items. Split or correct the source first.',
            REVENUE_TAX_EXPORT_PAYMENT_EVIDENCE_REQUIRED:
              'Enter the date, currency, and amount of payment or retained-proceeds evidence.',
            REVENUE_TAX_EXPORT_RECEIPT_REQUIRED:
              'Select a canonical receipt with a positive allocation to this invoice. The allocation may be partial; the typed PDF must support the export service operation as a whole and its ingress or conversion chain.',
            REVENUE_TAX_EXPORT_ELIGIBILITY_SOURCE_CHANGED:
              'The source changed after review. Reload and review it again.',
            REVENUE_TAX_EXPORT_ELIGIBILITY_ALREADY_REVIEWED:
              'The current evidence is still valid. A new decision can replace only canonically invalidated evidence.',
            REVENUE_TAX_EXPORT_SOURCE_PERIOD_OPEN_REQUIRED:
              'Reopen the source accounting period before confirming new evidence.',
            REVENUE_TAX_EXPORT_ELIGIBILITY_CHAIN_AMBIGUOUS:
              'This source has an inconsistent decision history. Correct the chain before reviewing it.',
            REVENUE_TAX_EXPORT_SOURCE_INVALID:
              'The invoice journal, account, or accounting link is invalid for this review.',
            REVENUE_TAX_EXPORT_SOURCE_CHANGED:
              'The entered facts do not form valid canonical evidence. Review the route and source.',
            unknown: 'The export review could not be completed.',
          },
        },
        transition: {
          action: 'Classify the 2027 transition',
          title: 'Classify the operation tax transition',
          description:
            'Record the legal treatment of this operation and the review evidence. Once saved, the classification cannot be changed.',
          source: 'Source',
          entity: 'Entity',
          books: 'Books',
          invoiceSource: 'Invoice {{number}}',
          currentEntity: 'Invoice issuing entity',
          treatment: 'Transition treatment',
          selectTreatment: 'Select without applying a default',
          evidenceCode: 'Evidence code',
          evidenceDescription: 'Evidence description',
          confirm: 'Save classification',
          cancel: 'Cancel',
          close: 'Close',
          saved: 'Classification saved for the entire operation.',
          classifiedAt: 'Classified on {{date}}.',
          immutable: 'Classification completed and locked for editing.',
          treatments: {
            ORDINARY_LEGACY_PIS_COFINS: 'PIS/COFINS under the legacy regime',
            OPTIONAL_REAL_ESTATE_CBS: 'Optional CBS for a real estate operation',
            NOT_ELIGIBLE: 'Operation not eligible for the transition',
          },
          errors: {
            REVENUE_TAX_TRANSITION_SOURCE_NOT_FOUND:
              'The provisions for this operation were not found.',
            REVENUE_TAX_TRANSITION_EVIDENCE_REQUIRED: 'Enter the evidence code and description.',
            REVENUE_TAX_TRANSITION_CLASSIFICATION_CONFLICT:
              'The operation provisions contain conflicting data. Review them before trying again.',
            REVENUE_TAX_TRANSITION_CLASSIFICATION_IMMUTABLE:
              'This operation has already been classified and cannot be changed.',
            REVENUE_TAX_TRANSITION_ASSESSMENT_EXISTS:
              'The operation is already included in a 2027 assessment and can no longer be classified.',
            REVENUE_TAX_TRANSITION_SOURCE_DATE_MISSING:
              'The original operation date was not found. Review the invoice, debit-note, or contract-recognition date.',
            REVENUE_TAX_TRANSITION_SOURCE_DATE_INVALID:
              'The date recorded on the invoice, debit note, or contract-recognition source is invalid. Correct the source before classifying.',
            REVENUE_TAX_TRANSITION_SOURCE_AFTER_CUTOFF:
              'The original operation is after December 31, 2026 and cannot use ordinary PIS/COFINS legacy treatment.',
            REVENUE_TAX_TRANSITION_SOURCE_EVIDENCE_MISSING:
              'The canonical invoice, debit-note, or contract-recognition source was not found or is unsupported for this transition.',
            unknown: 'The classification could not be saved. Try again.',
          },
        },
        status: {
          pending: 'Pending',
          reversed: 'Reversed',
          reversalPending: 'Reversal pending',
          partlyReversed: 'Partly reversed',
        },
      },
      classification: {
        revenueAccount: 'Revenue account',
        costCenter: 'Cost center',
        department: 'Department',
        managerialAccount: 'Managerial account',
        segment: 'Segment',
        unclassifiedLine: 'Unclassified',
        lockedAfterPosting: 'Classification locked after GL posting',
        lockedFromContract:
          'Classification is set by the contract, from its billing services. To change it, adjust the service classification on the contract.',
        viewGlPostings: 'View GL journal lines',
        loadingGlPostings: 'Loading journal lines...',
        save: 'Save classification',
        saving: 'Saving...',
        saveSuccess: 'Classification saved successfully',
        saveError: 'Failed to save classification',
        modeChangeSuccess: 'Classification mode changed',
        modeChangeError: 'Failed to change classification mode',
        item: 'item',
        items: 'items',
        noLineItems: 'No line items on this invoice',
        reclassify: 'Modify classification',
        reclassifyConfirm:
          'Existing journal entries will be reversed and the invoice will be re-posted with the new classification.',
        reclassifyReviewFallback: 'An accounting review request will be created.',
        reclassifyBanner: 'Modify classifications and confirm to re-post to the ledger',
        reclassifySuccess: 'Classification updated and re-posted to GL',
        reclassifyError: 'Failed to reclassify invoice',
        confirmReclassify: 'Confirm reclassification',
        cancel: 'Cancel',
        selectPeriod: 'Reversal period',
        loadingPeriods: 'Loading periods...',
        mode: {
          billLevel: 'Invoice',
          lineItem: 'Line item',
          custom: 'Custom',
        },
      },
      source: {
        externalRef: 'External Reference',
        cfdiConsolidatedTitle: 'Fiscal document — consolidated CFDI',
        cfdiFromGrouping:
          'Issued by the consolidated fiscal grouping (aggregated CFDI), not per invoice.',
        cfdiIssued: 'Consolidated CFDI issued and linked to this invoice.',
        attachedDocuments: 'Attached Documents',
        noDocuments: 'No documents attached',
        noFiscalNote: 'Invoice without linked NF',
        noFiscalNoteDescription: 'No fiscal note has been received or issued for this invoice.',
        documentPdf: '{{type}} — PDF',
        openDocument: 'Open',
        openInNewTab: 'New tab',
        download: 'Download',
        previewDocument: 'Preview document',
        documentNumber: 'NFS-e',
        cfdiFolio: 'Folio',
        consolidatedCount: 'Covers {{count}} invoices from this period',
        series: 'Series',
        rpsNumber: 'RPS',
        rpsSeries: 'RPS series',
        accessKey: 'Key',
        pdfUnavailable: 'PDF unavailable',
        attachEmitted: 'Attach emitted NF',
        attachEmittedTitle: 'NF emitted outside the system',
        attachEmittedDescription: 'Upload the XML or PDF of the issued invoice.',
        clearUploaded: 'Clear attached fiscal note',
        clearUploadedDialogTitle: 'Clear the attached fiscal note?',
        clearUploadedDialogDescription:
          'The fiscal note and its files will be removed. Invoice amounts, currency, and dates will not change.',
        clearUploadedCancel: 'Cancel',
        clearUploadedConfirm: 'Clear fiscal note',
        clearingUploaded: 'Clearing...',
        clearUploadedSuccess: 'Attached fiscal note removed successfully.',
        clearUploadedRefreshWarning:
          'The fiscal note was removed, but the page data did not refresh. Refresh the page.',
        clearUploadedError: 'Could not clear the attached fiscal note.',
        retryClearUploaded: 'Try again',
        close: 'Close',
      },
      lineItems: {
        product: 'Product/Service',
        service: 'Service',
        servicePlaceholder: 'Select service',
        description: 'Description',
        descriptionPlaceholder: 'Line item description',
        editDescription: 'Edit description',
        clickToEditDescription: 'Click to edit',
        saveDescription: 'Save',
        cancelDescription: 'Cancel',
        quantity: 'Qty',
        unitPrice: 'Unit Price',
        total: 'Total',
        subtotal: 'Subtotal',
        taxes: 'Taxes',
        invoiceTotal: 'Invoice Total',
      },
      receipts: {
        noReceipts: 'No receipts recorded for this invoice.',
        date: 'Date',
        method: 'Method',
        amount: 'Amount',
        allocated: 'Allocated',
        reference: 'Ref',
      },
      timeline: {
        invoiceIssued: 'Invoice issued',
        paymentReceived: 'Payment received',
        invoicePaid: 'Invoice paid',
      },
      withholdingTaxTypes: {
        IRRF: 'IRRF',
        PIS: 'PIS',
        COFINS: 'COFINS',
        CSLL: 'CSLL',
        INSS: 'INSS',
        ISS: 'ISS',
      },
    },
  },
  invoiceIssues: {
    title: 'Issues',
    filter: 'With issues',
    column: 'Issues',
    tagMore: '{{first}} +{{count}}',
    unknownIssue: 'Other issue',
    where: {
      line: 'Line {{n}}',
    },
    steps: {
      RECORD: 'Recording the invoice',
      APPROVE: 'Approval and ledger posting',
      NFSE: 'NFS-e issuance',
    },
    blocks: {
      RECORD: 'Blocks recording the invoice',
      APPROVE: 'Blocks approval',
      NFSE: 'Blocks NFS-e issuance',
    },
    codes: {
      SERVICE_NOT_MAPPED: {
        title: 'Service not registered',
        problem: 'A line of the invoice uses a service that is not registered.',
        fix: 'Register the service or pick an existing one on the line.',
      },
      REVENUE_ACCOUNT_MISSING: {
        title: 'Invoice not classified',
        problem: 'The invoice has no revenue account.',
        fix: 'Classify the invoice before approving it.',
      },
      GL_PERIOD_CLOSED: {
        title: 'Accounting period closed',
        problem:
          'The accounting period of the issue date is closed, so the revenue cannot be posted.',
        fix: 'Reopen the period or change the invoice issue date.',
      },
      CUSTOMER_TAX_ID_INVALID: {
        title: 'Customer CPF or CNPJ invalid',
        problem: "The customer's CPF or CNPJ is not valid, so the NFS-e cannot be issued.",
        fix: "Fix the CPF or CNPJ in the customer's record.",
      },
      CUSTOMER_TAX_ID_MISSING: {
        title: 'Customer CNPJ missing',
        problem: 'The customer is a company with no CNPJ, so the NFS-e cannot be issued.',
        fix: "Add the CNPJ to the customer's record.",
      },
      CUSTOMER_ADDRESS_INCOMPLETE: {
        title: 'Customer address incomplete',
        problem:
          "The customer's city and state do not match a Brazilian municipality, so the NFS-e cannot be issued.",
        fix: "Fix the city and state in the customer's address.",
      },
      SERVICE_FISCAL_CODE_MISSING: {
        title: 'Service has no fiscal code',
        problem: 'The service has no valid LC 116 service code, so the NFS-e cannot be issued.',
        fix: "Set the fiscal service type in the service's record.",
      },
    },
    panel: {
      intro: 'While issues are open, the invoice cannot be approved.',
      problemLabel: "What's wrong",
      blocksLabel: 'What it blocks',
      fixLabel: 'How to fix',
    },
    approve: {
      title: 'The invoice cannot be approved',
      description_one: 'Fix the open issue, then approve the invoice again.',
      description_other: 'Fix the {{count}} open issues, then approve the invoice again.',
      close: 'Close',
    },
    history: {
      events: {
        EXTERNAL_CREATED_WITH_ISSUES: 'Invoice received from the integration with issues',
        EXTERNAL_UPDATED: 'Invoice updated by the integration',
        CUSTOMER_CHANGED: 'Invoice customer changed by the integration',
        ISSUE_OPENED: 'Issue opened',
        ISSUE_RESOLVED: 'Issue resolved',
        AUTO_APPROVE_SKIPPED_OPEN_ISSUES: 'Automatic approval skipped',
        DRAFT_EDITED: 'Draft edited',
      },
      details: {
        autoApproveSkipped: 'The invoice has open issues: {{issues}}.',
        customerChanged: 'Customer {{old}} replaced by {{new}}',
        customerChangedNoCode: 'The invoice customer was replaced',
      },
      actors: {
        api: 'External integration',
        system: 'System',
      },
      changedTo: 'changed to',
      noValue: 'no value',
      unknownAccount: 'account not found',
      fields: {
        customerTaxId: 'Customer CPF or CNPJ',
        customerId: 'Customer',
        invoiceNumber: 'Invoice number',
        currency: 'Currency',
        issueDate: 'Issue date',
        dueDate: 'Due date',
        competencyDate: 'Competency date',
        managerialDate: 'Managerial date',
        description: 'Description',
        grossAmount: 'Gross amount',
        netAmount: 'Net amount',
        totalAmount: 'Total amount',
        subtotalAmount: 'Subtotal',
        taxTotalAmount: 'Total taxes',
        withholdingTotalAmount: 'Total withholdings',
        revenueGlAccountId: 'Revenue account',
        externalFiscalNoteNumber: 'External NF number',
        externalFiscalNoteIssueDate: 'External NF issue date',
        lineCount: 'Number of lines',
        installmentCount: 'Number of installments',
        line: 'Line {{n}}: {{field}}',
        lineFields: {
          amount: 'amount',
          description: 'description',
          serviceCode: 'service code',
          service: 'service',
        },
        installment: 'Installment {{n}}: {{field}}',
        installmentFields: {
          amount: 'amount',
          dueDate: 'due date',
        },
        withholding: '{{tax}} withholding',
        unknown: 'Other field',
      },
    },
  },
  approveErrors: {
    ownTaxOriginReversalExceedsAvailable:
      'The reversal exceeds the own-tax balance assessed for this invoice. Review the reversed amounts and try again.',
    ownTaxOriginAdjustmentUnsupported:
      'Adjustment lines cannot post to an assessed-tax account linked to this invoice. Reverse the matching original line instead.',
    ownTaxOriginReversalConflict:
      'The own-tax balance of this invoice changed during the reversal (for example, a tax guide was reversed at the same time). Reload the invoice and try again.',
    originAllocationMoveConflict:
      'The tax of this invoice changed while the reclassification moved the guide payment to the new posting (for example, a tax guide was approved or reversed at the same time). Reload the invoice and try again.',
    taxAccountNotMapped:
      'To approve, configure tax account mappings in the chart of accounts for the posting period.',
    taxAccountSlotNotFound:
      'Tax account is not configured. Check tax account mappings in settings.',
    noOpenPeriod:
      'No open accounting period found for the invoice/fiscal note issue date. Open that period and try again.',
    proposedBoletoCancelPending:
      'Wait for the previous boletos to be cancelled before approving or issuing this invoice again.',
    invoiceCannotBeIssued: 'This invoice cannot be approved in its current status.',
    billingServiceRequired: 'Link a billing service to the invoice before approving it.',
    focusNfeNotConfigured:
      'FocusNFe is not configured for the entity. Check the token and restart the API after changing the environment.',
    fiscalParametersRequired: 'Required fiscal parameters are missing: {{reason}}',
    fiscalAmountsMismatch:
      'The invoice fiscal amounts differ from the current calculation. Recalculate taxes and try again.',
    nfseValidationFailed: 'NFSe validation failed: {{reason}}',
    contractAssetCarrierMismatch:
      'The Contract Asset FX exposure points to a different account than the one recognition debited. Review the contract ledger before approving the invoice.',
    contractAssetCarrierReliefUnresolved:
      'What the Contract Asset accounts still carry, net of earlier invoices, does not cover this invoice. Review the contract ledger before approving the invoice.',
    contractAssetReliefEntityMismatch:
      'The invoice, the contract and the Contract Asset entry belong to different entities. Check the invoice and contract entity before approving.',
    issOwnTaxLegAmbiguous:
      'The ISS Apurado account receives more than one credit in this entry and none matches the own ISS of the note. Use an ISS Apurado account dedicated to ISS on the Revenue Tax rail.',
    customerAdvanceUnmapped:
      'This document covers a contract cycle that was already billed and must be booked as a customer advance, but the customer advance system account is not mapped. Map the customer advance account and try again.',
    settlementAdvanceCycleBilledConcurrently:
      'Another document billed this contract cycle while the settlement was being recognized. Try approving again.',
    goToTaxMapping: 'Go to mapping',
    goToPeriods: 'Go to accounting periods',
  },
  preBilling: {
    title: 'Pre-Billing',
    subtitle: 'Review and approve draft invoices before issuing',
    newInvoice: {
      action: 'New invoice',
      title: 'New invoice',
      description: 'Fill in the details to create a draft invoice in pre-billing.',
      cancel: 'Cancel',
      createDraft: 'Create as draft',
      creating: 'Creating...',
      success: 'Draft invoice created',
      updated: 'Existing draft updated',
      validation: {
        requiredFields: 'Fill in the required fields',
        entityRequired: 'Select an entity',
        entityCnpjRequired: 'The selected entity needs a CNPJ',
        customerRequired: 'Select a customer',
        customerIdentityRequired: 'The customer needs a CNPJ/CPF or code',
        customerEntityMismatch: 'The selected customer does not belong to this entity',
        amountRequired: 'Enter an amount greater than zero',
        netExceedsGross: 'The net amount cannot be greater than the gross amount',
        withholdingBreakdownMissing:
          'Net amount must equal gross minus the supplied withholdings. Leave net blank to calculate it from the billing service.',
        issOutOfRange: 'Own ISS must be between zero and the gross amount',
        issueDateRequired: 'Enter the issue date',
        serviceRequired: 'Select a service',
        amountInvalid: 'Enter a valid amount',
      },
      errors: {
        createError: 'Error creating invoice: {{message}}',
        networkError: 'Connection error. Try again.',
        serverError: 'Internal error while creating the invoice.',
        currencyUnconfigured: 'The entity has no functional currency configured for this invoice.',
        currencyDivergent: 'The entity books do not share one functional currency.',
        currencyUnsupported: 'The entity functional currency cannot be stored on an invoice.',
        enrichmentFailed: 'The CNPJ could not be looked up at the federal revenue service.',
        invalidTaxId: 'The customer CNPJ or CPF is invalid.',
      },
      form: {
        entity: 'Entity',
        customer: 'Customer',
        customerPlaceholder: 'Select a customer...',
        value: 'Gross amount',
        currency: 'Currency',
        currencyHint: 'When left blank, the invoice uses the entity functional currency.',
        issueDate: 'Issue date',
        competencyDate: 'Competency',
        managerialDate: 'Managerial date',
        dueDate: 'Due date',
        invoiceNumber: 'Invoice number',
        invoiceNumberPlaceholder: 'Optional',
        description: 'Description',
        descriptionPlaceholder: 'E.g. Accounting services - Jun/2026',
        service: 'Service',
        servicePlaceholder: 'Select a service',
        selectPlaceholder: 'Select',
        taxes: 'Taxes',
        taxesHint:
          'Leave blank to calculate the net amount and withholdings from the service, as the CSV import does.',
        netAmount: 'Net amount',
        irrf: 'IRRF',
        inss: 'INSS',
        pisRetido: 'Withheld PIS',
        cofinsRetido: 'Withheld COFINS',
        csllRetido: 'Withheld CSLL',
        issRetido: 'Withheld ISS',
        issProprio: 'Own ISS',
        noServices: 'No active services for this entity.',
        loadingServices: 'Loading services...',
      },
    },
    batchJobs: {
      title: 'Processing',
      description: 'Track imports and approvals in progress.',
      historyTitle: 'Processing history',
      historyDescription: 'Review previous imports and approvals.',
      viewHistory: 'View processing history',
      hideHistory: 'Hide processing history',
      loading: 'Loading batches…',
      empty: 'No recently processed batches.',
      loadError: 'The batch history could not be loaded.',
      details: 'Batch details',
      file: 'File',
      type: 'Type',
      createdAt: 'Created at',
      progress: 'Progress',
      result: 'Result',
      errors: 'Errors',
      attempts: 'Attempts',
      sourceRow: 'Row',
      sourceId: 'Source ID',
      stage: 'Stage',
      updatedAt: 'Updated at',
      allItems: 'All items',
      failedItems: 'Errors only',
      viewItems: 'View',
      filterItems: 'Filter batch items',
      noItems: 'No items on this page.',
      succeeded: '{{count}} completed',
      failed: '{{count}} failed',
      processed: '{{processed}} of {{total}} processed',
      invoicesIssuing: 'Invoices being issued: {{queued}}/{{total}}',
      retryFailed: 'Retry failed items',
      approveImport: 'Approve invoices from this batch',
      retryTitle: 'Retry failed items?',
      retryDescription:
        'A new attempt will be created only for failed items. Previous attempt history is preserved.',
      approveTitle: 'Approve all imported invoices?',
      approveDescription:
        'This batch membership will be frozen and valid invoices will enter the normal approval and emission workflow.',
      accepted: 'Request accepted as batch {{jobId}}.',
      acceptedTitle: 'Request accepted',
      viewAcceptedJob: 'Track batch',
      actionError: 'The request could not be started.',
      processingAction: 'Safely recording the request…',
      idempotencyCleanupError:
        'The request was accepted, but the browser could not clear its local key. Check history before trying again.',
      close: 'Close',
      cancel: 'Cancel',
      confirm: 'Confirm',
      previous: 'Previous',
      next: 'Next',
      page: 'Page {{page}} of {{totalPages}}',
      status: {
        PENDING: 'Pending',
        PROCESSING: 'Processing',
        COMPLETED: 'Completed',
        PARTIAL: 'Partial',
        FAILED: 'Failed',
        CANCELLED: 'Cancelled',
        SUCCEEDED: 'Completed',
        RETRY_SCHEDULED: 'Retry scheduled',
      },
      types: {
        AR_PRE_BILLING_IMPORT: 'Import',
        AR_PRE_BILLING_APPROVAL: 'Approval and emission',
      },
      stages: {
        IMPORT: 'Import',
        APPROVAL: 'Approval',
        EMISSION: 'Emission',
        POSTING: 'Posting',
      },
    },
    stats: {
      totalDrafts: 'In pre-billing',
      withFiscalNote: 'With fiscal note',
      missingRevenueAccount: 'Missing revenue account',
      overdue: 'Overdue',
    },
    summary: {
      totalAmount: 'Total amount',
      grossNetHint: 'gross / net',
      grossAmount: 'Gross amount',
      grossFooter: '{{invoiceCount}} invoices · {{clientCount}} clients',
      withholdingAmount: 'Withholdings at source',
      withholdingFooter: '{{percent}}% of gross',
      withholdingShare: '{{percent}} of gross',
      showByCustomer: 'View by customer',
      loadError: 'Could not load the totals.',
      netAmount: 'Net amount',
      netFooter: 'receivable from clients',
      clientCount: 'Clients',
      invoiceCount: 'Invoices',
      clientsDialogTitle: 'Totals by client',
      invoicesColumn: 'Invoices',
    },
    filters: {
      title: 'Filters',
      search: 'Search',
      searchPlaceholder: 'Customer, invoice number, description...',
      minAmount: 'Min amount',
      maxAmount: 'Max amount',
      issueDateFrom: 'Issue from',
      issueDateTo: 'Issue to',
      unclassifiedOnly: 'Invoices without classification',
      sourceGroupExclude: 'Exclude source group',
      clearAll: 'Clear all',
      activeFilters: 'Active filters:',
      apply: 'Apply',
      customerPlaceholder: 'Select customers',
      invoicePlaceholder: 'Filter by invoice...',
      descriptionPlaceholder: 'Filter by description...',
      amountPlaceholder: 'Amount',
      dueDatePlaceholder: 'Due date range',
      invoiceIssueDatePlaceholder: 'Invoice issue date range',
      fiscalNoteIssueDatePlaceholder: 'Fiscal note issue date range',
      fiscalNoteAll: 'All',
      fiscalNoteWith: 'With FN',
      fiscalNoteWithout: 'Without FN',
      glPostingAll: 'All',
      glPostingPosted: 'Posted',
      glPostingNotPosted: 'Not posted',
      minCharsHint: 'Minimum {{count}} characters.',
      amountOperators: {
        eq: 'Equal',
        gte: 'Greater or equal',
        lte: 'Less or equal',
        eqSymbol: '=',
        gteSymbol: '≥',
        lteSymbol: '≤',
      },
    },
    table: {
      customer: 'Customer',
      customerCode: 'Customer code',
      customerTaxId: 'Tax ID',
      entityName: 'Entity',
      invoice: 'Invoice',
      externalRef: 'External reference',
      status: 'Status',
      description: 'Description',
      grossAmount: 'Gross amount',
      amount: 'Net amount',
      withholding: 'Withholdings',
      currency: 'Currency',
      sourceGroup: 'Source group',
      dueDate: 'Due date',
      expectedCashDate: 'Expected cash',
      competencyDate: 'Competency',
      managerialDate: 'Managerial date',
      invoiceIssueDate: 'Invoice issue date',
      fiscalNoteIssueDate: 'NF issue date',
      fiscalNoteNumber: 'NF number',
      revenueAccount: 'GL account',
      revenueGlAccountName: 'GL account (name)',
      fiscalNote: 'FN',
      glPosting: 'Posted to ledger',
      externalFiscalNote: 'External NF',
      actions: 'Actions',
      noResults: 'No pre-billing invoices found.',
      loading: 'Loading pre-billing invoices...',
      hasFiscalNote: 'Fiscal note linked',
      noFiscalNote: 'No FN',
      missingFiscalNoteAlert: 'No FN',
      fiscalPending: 'Fiscal pending',
      glPosted: 'Yes',
      glNotPosted: 'No',
      sortAsc: 'ascending',
      sortDesc: 'descending',
      sortBy: 'Sort by {{field}}{{direction}}',
      sortTooltip: 'Click to sort. Shift+click for secondary sort.',
      filterColumnTooltip: 'Click to filter by this column',
      filterCustomerTooltip: 'Click to filter customers',
      groupSummary: '{{count}} invoices · gross {{gross}} · net {{net}}',
      groupInvoiceCount: '{{count}} invoices',
      groupGrossLabel: 'gross',
      groupNetLabel: 'net',
      collapseGroup: 'Collapse invoices for {{label}}',
      expandGroup: 'Expand invoices for {{label}}',
      selectGroupInvoices: 'Select invoices for {{label}}',
      selectCustomerInvoices: 'Select invoices for {{customer}}',
      dueInDays: '{{count}} days',
      dueOverdue: '{{count}} days overdue',
      dueToday: 'due today',
      settledByRetention: 'Settled by retention',
      aggregate: 'Aggregate',
      aggregatePeriod: 'Aggregate · {{period}}',
      paid: 'Paid',
      paidOn: 'Paid on {{date}}',
    },
    density: {
      decrease: 'Decrease table size',
      increase: 'Increase table size',
    },
    groups: {
      expandAll: 'Expand all',
      collapseAll: 'Collapse all',
      groupByLabel: 'Group by',
      noDueDate: 'No due date',
      noIssueDate: 'No issue date',
      noService: 'No service',
      noPropertyGroup: 'No property group',
      propertyGroup: 'Group {{id}}',
      propertyGroupIdOnly: 'ID only (the feed carries no name)',
      gross: 'gross',
      net: 'net',
      invoice_one: 'invoice',
      invoice_other: 'invoices',
      by: {
        customer: 'Customer',
        dueDate: 'Due date',
        issueDate: 'Issue date',
        service: 'Service',
        propertyGroup: 'Property group',
        none: 'No grouping',
      },
    },
    columns: {
      aria: 'Table columns',
      title: 'Columns',
      defaultsHint: 'Check or uncheck columns to show in the table.',
      reorderHint: 'Drag the handle to reorder columns in the table.',
      resetOrder: 'Reset column order',
      dragHandleAria: 'Reorder column',
      dataType: {
        date: 'Date',
        text: 'Text',
        status: 'Status',
        currency: 'Amount',
        classification: 'Classification',
        boolean: 'Yes/No',
        actions: 'Actions',
      },
    },
    actions: {
      openDetails: 'Edit details',
      openInvoiceDetails: 'Details',
      rowMenu: 'Actions for {{number}}',
      reconciliation: 'See reconciliation',
      cancelInvoice: 'Cancel invoice',
      approve: 'Approve',
      approveAllDrafts: 'Approve all drafts',
      blockedApproveHint: 'Blocked invoice. Fix the issue in its details before approving again.',
      classificationRequiredHint:
        'Classify this invoice for accounting before approving or issuing its fiscal note.',
      approveSelected: 'Approve selected',
      delete: 'Delete',
      deleteSelected: 'Delete selected',
      classifyMenu: 'Classify',
      bulkActions: 'Bulk actions',
      postToGl: 'Post to Ledger',
      postingToGl: 'Posting...',
      bill: 'Bill',
      billAndPost: 'Bill and Post',
      billing: 'Billing...',
      classifySelected: 'Classify selected',
      classifyAll: 'Classify all as...',
      overwriteRevenueAccount: 'Overwrite existing accounts',
      linkServiceMenu: 'Link service',
      selectService: 'Select service',
      overwriteService: 'Overwrite existing services',
      linkServiceSelected: 'Link selected',
      dueDateMenu: 'Due date',
      dueDateSelected: 'Update due date for selected',
      cancel: 'Cancel',
      canceling: 'Canceling...',
      saving: 'Saving...',
      approving: 'Approving...',
      generatingNfse: 'Generating NFS',
      deleting: 'Deleting...',
      bulk: {
        countBadge: '{{count}} invoices',
        back: 'Back',
        classifyTitle: 'Classify account',
        classifyDescription: 'Assign a chart of accounts entry',
        classifyBlockedDescription: 'No selected invoices are eligible for classification.',
        classifyAccountLabel: 'GL account',
        classifyConfirm: 'Classify {{count}}',
        overwriteRevenueAccountHint: 'Replaces classifications already made in the batch',
        linkServiceTitle: 'Link service',
        linkServiceDescription: 'Associate with a registered service',
        serviceLabel: 'Service',
        linkServiceConfirm: 'Link {{count}}',
        overwriteServiceHint: 'Replaces links already made in the batch',
        dueDateTitle: 'Change due date',
        dueDateDescription: 'Set a new date for the batch',
        dueDateLabel: 'New due date',
        dueDateHint: 'Applies the same date to all invoices in the batch.',
        dueDateConfirm: 'Change {{count}}',
        managementDatesTitle: 'Change management dates',
        managementDatesDescription: 'Set competency and/or managerial date',
        competencyDateLabel: 'Competency',
        managerialDateLabel: 'Managerial date',
        managementDatesHint: 'Fill at least one field. Only provided fields will be updated.',
        managementDatesConfirm: 'Change {{count}}',
        recalculateTaxesTitle: 'Recalculate taxes',
        recalculateTaxesDescription: 'Update taxes using the current fiscal configuration',
        recalculateTaxesHint:
          'Fiscal amounts and installments for eligible invoices will be recalculated and recorded in history.',
        recalculateTaxesConfirm: 'Recalculate {{count}}',
        billTitle: 'Bill',
        billDescription: 'Generate invoice for selected accounts',
        cancelTitle: 'Cancel invoices',
        cancelDescription: 'Void the selected that can still be cancelled',
        billBlockedDescription: 'No selected invoices are eligible for billing.',
        clearUploadedFiscalNoteTitle: 'Clear attached fiscal note',
        clearUploadedFiscalNoteDescription: 'Remove the uploaded note from {{count}} invoice(s)',
        deleteTitle: 'Delete',
        deleteDescription: 'Remove selected accounts',
        cancelBlockedDescription: 'None of the selected invoices can be cancelled.',
      },
    },
    import: {
      processingHint: 'Please wait while invoices are being imported.',
    },
    views: {
      label: 'Pre-billing views',
      all: 'All',
      drafts: 'Drafts',
      awaitingNf: 'Awaiting NF',
      blocked: 'Blocked',
      issuedUnposted: 'Issued, not posted',
    },
    dialogs: {
      approveAllDraftsTitle: 'Approve all drafts?',
      approveAllDraftsCount: '{{count}} of {{total}} drafts',
      approveAllDraftsStale_one: '{{count}} stale draft needs a review',
      approveAllDraftsStale_other: '{{count}} stale drafts need a review',
      approveAllDraftsOther_one: '{{count}} stays out (an aggregate or already posted)',
      approveAllDraftsOther_other: '{{count}} stay out (aggregates or already posted)',
      approveSkipped: '{{skipped}} of {{total}} selected stay out: {{reasons}}.',
      skipAggregate: 'aggregate (approved in its own dialog)',
      skipPosted: 'already posted',
      skipUnclassified: 'no account classification',
      skipStatus: 'a status that is not approved',
      back: 'Back',
      emitNfseTitle: 'Issue the NFS-e?',
      emitNfseDescription:
        'The NFS-e of {{count}} invoice(s) will be sent to the city hall. An issued note is only undone by cancelling it.',
      emitNfseConfirm: 'Issue',
      rowApproveTitle: 'Approve this invoice?',
      rowDeleteTitle: 'Delete this invoice?',
      rowDeleteDescription:
        'The invoice will be deleted from pre-billing. This action cannot be undone.',
      rowCancelTitle: 'Cancel this invoice?',
      approveAllDraftsChanged:
        'The queue changed since this confirmation opened. Check the new count and approve again.',
      approveAllDraftsDescription:
        '{{count}} draft invoices will be queued for approval, NFS-e issuance, and ledger posting. Processing continues in the background; track results and errors in the batch.',
      approveClassificationRequired:
        '{{count}} invoice(s) have no accounting classification. Classify them before approving the batch.',
      approveClassificationUnknown:
        'The invoices without an accounting classification could not be checked. Close and try again.',
      approveTitle: 'Approve selected invoices?',
      approveDescription:
        'The fiscal note will be sent for emission and, after authorization, the invoice will be posted to the ledger.',
      approveDescriptionPlural:
        '{{count}} invoices will have their fiscal note sent for emission and, after authorization, will be posted to the ledger.',
      // A selection that holds a cycle other than Padrão: each invoice gets its NF the way its
      // cycle says, so the dialog does not promise an emission at approval.
      approveDescriptionByCycle:
        'The invoice is posted to the ledger, and its fiscal note follows its revenue cycle: sent for emission now, after the payment, or issued outside Alchemy ERP.',
      approveDescriptionByCyclePlural:
        '{{count}} invoices will be posted to the ledger. Each fiscal note follows its invoice revenue cycle: sent for emission now, after the payment, or issued outside Alchemy ERP.',
      deleteTitle: 'Delete selected invoices?',
      deleteDescription:
        'Selected invoices will be removed from pre-billing. This action cannot be undone.',
      cancelTitle: 'Cancel selected invoices?',
      cancelDescription: 'The invoice will be voided and can no longer be approved or edited.',
      cancelDescriptionPlural:
        '{{count}} invoices will be voided and can no longer be approved or edited.',
      clearUploadedFiscalNoteTitle: 'Clear attached fiscal notes?',
      clearUploadedFiscalNoteDescription:
        'The uploaded fiscal note will be removed from {{count}} invoice(s). Invoice amounts, currency, and dates will not change.',
      clearUploadedFiscalNoteFailureItem: 'Invoice {{invoiceId}}: {{error}}',
      confirm: 'Confirm',
      cancel: 'Cancel',
      retry: 'Try again',
      close: 'Close',
    },
    toasts: {
      updateSuccess: 'Invoice updated successfully.',
      updateError: 'Could not update invoice.',
      revenueAccountUpdated: 'Revenue account updated successfully.',
      revenueAccountError: 'Could not update revenue account.',
      revenueAccountRequired: 'Select a revenue account.',
      revenueAccountNoEligible: 'No eligible invoices to classify.',
      revenueAccountBatchSuccess: '{{count}} invoice(s) classified successfully.',
      revenueAccountPartial:
        '{{success}} classified, {{failed}} failed. Please review failed items.',
      revenueAccountBatchError: 'Could not classify invoices.',
      serviceRequired: 'Select a service.',
      serviceNoEligible: 'No eligible invoices to link service.',
      serviceBatchSuccess: '{{count}} invoice(s) linked to the service successfully.',
      servicePartial: '{{success}} linked, {{failed}} failed. Please review failed items.',
      serviceBatchError: 'Could not link service to invoices.',
      dueDateRequired: 'Select a due date.',
      dueDateNoEligible: 'No draft invoices selected to update due date.',
      dueDateBatchSuccess: '{{count}} invoice(s) due date updated successfully.',
      dueDatePartial: '{{success}} updated, {{failed}} failed. Please review failed items.',
      dueDateBatchError: 'Could not update invoice due dates.',
      managementDatesRequired: 'Enter at least competency or managerial date.',
      managementDatesNoEligible: 'No draft invoices selected to update management dates.',
      managementDatesBatchSuccess: '{{count}} invoice(s) management dates updated successfully.',
      managementDatesPartial: '{{success}} updated, {{failed}} failed. Please review failed items.',
      managementDatesBatchError: 'Could not update invoice management dates.',
      recalculateTaxesNoEligible: 'No draft invoices selected for tax recalculation.',
      recalculateTaxesBatchSuccess: '{{count}} invoice(s) recalculated successfully.',
      recalculateTaxesPartial:
        '{{success}} recalculated, {{failed}} failed. Please review failed items.',
      recalculateTaxesBatchError: 'Could not recalculate invoice taxes.',
      recalculateTaxesBatchLimit: 'Select at most {{max}} invoices per tax recalculation batch.',
      recalculateTaxesFailureItem: 'Invoice {{invoiceId}}: {{reason}}',
      recalculateTaxesUnknownError: 'Unknown tax recalculation error.',
      clearUploadedFiscalNoteSuccess: 'Fiscal note removed from {{count}} invoice(s).',
      clearUploadedFiscalNotePartial:
        'Fiscal note removed from {{success}} invoice(s); {{failed}} could not be changed.',
      clearUploadedFiscalNoteError: 'Could not clear the attached fiscal notes.',
      openInvoice: 'Open invoice',
      approveSuccess:
        'The fiscal note was sent for emission; after authorization, it will be posted to the ledger.',
      approveBatchSuccess:
        '{{count}} invoice(s) approved. Fiscal notes were sent for emission and will be posted to the ledger after authorization.',
      approveBatchPartial: '{{success}} approved, {{failed}} failed. Please review failed items.',
      approveBatchFailureReason: '{{count}} invoice(s) not approved: {{reason}}',
      approveError: 'Could not approve invoice.',
      postToGlSuccess: '{{count}} invoice(s) posted to GL.',
      postToGlPartial: '{{success}} posted, {{failed}} failed. Please review failed items.',
      postToGlPartialWithReason: '{{success}} posted, {{failed}} failed. {{reason}}',
      postToGlAllFailed: 'Could not post invoices to GL.',
      postToGlAllFailedWithReason: 'Could not post invoices to GL: {{reason}}',
      fiscalConfigRequiredForTaxProvisioning:
        'Entity fiscal config is required for tax provisioning. Configure it and try again.',
      goToFiscalSettings: 'Go to fiscal settings',
      glPostingReasons: {
        invoiceNotFound: 'Invoice not found.',
        invoiceAlreadyPosted: 'Invoice is already posted to GL.',
        missingRevenueAccount: 'Invoice has no revenue account configured.',
        missingEntity: 'Invoice has no linked entity.',
        missingCustomer: 'Invoice has no linked customer.',
        missingIssueDate: 'Invoice has no issue date.',
        invalidInvoiceAmount: 'Invoice must have a positive total amount.',
        invalidCustomerOffsetSettings: 'Customer offset account settings are invalid.',
        missingCustomerOffsetSettings:
          'Configure the customer receivable root account mapping in Settings → Accounting & Tax → Account Mapping (AR tab).',
        noOpenPeriod:
          'No open accounting period was found for the invoice/fiscal note issue date in any book. Open that period and try again.',
        entityWithoutBooks: 'Entity has no accounting books configured for posting.',
        invalidInvoiceStatus:
          'Invoice status must be Issued, Paid, or Partially Paid to post to GL.',
      },
      postToGlError: 'Could not post invoices to GL.',
      billSuccess: '{{count}} invoice(s) billed successfully.',
      billPartial: '{{success}} billed, {{failed}} failed. Please review failed items.',
      billError: 'Could not bill invoices.',
      cancelSuccess: '{{count}} invoice(s) cancelled successfully.',
      cancelPartial: '{{success}} cancelled, {{failed}} failed. Please review failed items.',
      cancelError: 'Could not cancel invoices.',
      deleteSuccess: 'Invoice deleted successfully.',
      deleteBatchSuccess: '{{count}} invoice(s) deleted successfully.',
      deleteError: 'Could not delete invoice.',
      importSuccess: '{{created}} created, {{updated}} updated.',
      importPartial:
        'Import finished with {{errors}} error(s). {{created}} created, {{updated}} updated.',
    },
    selection: {
      selected: '{{count}} invoice selected',
      selectedPlural: '{{count}} invoices selected',
      total: 'Selected total',
    },
    pagination: {
      showing: 'Showing {{start}}-{{end}} of {{total}}',
      noResults: 'No results',
      page: 'Page {{current}} of {{total}}',
      previous: 'Previous',
      next: 'Next',
      itemsPerPage: 'Items per page',
      itemsPerPageOption: '{{count}} / page',
    },
  },
  fiscalNoteUpload: {
    help: 'How to attach the invoice',
    verification: {
      processing: 'Checking details…',
      success: 'Details checked',
      failed: 'Could not check the details',
      back: 'Back',
      retry: 'Try again',
    },
    steps: {
      document: '1. Document',
      review: '2. Review',
      processing: 'Attaching',
      success: 'Complete',
      error: 'Could not attach',
      discard: 'Discard changes',
    },
    extraction: {
      processing: 'Reading the PDF…',
      ready: 'Details extracted',
      review: 'Review the fields before continuing.',
      failed: 'Could not read the PDF',
      retry: 'Read PDF again',
      warnings: {
        REVIEW_REQUIRED: 'Review the extracted details.',
        MISSING_FIELDS: 'Complete the unidentified fields.',
        LOW_CONFIDENCE: 'Some details need review.',
        ISSUER_MISMATCH: 'The issuer differs from the invoice entity.',
        RECIPIENT_MISMATCH: 'The recipient differs from the invoice customer.',
        WITHHOLDINGS_REQUIRE_REVIEW: 'Check the withholdings in the PDF.',
      },
    },
    lifecycle: {
      processing: 'Attaching the document and applying reviewed details…',
      success: 'Invoice {{number}} attached. The reviewed details were saved.',
      failed: 'The fiscal document could not be attached',
      errorDetails: 'Error code',
      close: 'Done',
      retry: 'Review and try again',
      refreshError:
        'The document was attached. Reload the invoice to refresh the displayed details.',
      discardTitle: 'Discard the reviewed details?',
      discardDescription:
        'The PDF and entered details have not been attached. Leaving will require entering them again.',
      discardConfirm: 'Discard and leave',
      keepEditing: 'Keep reviewing',
    },
    manual: {
      select: 'Select',
      xmlMode: 'Signed XML',
      pdfMode: 'PDF only',
      pdfRequired: 'Invoice PDF',
      reviewAction: 'Review details',
      warningTitle: 'Signature not verified',
      warning:
        'Check the key, parties, issue date, amount and every tax against the PDF. The digital signature and authority status will not be verified. An invalid XML will not be used in this upload.',
      reviewed: 'I reviewed the details and invoice status.',
      reviewHelp: 'What am I confirming?',
      reviewedDetails:
        'I checked the details and taxes against the PDF and confirm that the invoice was issued and has not been cancelled.',
      documentType: 'NFS-e type',
      national: 'National NFS-e',
      municipal: 'Municipal NFS-e',
      documentNumber: 'Invoice number',
      accessKey: 'Access key / identification',
      issueDate: 'Issue date',
      issuerTaxId: 'Issuer CNPJ',
      recipientTaxId: 'Recipient CPF/CNPJ',
      totalAmount: 'Gross amount',
      issScenario: 'ISS treatment',
      issAmount: 'ISS amount',
      irrfAmount: 'IRRF withheld',
      pisAmount: 'PIS withheld',
      cofinsAmount: 'COFINS withheld',
      csllAmount: 'CSLL withheld',
      inssAmount: 'INSS withheld',
      csrf: {
        label: 'CSRF withheld on the NFS-e',
        invoiceSum: 'Invoice PIS + COFINS + CSLL',
        pis: 'PIS',
        cofins: 'COFINS',
        csll: 'CSLL',
        confirmInvoiceBreakdown:
          'I confirm the NFS-e aggregate total matches and authorize using the invoice-calculated PIS, COFINS, and CSLL split.',
        matches: 'The NFS-e total matches the invoice fiscal breakdown.',
        mismatch:
          'The NFS-e total does not match the invoice. Correct the invoice fiscal configuration or attach the correct document.',
      },
      sourceLabel: 'Manually reviewed PDF · signature not verified',
      scenarios: {
        ISS_OWED: 'Own ISS',
        ISS_RETAINED: 'Withheld ISS',
        EXEMPT: 'Exempt / not taxable',
        SIMPLES: 'Simples Nacional',
      },
    },

    title: 'Attach emitted {{document}}',
    description:
      'The {{document}} must have been issued by this entity, to this customer and in the invoice currency. Upload its signed XML or PDF to extract the details. Review and correct the fields before attaching. If amounts differ, you can apply them to the invoice after reviewing the comparison.',
    document: {
      nfse: 'NFS-e',
      cfdi: 'CFDI',
    },
    fields: {
      xml: '{{document}} XML',
      xmlHint: 'Required. The digitally signed authorized XML downloaded from the portal or PAC.',
      pdf: 'PDF (optional)',
    },
    actions: {
      verify: 'Verify',
      back: 'Change file',
      attach: 'Attach',
      applyAmounts: 'Apply NFS-e amounts',
      cancel: 'Cancel',
    },
    preview: {
      title: 'Check before attaching',
      number: 'Number',
      issueDate: 'Issued',
      total: 'Amount',
      issuer: 'Issuer',
      recipient: 'Recipient',
      accessKey: 'Key',
      reuses:
        'This document already exists in the system (received by an integration). It will only be linked.',
    },
    amountConfirmation: {
      title: 'The amounts differ',
      description:
        'Confirming adjusts the invoice amounts, taxes, withholdings, lines, classifications and installments to the fiscal document.',
      invoice: 'Current invoice',
      document: 'Uploaded document',
      tax: 'Own ISS',
      withholding: 'Withholdings',
      net: 'Net',
    },
    toasts: {
      attached: 'Document {{number}} attached (issued {{issueDate}}). Approve the invoice to post.',
    },
    signatureErrors: {
      MALFORMED_XML:
        'The XML structure could not be read. Download the file again from the issuing portal and upload it without editing.',
      SIGNATURE_MISSING:
        'The XML has no digital signature. Download the authorized XML from the issuing portal.',
      CERTIFICATE_MISSING:
        'The XML signature does not include a valid certificate. Request the complete authorized XML from the issuer.',
      WEAK_ALGORITHM:
        'The XML signature uses an unsupported algorithm. Request an XML with a compatible signature from the issuer.',
      SIGNATURE_INVALID:
        'The digital signature does not match the XML content. Download the original file again and upload it without editing.',
      CERTIFICATE_EXPIRED:
        'The signing certificate is outside its validity period. Ask support to review the document.',
      CERTIFICATE_UNTRUSTED:
        'The certificate trust chain could not be validated. Ask support to check the ICP-Brasil configuration and the issuer certificate.',
      SIGNED_CONTENT_INCOMPLETE:
        'The signature does not cover all required NFS-e data. Ask support to review the original XML.',
    },
    errors: {
      generic: 'The document could not be attached. Try again.',
      invalidPdf: 'Select a valid PDF up to 5 MB.',
      AR_FISCAL_NOTE_PDF_EXTRACTION_FAILED: 'Could not read the PDF. Retry or fill in the details.',
      AR_FISCAL_NOTE_PDF_DOCUMENT_UNSUPPORTED: 'Select the PDF of an issued NFS-e.',
      AR_FISCAL_NOTE_UPLOAD_MANUAL_INVALID:
        'Provide a PDF and check the required fields, issue date, positive gross amount and taxes. Withholdings cannot exceed gross; exempt or Simples ISS must be zero.',
      AR_FISCAL_NOTE_UPLOAD_MANUAL_REVIEW_REQUIRED:
        'Confirm that all PDF details and taxes were reviewed before attaching.',
      AR_FISCAL_NOTE_UPLOAD_MANUAL_EXISTING_NOTE:
        'This key is already registered. Use the verified XML or link the existing note; manual PDF data cannot replace existing fiscal facts.',
      AR_FISCAL_NOTE_UPLOAD_INVALID_STATUS:
        'Only a draft or blocked invoice can take an attachment.',
      AR_FISCAL_NOTE_UPLOAD_ALREADY_HAS_NOTE:
        'This invoice already has an active fiscal document. Cancel or detach it before attaching another.',
      AR_FISCAL_NOTE_UPLOAD_COUNTRY_UNSUPPORTED:
        'Attaching an externally emitted document is available for Brazilian and Mexican entities only.',
      AR_FISCAL_NOTE_UPLOAD_XML_INVALID:
        'The signed content was not recognized as an NFS-e (São Paulo, Nacional or ABRASF) with key, date and amount. Check the file.',
      AR_FISCAL_NOTE_UPLOAD_UNSIGNED:
        'The XML digital signature or its trust chain could not be verified. Upload the authorized XML downloaded from the portal or PAC.',
      AR_FISCAL_NOTE_UPLOAD_ISSUER_MISMATCH:
        'The document was issued by {{issuerTaxId}}, which is not this invoice’s entity.',
      AR_FISCAL_NOTE_UPLOAD_RECIPIENT_MISMATCH:
        'The document was issued to {{recipientTaxId}}, which is not this invoice’s customer.',
      AR_FISCAL_NOTE_UPLOAD_CURRENCY_MISMATCH:
        'The document is in {{documentCurrency}} and the invoice in {{invoiceCurrency}}.',
      AR_FISCAL_NOTE_UPLOAD_TOTAL_MISMATCH:
        'The document amount ({{documentTotal}}) differs from the invoice amount ({{invoiceTotal}}). Fix the invoice or upload the right document.',
      AR_FISCAL_NOTE_UPLOAD_AMOUNT_CONFIRMATION_REQUIRED:
        'The document amounts differ. Review the comparison and explicitly apply them before attaching.',
      AR_FISCAL_NOTE_UPLOAD_ISS_MISMATCH:
        'The ISS declared on the document ({{documentIss}}) differs from the ISS computed for the invoice ({{invoiceIss}}). Recalculate the invoice taxes or upload the right document.',
      AR_FISCAL_NOTE_UPLOAD_TAX_MISMATCH:
        'The document’s IVA differs from the invoice tax total. Recalculate the taxes or upload the right document.',
      AR_FISCAL_NOTE_UPLOAD_FISCAL_PARAMETERS_MISSING:
        'The invoice is missing fiscal parameters (service, rate). Complete the fiscal data before attaching.',
      AR_FISCAL_NOTE_UPLOAD_ALREADY_LINKED: 'This document is already linked to another invoice.',
      AR_FISCAL_NOTE_UPLOAD_NOTE_CANCELLED:
        'This document is recorded as cancelled and cannot be attached.',
      AR_FISCAL_NOTE_UPLOAD_EMISSION_IN_PROGRESS:
        'An NFS-e emission is in progress ({{emissionStatus}}) for this invoice. Wait for it or cancel it before attaching.',
      AR_FISCAL_NOTE_UPLOAD_CONCURRENT_CHANGE:
        'The invoice changed while the document was being attached. Reload and try again.',
      AR_FISCAL_NOTE_UPLOAD_CFDI_NOT_INGRESO:
        'Only a CFDI de ingreso (type I) can be attached to a receivable.',
      AR_FISCAL_NOTE_UPLOAD_FILE_REQUIRED: 'Select the document XML.',
      AR_INVOICE_ISSUE_FISCAL_NOTE_MISMATCH:
        'The attached document no longer matches the invoice amount or currency. Attach the right document or fix the invoice before approving.',
    },
  },
  nfseEmission: {
    title: 'NFSe emission',
    currentStatus: 'Status',
    providerSubtitle: '{{mode}} · via FocusNFe',
    providerOnly: 'via FocusNFe',
    settingsHint: 'Configure the FocusNFe integration at',
    mode: {
      NACIONAL: 'National',
      MUNICIPAL: 'Municipal',
    },
    environment: {
      homologacao: 'Test environment',
      producao: 'Production',
    },
    status: {
      none: 'Not started',
      PENDING: 'Pending',
      PROCESSING: 'Processing',
      AUTHORIZED: 'Authorized',
      CANCELLING: 'Cancelling',
      ERROR: 'Error',
      CANCELLED: 'Cancelled',
    },
    actions: {
      emit: 'Emit NFSe',
      retry: 'Retry NFSe',
      openPdf: 'Open DANFSe',
      openSettings: 'FocusNFe settings',
    },
    errors: {
      title: 'Emission failed',
    },
    toasts: {
      enqueued: 'NFSe emission queued.',
      emitError: 'Could not request NFSe emission.',
      validationError: 'Fiscal data is incomplete for NFSe emission.',
      notConfigured: 'FocusNFe is not configured for this entity.',
      pdfError: 'Could not open the NFSe PDF.',
    },
  },
  nfseCancel: {
    title: 'Cancel NFSe',
    confirmTitle: 'Confirm administrative cancellation',
    retryTitle: 'Fix GL reversal',
    description:
      'Select the cancellation type, provide justification, and review the line-by-line GL reversal.',
    retryDescription:
      'The NFSe was already cancelled with the city hall. Adjust the reversal date and journal lines to finish cancellation.',
    justificativa: 'Justification (15 to 255 characters)',
    reversalDate: 'GL reversal date',
    defaultKeepIss: 'ISS kept by default',
    lineDebit: 'Debit {{amount}}',
    lineCredit: 'Credit {{amount}}',
    balanced: 'balanced',
    unbalanced: 'unbalanced',
    bookBalance: 'D {{debit}} / C {{credit}} — {{balanced}}',
    balanceDifference: 'Difference: {{amount}}',
    postingKindAccrual: 'Invoice posting',
    postingKindIssReclass: 'Provisioned ISS reclassification',
    reissueFullReversalNote:
      'On reissue the reversal is full, ISS included. The new note posts the new amount and its own ISS.',
    reissueRequiresFullReversal:
      'On reissue the GL reversal must be full: reverse every posting in full. To keep part of the amount, choose to void definitively.',
    reissueRequiresFullReversalRetry:
      'On reissue the GL reversal must be full. The lines already show the proposed full reversal: confirm to complete the cancellation.',
    postingKeptInFull:
      'No lines will be reversed — this posting survives the cancellation in full.',
    noGlReversal:
      'This invoice was not posted to the general ledger. Cancelling its NFSe requires no accounting reversal.',
    noGlReversalTitle: 'No accounting reversal needed',
    result: {
      processing: 'Submitting cancellation request…',
      requested: {
        title: 'Cancellation requested',
        description:
          'The municipality still needs to process the request. Follow its status on this invoice.',
      },
      confirmed: {
        title: 'Cancellation confirmed',
        description:
          'The NFSe and invoice were updated. You can review the result on the invoice page.',
      },
      error: { title: 'Could not complete cancellation' },
      close: 'Close',
    },
    adjustmentDescription: 'Manual reversal adjustment',
    cancellationStatus: 'Cancellation: {{status}}',
    fields: {
      account: 'Account',
      description: 'Description',
      debit: 'Debit',
      credit: 'Credit',
      actions: 'Actions',
    },
    cancelType: {
      label: 'Cancellation type',
      direct: 'Direct (within deadline)',
      administrative: 'Administrative (after deadline)',
    },
    postCancelAction: {
      label: 'Outcome after cancellation',
      revertToDraft: 'Revert to draft (edit and re-emit)',
      void: 'Void definitively',
    },
    actions: {
      openDialog: 'Cancel NFSe',
      submit: 'Request cancellation',
      confirmAdministrative: 'Confirm cancellation',
      retryGlReversal: 'Fix GL reversal',
      addAdjustment: 'Add adjustment',
      next: 'Next',
      back: 'Back',
      cancel: 'Cancel',
    },
    steps: {
      details: 'Cancellation',
      detailsDesc: 'Type, justification, and reversal date',
      reversal: 'GL reversal',
      reversalDesc: 'Review journal lines line by line',
    },
    status: {
      REQUESTED: 'Requested',
      PROCESSING: 'Processing',
      PENDING_ADMINISTRATIVE: 'Pending administrative confirmation',
      GL_REVERSAL_ERROR: 'GL reversal error',
      CONFIRMED: 'Confirmed',
      FAILED: 'Failed',
    },
    glReversalError: {
      title: 'NFSe cancelled — GL reversal pending',
      description:
        'The NFSe was cancelled with the city hall. Fix the GL reversal to complete cancellation.',
      reasonLabel: 'Reason:',
      bookSuffix: ' on book {{bookCode}}',
      reasons: {
        reversalDateBeforePosting:
          'The reversal date is before the original journal posting date ({{date}}){{bookSuffix}}.',
        noOpenPeriod:
          'There is no OPEN GL period for the reversal date{{bookSuffix}}. Open the period or choose another date.',
        insufficientLines: 'Each book reversal must contain at least two lines{{bookSuffix}}.',
        unbalanced: 'Reversal lines are not balanced{{bookSuffix}}.',
        noActivePosting: 'There is no active GL posting to reverse{{bookSuffix}}.',
        postingChanged:
          'Postings changed after the preview ({{activePostingCount}} active; {{requestedPostingCount}} submitted). Refresh the reversal preview. Active posting: {{activePostingId}}.',
        postingChangedUnknown: 'Postings changed after the preview. Refresh the reversal preview.',
        genericFinalizeFailure:
          'The GL reversal could not be posted automatically. Review the date and journal lines.',
        reissueRequiresFull:
          'The NFSe was cancelled for reissue, and a reissue requires a full GL reversal — the requested reversal was partial. Open “Fix GL reversal” and confirm the proposed full reversal to complete the cancellation.',
      },
    },
    validation: {
      required: 'Required field.',
      justificativa: 'Justification must be between 15 and 255 characters.',
      justificativaMax: 'Justification must be at most 255 characters.',
      formIncomplete: 'Fill in all required fields before continuing.',
      balance: 'Each book must have at least two lines and be balanced.',
      reversalDateBeforePosting:
        'Reversal date cannot be before the original journal posting date.',
    },
    tooltips: {
      cancelType:
        'Direct: cancellation within the municipal deadline, processed automatically with the city hall. Administrative: after the deadline; the request stays pending until manual confirmation when the city hall accepts it.',
      cancelTypeAria: 'Help for cancellation type',
      postCancelAction:
        'Revert to draft: the invoice returns to draft for editing and a new NFSe emission. Void definitively: the invoice is voided and cannot be re-emitted.',
      postCancelActionAria: 'Help for outcome after cancellation',
      reversalDate:
        'Date on which the GL reversal will be posted. It must be on or after the original posting date.',
      reversalDateAria: 'Help for GL reversal date',
      reversalDateRetry:
        'Adjust the reversal date. It must be on or after the original posting date and fall in an open GL period.',
      reversalDateRetryAria: 'Help for fixing the GL reversal date',
      justificativa:
        'Sent to the city hall via FocusNFe and recorded in the invoice history. Required for fiscal audit.',
      justificativaAria: 'Help for justification',
    },
    toasts: {
      previewError: 'Could not load reversal preview.',
      submitError: 'Could not request cancellation.',
      validationError: 'Review reversal lines before continuing.',
      requested: 'NFSe cancellation enqueued.',
      confirmed: 'Administrative cancellation confirmed and reversal posted.',
      retrySuccess: 'GL reversal posted and cancellation completed.',
    },
  },
};
